<template>
  <div class="settings mt-5">
    <b-container>
 
     <b-row>
       <b-col md="12">
         <b-card title="Settings" v-if="role_is_notmod" class="mb-4 bs">
           <b-card-text>
             Only the owner and moderators can access room settings.
           </b-card-text>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="$parent.currentUser.adm_acc" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1"
                variant="danger"
                v-b-toggle.room-admin>
                Admin Only
             </b-button>
           </b-card-header>
           <b-collapse id="room-admin" accordion="my-accordion" role="tabpanel"
              v-on:show="admin_ctrl_open">
             <b-card-body>
                <b-card-text style="padding:0 20px">

                  <b-row>
                    <b-col style="text-align:right;">
                       <span style="font-weight:bold;"
                         >
                         Primary Contact
                       </span>
                    </b-col>
                    <b-col>
                      <b-input
                        :style="admin_ctrl.o_uid?'':'border: solid 1px red;'"
                        v-model.trim="admin_ctrl.o_em"
                        v-on:keyup="admin_em_keyup"
                        v-on:change="admin_em_change"
                        placeholder="Email"
                        maxlength="100"
                      >
                      </b-input>
                    </b-col>
                    <b-col>
                      <b-input
                        style="display:inline-block"
                        v-model.trim="admin_ctrl.o_dname"
                        placeholder="Display Name"
                        maxlength="100"
                      >
                      </b-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="text-align:right;">
                       <span style="font-weight:bold;"
                         >
                         Hard Participant Limit
                       </span>
                    </b-col>
                    <b-col>
                      <b-input
                        style="display:inline-block;max-width:6rem;"
                        v-model.trim="admin_ctrl.joined_max"
                        placeholder="Maximum Count"
                        maxlength="6"
                      >
                      </b-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="text-align:right;">
                       <span style="font-weight:bold;"
                         >
                         Hard Viewing Limit
                       </span>
                    </b-col>
                    <b-col>
                      <b-input
                        style="display:inline-block;max-width:6rem;"
                        v-model.trim="admin_ctrl.viewed_max"
                        placeholder="Maximum Count"
                        maxlength="6"
                      >
                      </b-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="text-align:right;">
                       <span style="font-weight:bold;"
                         >
                         Hard Breakout Room Limit
                       </span>
                    </b-col>
                    <b-col>
                      <b-input
                        style="display:inline-block;max-width:6rem;"
                        v-model.trim="admin_ctrl.eph_limit"
                        placeholder="Maximum Count"
                        maxlength="6"
                      >
                      </b-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="text-align:right;">
                       <span style="font-weight:bold;"
                         >
                         Bad Email Count
                       </span>
                    </b-col>
                    <b-col>
                      <b-input
                        style="display:inline-block;max-width:6rem;"
                        v-model.trim="admin_ctrl.email_bad"
                        maxlength="6"
                      >
                      </b-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="admin_ctrl.enable_desk? 'outline-secondary':'vxon'"
                        @click="admin_ctrl.enable_desk = false">
                        Shared Desktop Disabled
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="admin_ctrl.enable_desk? 'vxon':'outline-secondary'"
                        @click="admin_ctrl.enable_desk = true">
                        Shared Desktop Enabled
                      </b-button>
                    </b-button-group>
                    </b-col>
                  </b-row>
               </b-card-text>

               <b-row>
                 <b-col>
                   <span style="font-size:0.8rem; color:red;">
                     {{admin_ctrl.err}}
                   </span>
                 </b-col>
               </b-row>
               <b-row>
                 <b-col>
                  <b-button size="sm"
                    :disabled="!admin_ctrl.o_uid"
                    @click="admin_ctrl_save"
                    variant="primary">
                     Save
                  </b-button>
                  <b-button size="sm"
                    class="float-right"
                    @click="admin_ctrl_cancel"
                    variant="outline-danger">
                      Cancel
                   </b-button>
                 </b-col>
               </b-row>

             </b-card-body>
           </b-collapse>
         </b-card>
        </b-col>
     </b-row>

     <b-row>
       <b-col v-if="role_is_mod">
          <div style="margin-top:0.5rem;width:100%;border-bottom: solid 2px black;text-align:center;font-size: 0.9rem; font-weight:bold;">
            Common Settings for @{{ titleInfo.room }}
          </div>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1 highlight" v-b-toggle.acc-access>
                Room Access ({{ctrl.can_view}})
             </b-button>
           </b-card-header>
           <b-collapse id="acc-access" accordion="my-accordion" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('access')"> ? </b-button>
             <b-card-body>
                <b-card-text  style="padding:20px">
                  <b-row>
                    <b-col md="12">
                      <p class="card-text">
                        <span>Who can access your room: </span>
                        <span style="color:#706030;font-size:0.9rem;font-weight:bold;text-decoration:underline;">{{ctrl_can_access_msg}}
                        </span>
                      </p>
                      <vue-slider
                        v-model="ctrl.can_view" @change="change_room_ctrl()"
                        :data="ctrl_values"
                        :marks="ctrl_marks"
                        :process="slider_process"
                        :tooltip="'none'"
                      ></vue-slider>
                    </b-col>
                  </b-row>
                </b-card-text>
        <!--
                <b-card-text  style="padding:20px">
                  <b-row>
                    <b-col md="12">
                      <p class="card-text">
                        Who can view your room: {{ ctrl_can_view_msg }}
                      </p>
                      <vue-slider
                        v-model="ctrl.can_view" @change="change_room_ctrl()"
                        :data="ctrl_values"
                        :marks="ctrl_marks"
                        :process="slider_process"
                        :tooltip="'none'"
                      ></vue-slider>
                    </b-col>
                  </b-row>
                </b-card-text>
                <b-card-text style="padding:20px">
                  <b-row>
                    <b-col md="12">
                      <p class="card-text">
                        Who can join your meeting: {{ ctrl_can_join_msg }}
                      </p>
                      <vue-slider
                        v-model="ctrl.can_join" @change="change_room_ctrl()"
                        :data="ctrl_values"
                        :marks="ctrl_marks"
                        :process="slider_process"
                        :tooltip="'none'"
                      ></vue-slider>
                    </b-col>
                  </b-row>
                </b-card-text>
          -->
                <b-card-text style="padding: 0 20px">
                  <b-row>
                    <b-col md="12">
                      <p class="card-text"> Breadth of access when open </p>
                    </b-col>
                    <b-col md="12">
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="(ctrl.pub == 'any')? 'outline-secondary':'vxon'"
                        @click="ctrlPubSet('same')">
                        Only Within Same Account.
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="(ctrl.pub == 'any')? 'vxon':'outline-secondary'"
                        @click="ctrlPubSet('any')">
                        Anyone From Any Account
                      </b-button>
                    </b-button-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <p class="card-text"> Who can change the room's settings? </p>
                    </b-col>
                    <b-col md="12">
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="ctrl.adhoc ? 'outline-secondary':'vxon'"
                        @click="adhocSet(false)">
                        Only Owner/Moderator
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="ctrl.adhoc ? 'vxon':'outline-secondary'"
                        @click="adhocSet(true)">
                        Anyone can Manage
                      </b-button>
                    </b-button-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <p class="card-text"> Log users joining/leaving room participation? </p>
                    </b-col>
                    <b-col md="12">
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="ctrl.ulog ? 'outline-secondary':'vxon'"
                        @click="ulogSet(false)">
                        No logging
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="ctrl.ulog ? 'vxon':'outline-secondary'"
                        @click="ulogSet(true)">
                        Log events to Chat stream
                      </b-button>
                    </b-button-group>
                    </b-col>
                  </b-row>
                </b-card-text>

                <b-card-text style="padding: 0 20px">
                  <b-row style="border-bottom: solid 1px;">
                    <b-col md="12">
                      <p class="card-text"> Open/Close the Room on a Schedule </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="11">
                      <b-row>
                        <b-col sm="6">
                          <date-picker
                           v-model="ocs_edit.op"
                           placeholder="Open Room At"
                           :not-before="Date.now()"
                           type="datetime"
                           lang="en"
                           format="MM-DD-YYYY [at] hh:mm A"
                           :time-picker-options="{
                             start: '00:00',
                             step: '00:15',
                             end: '23:59'
                           }"
                          >
                          </date-picker>
                        </b-col>
                        <b-col sm="6">
                          <date-picker
                           :disabled="!ocs_edit.op"
                           v-model="ocs_edit.cl"
                           :not-before="ocs_edit.op"
                           type="datetime"
                           placeholder="Close Room At"
                           lang="en"
                           format="MM-DD-YYYY [at] hh:mm A"
                           :time-picker-options="{
                             start: '00:00',
                             step: '00:15',
                             end: '23:59'
                           }"
                          >
                          </date-picker>
                        </b-col>
                        <b-col style="font-size:0.9rem;">
                          <b-form-radio-group v-model="ocs_edit.rp" name="ocs-radio"
                             style="font-size:0.9rem;">
                            <span style="display:inline-block;margin-right:0.3rem;">
                              Repeat:
                            </span>
                            <b-form-radio value="none">
                              None
                            </b-form-radio>
                            <b-form-radio value="daily">
                              Daily
                            </b-form-radio>
                            <b-form-radio value="weekly">
                              Weekly
                            </b-form-radio>
                          </b-form-radio-group>
                        </b-col>
                      </b-row>
                    </b-col>        
                    <b-col sm="1" style="margin:auto;">
                      <b-button size="sm"
                        @click="ocs_add"
                        variant="primary">
                        Add
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                    <b-table
                       striped
                       show-empty
                       stacked="sm"
                       :fields="ocsListFields"
                       :items="ocsList"
                       small
                       empty-text="No open/close events scheduled."
                    >
                       <template v-slot:cell(rp)="data">
                         {{ocs_show_repeat(data.item)}}
                       </template>
                       <template v-slot:cell(op)="data">
                         {{ocs_show_summary(data.item)}}
                       </template>
                       <template v-slot:cell(cl)="data">
                         {{ocs_show_next(data.item)}}
                       </template>
                       <template v-slot:cell(ac)="data">
                         <b-checkbox v-model="data.item.ac"
                          :disabled="data.item.rp == 'none'"
                          @change="ocs_toggle(data.item)">
                         </b-checkbox>
                       </template>
                       <template v-slot:cell(ctrl)="data">
                         <b-button size="sm" variant="danger"
                           style="font-size:0.75rem;text-transform:uppercase;padding: 0 0.4rem;"
                           @click="ocs_del(data.item)">
                           Del
                         </b-button>
                       </template>
                    </b-table>
                    </b-col>
                  </b-row>
                </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
        </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1 highlight" v-b-toggle.acc-layout >
                Configure Video Layout ({{ presLayoutSelName }})
             </b-button>
           </b-card-header>
           <b-collapse id="acc-layout" accordion="my-accordion" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('layout')"> ? </b-button>
             <b-card-body>
              <b-card-text>
                <div class="mt-3">Host View Layout <strong>{{ presLayoutSelName }}</strong></div>
                <b-form-select v-if="!ctrl_truckfocus" v-model="presLayoutSel" :options="presLayouts"
                   @change="change_room_ctrl()">
                </b-form-select>
                <b-button v-if="ctrl_truckfocus" style="width:100%" variant="outline-primary"
                   @click="take_from_dashboard">
                   Overridden by Focus. Click to Undo.
                </b-button>
                <div class="mt-3">Audience View Layout <strong>{{ audLayoutSel }}</strong></div>
                <b-form-select v-model="audLayoutSel" :options="audLayouts"
                   @change="change_room_ctrl()">
                </b-form-select>
              </b-card-text>
               <b-card-text style="padding:10px">
                  <b-row v-if="ctrl.cast && ctrl.cast.handle">
                    <b-col md="12">
                      <p class="card-text"> You are currently showing a video on your broadcast page. </p>
                    </b-col>
                    <b-col md="12">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        variant="vxon"
                        @click="rem_current_broadcast">
                        Turn off broadcast
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <p class="card-text"> Which participants are visible in Host View? </p>
                    </b-col>
                    <b-col md="12">
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="ctrl.prsonly ? 'outline-secondary':'vxon'"
                        @click="prsonlySet(false)">
                        All Participants
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="ctrl.prsonly ? 'vxon':'outline-secondary'"
                        @click="prsonlySet(true)">
                        Only Panelists
                      </b-button>
                    </b-button-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <p class="card-text"> Can participants see/hear each other? </p>
                    </b-col>
                    <b-col md="12">
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="ctrl.privmode ? 'outline-secondary':'vxon'"
                        @click="privmodeSet(false)">
                        Normal Meeting
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="ctrl.privmode ? 'vxon':'outline-secondary'"
                        @click="privmodeSet(true)">
                        Privacy Mode
                      </b-button>
                    </b-button-group>
                    </b-col>
                    <b-col md="12" v-if="ctrl.privmode"
                       style="margin:0 0.5rem;font-size:0.75rem;">
                       Moderator can see/hear everyone. Only first participant with hand raised can see/hear moderator. Other waiting participants see thumbnails and hear nothing until they are first in line.
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <p class="card-text"> Automatically raise hands when participants join? </p>
                    </b-col>
                    <b-col md="12">
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="ctrl.auto_raise ? 'outline-secondary':'vxon'"
                        @click="autoRaiseSet(false)">
                        Join with hand down
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="ctrl.auto_raise ? 'vxon':'outline-secondary'"
                        @click="autoRaiseSet(true)">
                        Join with hand raised
                      </b-button>
                    </b-button-group>
                    </b-col>
                  </b-row>
               </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1 highlight" v-b-toggle.acc-users >
               Currently in the Room ({{ userStats.all }})
             </b-button>
           </b-card-header>
           <b-collapse id="acc-users" accordion="my-accordion2" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('inroom')"> ? </b-button>
             <b-card-body>
              <b-row>
                <b-col>
                  <b-button size="sm" @click="refresh_users" variant="primary">
                   Refresh
                  </b-button>
                </b-col>
                <b-col sm="3">
                  <b-button-group>
                    <b-button size="sm" @click="empty_room" variant="danger">
                      Empty Room
                    </b-button>
                  </b-button-group>
               </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button class="uarfilt" size="sm"
                    @click="user_filter_sel('part')" :variant="userFilt.part.v">
                    Part: {{ userStats.part }} / {{ ctrl.joined_max }}
                  </b-button>
                  <b-button class="uarfilt" size="sm"
                    @click="user_filter_sel('view')" :variant="userFilt.view.v">
                    Viewing: {{ userStats.view }} / {{ ctrl.viewed_max }}
                  </b-button>
                  <b-button class="uarfilt" size="sm"
                    @click="user_filter_sel('wait')" :variant="userFilt.wait.v">
                    Waiting: {{ userStats.wait || "-" }}
                  </b-button>
                  <b-button class="uarfilt" size="sm"
                    @click="user_filter_sel('off')" :variant="userFilt.off.v">
                    Gone: {{ userStats.off || "-" }}
                  </b-button>
                  <b-button class="uarfilt" size="sm"
                    @click="user_filter_sel('blk')" :variant="userFilt.blk.v">
                    Blocked: {{ userStats.blk || "-" }}
                  </b-button>
                  <b-button class="uarfilt" size="sm"
                    @click="user_filter_sel('mod')" :variant="userFilt.mod.v">
                    Mod: {{ userStats.mod || "-" }}
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-input size="sm"
                    v-model.trim="uar_search"
                    v-on:keyup='user_filter_changed'
                    maxlength="50"
                    placeholder="User Filter">
                  </b-input>
                </b-col>
              </b-row>
              <b-card-text>
                 <div class="mb-3" v-if="true">
                   <b-table
                     striped
                     hover
                     show-empty
                     stacked="sm"
                     ref="userstab"
                     :items="usersAtRoom"
                     :fields="usersAtRoomFields"
                     small>
                     <template v-slot:cell(uid)="row">
                       <span style="cursor:pointer" @click="selectForChat(row.item)"> {{ row.item.dname || row.value }} </span>
                     </template>
                     <template v-slot:cell(rank)="row">
                       {{ row.value }}
                     </template>
                     <template v-slot:cell(status)="row">
                       {{ row.value }} ({{ row.item.cids }})
                     </template>
                     <template v-slot:cell(can_view)="row">
                       {{ row.item.can_view ? "Yes" : "No" }}
                       <b-button
                         v-if="!row.item.can_view_isfixed && !row.item.can_view"
                         style="position:abolute"
                         size="sm"
                         @click="change_user_role(row.item, 'can_view', true)"
                         variant="link">
                         <i class="typcn typcn-plus" style="color:green;font-size:120%"/>
                       </b-button>
                       <b-button
                         v-if="!row.item.can_view_isfixed && row.item.can_view"
                         size="sm"
                         @click="change_user_role(row.item, 'can_view', false)"
                         variant="link">
                         <i class="typcn typcn-delete" style="color:red;font-size:120%"/>
                       </b-button>
                     </template>
                     <template v-slot:cell(can_join)="row">
                       {{ row.item.can_join ? "Yes" : "No" }}
                       <b-button
                         v-if="
                           !row.item.can_join_isfixed &&
                             row.item.can_view &&
                             !row.item.can_join
                         "
                         size="sm"
                         @click="change_user_role(row.item, 'can_join', true)"
                         variant="link">
                         <i class="typcn typcn-plus" style="color:green;font-size:120%"/>
                       </b-button>
                       <b-button
                         v-if="
                           !row.item.can_join_isfixed &&
                             row.item.can_view &&
                             row.item.can_join"
                         size="sm"
                         @click="change_user_role(row.item, 'can_join', false)"
                         variant="link">
                         <i class="typcn typcn-delete" style="color:red;font-size:120%"/>
                       </b-button>
                     </template>
                     <template v-slot:cell(kind)="row">
                       <b-button
                         v-if="row.item.joined && row.item.kind == 'prs'"
                         size="sm"
                         @click="change_user_kind(row.item, 'aud')"
                         variant="link">
                       Remove
                       </b-button>
                       <b-button
                         v-if="row.item.joined && row.item.kind != 'prs' && (row.item.is_owner || row.item.kind == 'aud')"
                         size="sm"
                         @click="change_user_kind(row.item, 'prs')"
                         variant="link">
                       Add
                       </b-button>
                     </template>
                  </b-table>
                 </div>
                 <b-col md="6" class="my-1">
                   <b-button class="uarfilt" style="margin:0" size="sm"
                     v-if="uar_page > 1"
                     @click="user_page_prev" variant="primary">
                     Prev
                   </b-button>
                   <span class="uarfilt" style="font-size:0.8rem;">
                     Page {{ uar_page }}
                   </span>
                   <b-button class="uarfilt" style="margin:0" size="sm"
                     v-if="usersAtRoom.length >= uar_per"
                     @click="user_page_next" variant="primary">
                     Next
                   </b-button>
                 </b-col>                 
               </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col>
          <div style="margin-top:0.5rem;width:100%;border-bottom: solid 2px black;text-align:center;font-size: 0.9rem; font-weight:bold;">
            Advanced Customization
          </div>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-displayname>
               Branding, Title, Description, Website, Tags
             </b-button>
           </b-card-header>
           <b-collapse id="acc-displayname" accordion="my-accordion" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('title')"> ? </b-button>
             <b-card-body>
               <b-row
                 class="bhelp-title" data-balloon-pos="inl-right"
                 aria-label="Set a topic/title for discussion."
               >
                 <b-col>
                 <b-input
                     class="mb-1"
                     id="input-displayname2"
                     type="text"
                     v-model.trim="ctrl.dname"
                     required
                     placeholder="Display Name."
                     maxlength="100"
                 ></b-input>
                 </b-col>
               </b-row>
               <b-row
                 class="bhelp-title" data-balloon-pos="inl-right"
                 aria-label="Include a description users can see on home page."
                 >
                 <b-col>
                 <b-input
                    class="mb-1"
                    id="input-siteDescr"
                    type="text"
                    v-model.trim="ctrl.descr"
                    required
                    maxlength="300"
                    placeholder="Description">
                 </b-input>
                 </b-col>
               </b-row>
               <b-row
                 class="bhelp-title" data-balloon-pos="inl-right"               
                 aria-label="A URL for your website if you have one."
                 >
                 <b-col>
                 <b-input
                    class="mb-1"
                    id="input-siteURL2"
                    type="text"
                    v-model.trim="ctrl.url"
                    required
                    maxlength="300"
                    placeholder="Web page URL to show to users.">
                 </b-input>
                 </b-col>
               </b-row>
               <b-row
                 class="bhelp-title" data-balloon-pos="inl-right"
                 aria-label="Tag the discussion to help with search."
                 >
                 <b-col>
                 <b-form-group :state="cat_state" label-for="tags-validation">
                   <b-form-tags
                     input-id="tags-validation"
                     :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
                     v-model="ctrl.cat"
                     :state="cat_state"
                     :tag-validator="ctrl_catValidator"
                     separator=","
                   ></b-form-tags>
                    <!-- The following slots are for b-form-group -->
                   <template v-slot:invalid-feedback>
                      Include at least one of: {{ req_cats.join(", ") }}
                   </template>
                   <template v-slot:description>
                      <div id="tags-validation-help">
                       Tag the room. Press enter to add. Max of 10. Lower case only.
                     </div>
                   </template>
                 </b-form-group>
                 </b-col>
               </b-row>
               <b-row class="pb-2 bhelp-title"
                 data-balloon-pos="inl-right"
                 aria-label="You can pull title, descr, etc. from the current or next meeting." 
                 >
                 <b-col>
                   <b-button size="sm" :disabled="!cat_state"
                     @click="change_room_ctrl(true)" variant="primary">
                     Update Metadata
                   </b-button>
                   <b-button size="sm" v-if="false && set_info_from_meeting(true)==1"
                      @click="set_info_from_meeting()" variant="primary">
                      Update For Current Meeting
                   </b-button>
                   <b-button size="sm" v-if="set_info_from_meeting(true)>1"
                      @click="set_info_from_meeting()" variant="primary">
                      Update For Upcoming Meeting
                   </b-button>
                 </b-col>
               </b-row>
               <b-row class="pb-4">
                 <b-col>
                   <div>
                     <span> Click to change your location: </span>
                     <span> <a style="cursor:pointer;color:#007bff;text-decoration:underline;"
                              @click="$parent.goAccount">
                               {{ prettyLocation }} </a> </span>
                   </div>
                 </b-col>
               </b-row>

               <b-row>
                <b-col>
                  <div class="brand_section">Room Logo Image</div>
                  <div class="brand_usage">Placed on the host's video tile and the room's no access page</div>
                  <upload-image
                    v-model="ctrl.rlogo"
                    v-on:changed="img_rlogo_changed"
                    imgkind="room_logo"
                    size=4
                    optional=true
                  />
                </b-col>
               </b-row>
               <b-row>
                <b-col>
                  <div class="brand_section">Room Tag Image</div>
                  <div class="brand_usage">Small image used to tag messages from moderators</div>
                  <upload-image
                    v-model="ctrl.rlogosm"
                    v-on:changed="img_rlogosm_changed"
                    imgkind="room_logosm"
                    size=4
                    optional=true
                  />
                </b-col>
               </b-row>
               <b-row>
                <b-col>
                  <div class="brand_section">Room Background Image</div>
                  <div class="brand_usage">Placed behind room's video meeting.</div>
                  <upload-image
                    v-model="ctrl.rback"
                    v-on:changed="img_rback_changed"
                    imgkind="room_back"
                    size=4
                    optional=true
                  />
                </b-col>
               </b-row>
               <b-row>
                <b-col>
                  <div class="brand_section">Room Banner Image</div>
                  <div class="brand_usage">Placed above room's video meeting.</div>
                  <upload-image
                    v-model="ctrl.rbannland"
                    v-on:changed="img_rbannland_changed"
                    imgkind="room_bannland"
                    size=4
                    optional=true
                  />
                </b-col>
               </b-row>
               <b-row>
                  <b-col>
                    <div class="brand_section">Slate Image/Audio/Video</div>
                    <div class="brand_usage">Shown while waiting for host to arrive</div>
                    <upload-image
                      v-model="slate.url"
                      :mime="slate.mime"
                      v-on:changed="img_slate_changed"
                      imgkind="room_slate"
                      types="image,audio,video"
                      size=100
                    />
                  </b-col>
               </b-row>
               <b-row>
                 <b-col md="12">
                   <div style="font-size:0.8rem;">Show the slate when no panelist is present? </div>
                 </b-col>
               </b-row>
               <b-row>
                 <b-col>
                    <b-button-group style="width:100%">
                      <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="slate.mode=='on' ? 'outline-secondary':'vxon'"
                        @click="ctrlState('off')">
                        Disable
                      </b-button>
                      <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="slate.mode=='on' ? 'vxon':'outline-secondary'"
                        @click="ctrlState('on')">
                        Enable
                      </b-button>
                   </b-button-group>
                 </b-col>
               </b-row>
               <b-row>
                <b-col>
                  <div class="brand_section">Personal Thumbnail</div>
                  <div class="brand_usage"> Shown when you participate with only audio</div>
                  <upload-image
                    v-model="imgs.tnurl"
                    tnkind="my_tn"
                    size=4
                  />
                </b-col>
               </b-row>
               <b-row>
                 <b-col md="12">
                   <p class="card-text" style="font-weight:bold">
                     Which feature buttons can participants see?
                   </p>
                 </b-col>
                 <b-col md="12">
                   <span v-for="(tohide,title) in canhide">
                     <b-button class="mb-1" style="padding-top:0;padding-bottom:0;"
                       :variant="ctrl.hide.includes(tohide.n) ? 'outline-secondary' : 'vxon'"
                       :title="tohide.t"
                       @click="hide(tohide.n)">
                       {{ tohide.d }}
                     </b-button>
                   </span>
                 </b-col>
               </b-row>

             </b-card-body>            
           </b-collapse>
         </b-card>
        </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="(role_is_mod && ctrl.eph_limit && !ctrl_eph)">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-spawn>
               Breakout Rooms
             </b-button>
           </b-card-header>
           <b-collapse id="acc-spawn" accordion="my-accordion" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('breakout')"> ? </b-button>
             <b-card-body style="padding-bottom:0;">
               <b-card-text v-if="role_is_mod">
                 <div v-if="ctrl.eph" style="margin-bottom:0.2rem">
                   You currently have <span style="color:#0062cc;font-weight:bold;"> {{ ctrl.eph }} </span> breakout rooms.
                 </div>
                 <div v-if="!ctrl.eph" style="margin-bottom:0.2rem">
                   You currently have no breakout rooms.
                 </div>
                 <div> You are limited to {{ ctrl.eph_limit }} rooms. </div>
                   <b-form-input
                         class="mb-1"
                         type="text"
                         v-model.trim="spawn.cnt"
                         required
                         placeholder="How many breakout rooms do you want?"
                   ></b-form-input>
                   <b-button size="sm" variant="primary"
                     @click="do_spawn_ephroom"
                     >
                     Change Number Of Rooms
                   </b-button>
                   <b-button size="sm" variant="danger"
                     @click="do_deleteall_ephrooms"
                     :disabled="!ctrl.eph"
                     >
                     Delete All
                   </b-button>
                  <b-form-group label="Breakout Mode">
                    <b-form-radio v-model="ctrl.eph_mode" name="eph_radio" value="open" @change="change_eph_mode()">People can move freely between breakout rooms</b-form-radio>
                    <b-form-radio v-model="ctrl.eph_mode" name="eph_radio" value="locked" @change="change_eph_mode()">Lock people to their breakout room</b-form-radio>
                  </b-form-group>
                  <b-form-group label="Panelists">
                    <b-form-radio v-model="ctrl.eph_strict" name="eph2_radio" value="true" @change="change_eph_mode()">Panelists in the main room do NOT appear in break rooms</b-form-radio>
                    <b-form-radio v-model="ctrl.eph_strict" name="eph2_radio" value="false" @change="change_eph_mode()">Panelists in the main room also appear in all breakout rooms</b-form-radio>
                  </b-form-group>
               </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
        </b-col>
     </b-row>
      
     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod && !ctrl_eph" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-alert>
               Alerts
             </b-button>
           </b-card-header>
           <b-collapse id="acc-alert" accordion="my-accordion" role="tabpanel"
              v-on:show="clicked_alert">
             <b-button class="info" variant="light" @click="showinfo('alert')"> ? </b-button>
             <b-card-body>
               <b-card-text>
                  <div class="alert_section">
                    <div class="alert_heading">
                      Up to 3 phone numbers for SMS alerts
                    </div>
                    <b-form-tags
                      v-model="edit_alert.phone"
                      :disabled="!edit_alert.phone || !edit_alert.phone.length"
                      add-on-change
                      no-outer-focus
                    >
                      <template v-slot="{ tags, disabled, removeTag }">
                        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-0">
                           <li v-for="tag in tags" :key="tag" class="list-inline-item">
                             <b-form-tag
                              @remove="removeTag(tag)"
                              :title="tag"
                              variant="info"
                             >{{ tag }}
                             </b-form-tag>
                          </li>
                       </ul>
                       <b-button size="sm" variant="primary"
                         v-if="!edit_alert.phone || edit_alert.phone.length < 3"
                         class="ml-4 pt-0 pb-0"
                         @click="addPhoneTag">
                         Add
                       </b-button>
                     </template>
                    </b-form-tags>
                    <div class="alert_headingN">
                       Email for alerts (an owner or moderator)
                    </div>
                    <b-form-select v-model="edit_alert.em" :options="alertEmails">
                    </b-form-select>
                  </div>
                  <div class="alert_section">
                     <div class="alert_heading">
                       Message to show if room is closed
                     </div>
                      <auto-text-area size="sm"
                        v-model.trim="edit_alert.noa_msg"
                        maxlength="500"
                        placeholder="You do not have permission to access this room.">
                      </auto-text-area>
                   </div>
                   <div class="alert_section">
                     <div class="alert_heading">
                       Audible doorbell when a visitor enters your room
                     </div>
                     <b-form-radio-group id="sms-dbell"
                       v-model="edit_alert.dbell"
                       name="r-alert-dbell">
                       <b-form-radio value="false">Disable</b-form-radio>
                       <b-form-radio value="true">Enable</b-form-radio>
                     </b-form-radio-group>
                     <div class="alert_descr"
                       v-if="edit_alert.dbell == 'true'">
                       Moderators will hear a doorbell chime when a vistor arrives.
                     </div>
                     <div class="alert_headingN">
                      Send SMS alert when a visitor enters your room
                     </div>
                     <b-form-radio-group id="sms-alert"
                       :disabled="!edit_alert.phone || !edit_alert.phone.length"
                       v-model="edit_alert.sms"
                       name="r-sms-alerts">
                       <b-form-radio value="-">Never</b-form-radio>
                       <b-form-radio value="whenaway">Only when you are away</b-form-radio>
                       <b-form-radio value="any">Always</b-form-radio>
                     </b-form-radio-group>
                     <div class="alert_descr"
                       v-if="edit_alert.sms == 'whenaway'">
                       You will be notified when a visitor arrives while you are not present.
                     </div>
                     <div class="alert_descr"
                       v-if="edit_alert.sms == 'any'">
                       You will always be notified when a vistor arrives even if you are already in the room.
                     </div>
                   </div>

                   <div class="alert_section">
                     <div class="alert_heading">
                       Allow visitors to leave you a message when your room is private.
                     </div>
                     <b-form-radio-group id="contact-alert"
                      v-model="edit_alert.contact"
                      name="r-contact-alert">
                       <b-form-radio value="-">Never</b-form-radio>
                       <b-form-radio value="email">Via email</b-form-radio>
                       <b-form-radio value="sms"
                         :disabled="!edit_alert.phone || !edit_alert.phone.length"
                         >
                         Via text message
                       </b-form-radio>
                     </b-form-radio-group>
                     <b-button size="sm"
                       style="position:absolute;top:5px;right:5px;margin:0"
                       v-if="ctrl.can_contact && !alerts_have_changed()"
                       @click="do_test_contact()"
                       :disabled="edit_alert.tested_contact"
                       variant="primary"
                       >
                       {{ edit_alert.tested_contact ? "Sent" : "Test" }}
                     </b-button>
                     <div class="alert_descr"
                       v-if="edit_alert.contact == 'email'">
                       Users can write a short message which we forward to you via email.
                     </div>
                     <div class="alert_descr"
                       v-if="edit_alert.contact == 'sms'">
                       Users can write a short message which we forward to you via SMS.
                     </div>
                     <div class="alert_headingN">
                       Allow visitors to leave voicemails when your room is private.
                     </div>
                     <b-form-radio-group id="vmail-alert"
                      v-model="edit_alert.vmail">
                       <b-form-radio value="false">Never</b-form-radio>
                       <b-form-radio value="true">Enabled</b-form-radio>
                     </b-form-radio-group>
                   </div>
                   <div style="margin-top:0.3rem;"
                     v-if="!edit_alert.saving">
                     <div class="alert_error"
                       v-if="edit_alert.error">
                       {{ edit_alert.error }}
                     </div>
                     <b-button size="sm"
                       :disabled="!alerts_have_changed()"
                       @click="update_alerts()"
                       variant="primary">
                       Save Changes
                     </b-button>
                     <b-button  size="sm"
                       v-if="alerts_have_changed()"
                       @click="cancel_edit_alert()"
                       variant="outline-danger">
                       Cancel
                     </b-button>
                   </div>
               </b-card-text>
             </b-card-body>
             <b-card-body>
                <b-row>
                  <b-col sm="2">
                    <b-button  size="sm"
                      @click="get_voicemails_first()"
                      variant="primary">
                      Refresh
                    </b-button>
                  </b-col>
                  <b-col sm="3">
                    <b-button  size="sm"
                      class="vm_btn_mat"
                      @click="get_voicemails_prev()"
                      :disabled="vmail_cur_page <= 0"
                      variant="primary">arrow_back</b-button>
                    <b-button  size="sm"
                      class="vm_btn_mat"
                      @click="get_voicemails_next()"
                      :disabled="(vmail_cur_page+1) >= vmail_max_page"
                      variant="primary">arrow_forward</b-button>
                    <span v-if="vmail_max_page"
                      style="font-weight:bold;vertical-align:middle;">
                      {{vmail_cur_page+1}}/{{vmail_max_page}}
                    </span>
                  </b-col>
                  <b-col sm="6"
                    v-show="vmail_stats.playing">
                    <audio style="max-height:2rem;width:100%;"
                       controls ref="vmaudio">
                    </audio>
                  </b-col>
                </b-row>
                <b-row v-if="vmail_stats.playing"
                  style="padding-top:0">
                  <b-col sm="2">
                    <b-button  size="sm"
                      style="line-height:0.9rem;"
                      :disabled="vmail_stats.fwd_pending || !vmail_stats.fwd_to_room"
                      @click="vm_forward"
                      variant="primary">
                      Forward
                    </b-button>
                  </b-col>
                  <b-col sm="4">
                     <b-form-input
                       style="height:auto; padding: 0.1rem;"
                       type="text"
                       v-model.trim="vmail_stats.fwd_to_room"
                       placeholder="Forward to @room"
                      ></b-form-input>
                  </b-col>
                  <b-col sm="6">
                  </b-col>
                  <b-col v-if="vmail_stats.fwd_err"
                    style="color:red;font-size:0.8rem;">
                    {{vmail_stats.fwd_err}}
                  </b-col>
                </b-row>
                <b-table
                   striped
                   hover
                   show-empty
                   stacked="sm"
                   :items="vmails_tab"
                   :fields="vmailFields"
                   small>
                   <template v-slot:cell(tm)="row">
                      <div @click="vm_select(row.item)" style="width:100%">
                        {{get_vmail_date(row.value)}}
                      </div>
                   </template>
                   <template v-slot:cell(dname)="row">
                      <div @click="vm_select(row.item)" style="width:100%">
                        {{row.value}}
                      </div>
                   </template>
                   <template v-slot:cell(em)="row">
                      <div @click="vm_select(row.item)" style="width:100%">
                        {{row.value}}
                      </div>
                   </template>
                   <template v-slot:cell(vurl)="row">
                     <div  style="position:relative">
                     <b-button size="sm"
                       v-if="!row.item.playing"
                       class="vm_btn_mat"
                       @click="vm_play(row.item)"
                       >play_arrow</b-button>
                     <b-button size="sm"
                       v-if="row.item.playing"
                       class="vm_btn_mat"
                       @click="vm_stop()"
                       >stop</b-button>
                     <confirm-del size='sm'
                       v-if="!row.item.playing"
                       :clear="row.item.id"
                       timeout="2000"
                       v-on:confirmed-delete="vm_delete(row.item)">
                     </confirm-del>
                     <span v-if="!row.item.played"
                        class="vm_btn_mat vm_new_tag">
                        voicemail
                     </span>
                     </div>
                   </template>
                </b-table>
             </b-card-body>
           </b-collapse>
         </b-card>
        </b-col>
     </b-row>      

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod && !ctrl_eph" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-notify>
               Notifications
             </b-button>
           </b-card-header>
           <b-collapse id="acc-notify" accordion="my-accordion" role="tabpanel"
              v-on:show="clicked_notify">
             <b-card-body>
               <b-card-text>

                 <div class="alert_section">
                     <div class="alert_heading">
                       Enable Customized Visitor Arrival Notifications
                     </div>
                     <b-form-radio-group
                       v-model="edit_anote.enabled">
                       <b-form-radio value="false">Disabled</b-form-radio>
                       <b-form-radio value="true">Enabled</b-form-radio>
                     </b-form-radio-group>
                     <div class="alert_descr"
                       v-if="edit_anote.enabled == 'true'">
                       The features below turn this room into a central lobby. Notify other rooms when visitors arrive here optionally guided by the visitor.
                     </div>
                     <div class="alert_descr"
                       v-if="edit_anote.enabled != 'true'">
                       All of the features below are disabled.
                     </div>
                 </div>

                 <div class="alert_section">
                   <div class="alert_heading">
                     Custom Delay Between Visitor Prompts
                   </div>
                   <b-form-radio-group
                     style="display:inline-block;"
                     v-model="edit_anote.prompt_enabled"
                     :disabled="edit_anote.enabled == 'false'"
                     >
                     <b-form-radio value="false">Disable</b-form-radio>
                     <b-form-radio value="true">Enable</b-form-radio>
                   </b-form-radio-group>
                   <b-input style="display:inline-block;width:8rem;"
                    v-show="edit_anote.prompt_enabled == 'true'"
                    placeholder="seconds"
                    v-model="edit_anote.prompt_sec"
                    :disabled="edit_anote.enabled == 'false'"
                    >
                   </b-input>
                   <div class="alert_descr"
                     v-if="edit_anote.prompt_enabled == 'true' && edit_anote.prompt_sec">
                     Repeat the visitor prompt if still alone in the room after {{ edit_anote.prompt_sec }} seconds. If text or voice messaging has been enabled under Alerts they will be given the option to leave a message.
                   </div>

                   <div class="alert_headingN">
                     Notification Timing
                   </div>
                   <b-form-radio-group id="anote-mode"
                     v-model="edit_anote.mode"
                     :disabled="edit_anote.enabled == 'false'"
                     >
                     <b-form-radio value="all">All</b-form-radio>
                     <b-form-radio value="brr">Batched Round-Robin</b-form-radio>
                     <b-form-radio value="rr">Round Robin</b-form-radio>
                   </b-form-radio-group>
                   <div class="alert_descr"
                     v-if="edit_anote.mode == 'all'">
                     Notify all listed rooms in one shot.
                   </div>
                   <div class="alert_descr"
                     v-if="edit_anote.mode == 'brr'">
                     Notify listed rooms a few rooms at a time.
                   </div>
                   <div class="alert_descr"
                     v-if="edit_anote.mode == 'rr'">
                     Notify listed rooms one room at a time.
                   </div>
                 </div>

                 <div class="alert_section">
                   <div class="alert_heading">
                     Prompt Visitors to Contact By Name
                   </div>
                   <b-form-radio-group
                     v-model="edit_anote.nameq_enabled"
                     :disabled="edit_anote.enabled == 'false'"
                     >
                     <b-form-radio value="false">Disabled</b-form-radio>
                     <b-form-radio value="true">Enabled</b-form-radio>
                   </b-form-radio-group>
                   <div class="alert_descr"
                     v-if="edit_anote.nameq_enabled == 'true'">
                     Visitors can notify another room by typing in that owner's name.
                   </div>

                   <div class="alert_headingN">
                     Prompt Visitors to Get a Call-back
                   </div>
                   <b-form-radio-group
                     v-model="edit_anote.callb_enabled"
                     :disabled="edit_anote.enabled == 'false'"
                     >
                     <b-form-radio value="false">Disabled</b-form-radio>
                     <b-form-radio value="true">Enabled</b-form-radio>
                   </b-form-radio-group>
                   <div class="alert_descr"
                     v-if="edit_anote.callb_enabled == 'true'">
                     Visitors can keep their place in line and get an SMS/email URL to return when an agent is ready.
                   </div>
                 </div>

                 <div class="alert_section">
                   <div class="alert_heading">
                     Prompt Visitors to Contact a Department
                   </div>
                   <b-form-radio-group
                     v-model="edit_anote.cat_enabled"
                     :disabled="edit_anote.enabled == 'false'"
                     >
                     <b-form-radio value="false">Disabled</b-form-radio>
                     <b-form-radio value="true">Enabled</b-form-radio>
                   </b-form-radio-group>
                   <div class="alert_descr"
                     v-if="edit_anote.cat_enabled == 'true'">
                     Visitors can notify rooms associated with the selected department or be automatically transferred to that departments lobby.
                   </div>
                   <div class="alert_headingN">
                      List Departments Below in Visitor Prompt (Max 6)
                   </div>
                  <b-row>
                    <b-col>
                     <input-sub
                       v-model="add_acat.label"
                       v-on:enter='notify_add_cat'
                       placeholder="Label for Button"
                     >
                     </input-sub>
                    </b-col>
                    <b-col>
                      <search-transfer ref="anote_cat_input"
                        v-on:room="notify_add_cat"
                        v-on:search="notify_add_cat"
                        clrsearch="false"
                        clrroom="false"
                        placeholder="Department Name or @Room"
                      >
                      </search-transfer>
                    </b-col>
                  </b-row>
                   <div class="alert_descr">
                     Type in a department name, label text, and hit enter to add a department notification button to the visitor prompt. Use a @room name to instead send the visitor to that room when the button is clicked.
                   </div>
                   <div class="alert_error"
                     v-if="add_acat.error">
                     {{ add_acat.error }}
                   </div>
                  <b-table
                    striped
                    hover
                    show-empty
                    stacked="sm"
                    :items="edit_anote.cats"
                    :fields="acatFields"
                    style="font-size:0.9rem"
                    small>
                    <template v-slot:cell(ctrl)="row">
                      <b-button size="sm" v-if="row.item.ctrl"
                        style="padding: 0 0.2rem;font-size:0.7rem;float:right;"
                        variant="outline-danger"
                        @click="notify_del_cat(row.item)"
                      >DEL
                      </b-button>
                    </template>
                  </b-table>

                 </div>

                 <div style="margin-top:0.2rem;"
                   v-if="!edit_anote.saving">
                   <div class="alert_error"
                     v-if="edit_anote.error">
                     {{ edit_anote.error }}
                   </div>
                   <b-button size="sm" style="padding: 0 0.2rem;"
                     :disabled="!anotes_have_changed()"
                     @click="update_anotes()"
                     variant="primary">
                     Save Changes
                   </b-button>
                   <b-button  size="sm" style="padding: 0 0.2rem;"
                     v-if="anotes_have_changed()"
                     @click="cancel_edit_anote()"
                     variant="outline-danger">
                     Cancel
                   </b-button>
                 </div>

                 <div class="alert_section" style="margin-top:0.7rem;">
                  <div class="alert_heading">
                     Rooms to Notify Upon Visitor Arrival
                  </div>
                  <b-row>
                    <b-col>
                      <search-transfer ref="anote_room_input"
                        v-on:room="notify_add_room"
                        nosearch="true"
                        clrroom="false"
                        placeholder="@Room"
                      >
                      </search-transfer>
                    </b-col>
                    <b-col>
                     <input-sub
                       v-model="add_anote.cat"
                       v-on:enter='notify_add_room'
                       placeholder="Department Name (Optional)"
                     >
                     </input-sub>
                    </b-col>
                  </b-row>
                   <div class="alert_descr">
                     Type in a @room name and optional department name, and hit enter to add room to the notification list. Some or all of these rooms will be notified when a visitor arrives depending on the settings above.
                   </div>
                   <div class="alert_error"
                     v-if="add_anote.error">
                     {{ add_anote.error }}
                   </div>
                  <b-table
                    striped
                    hover
                    show-empty
                    stacked="sm"
                    :items="arrivalItems"
                    :fields="arrivalFields"
                    style="font-size:0.9rem"
                     small>
                    <!-- <template v-slot:cell(noall)="row"> -->
                    <template v-slot:cell(ctrl)="row"
                      style="min-width:4rem">
                      <b-checkbox v-model="row.item.noall"
                        style="display: inline"
                        @change="notify_noall_toggle(row.item)">
                      </b-checkbox>
                      <b-button size="sm" v-if="row.item.ctrl"
                        style="padding: 0 0.2rem;font-size:0.7rem;float:right;"
                        variant="outline-danger"
                        @click="notify_del_room(row.item)"
                      >DEL
                      </b-button>
                    </template>
                  </b-table>
                 </div>

               </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
        </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card title="Available Webinars"
                v-if="false" class="mb-4 bs">
           <b-card-text>
             <div class="mb-3">
               <b-table
                 striped
                 show-empty
                 stacked="md"
                 :fields="roomWebinarFields"
                 :items="roomWebinars"
                 small
               >
               <template v-slot:cell(isreg)="data">
                 <b-button v-if="!data.item.isreg && !data.item.isfull && !data.item.isold" size="sm"
                    @click="do_self_regmeeting(data.item)" variant="secondary">
                    REGISTER
                 </b-button>
                 <b-button v-if="!data.item.isreg && !data.item.isfull && data.item.isold" size="sm"
                    disabled variant="secondary">
                    FINISHED
                 </b-button>
                 <b-button v-if="!data.item.isreg && data.item.isfull" size="sm"
                    disabled variant="secondary">
                    FULL
                 </b-button>
                 <b-button v-if="data.item.isreg" size="sm"
                    disabled variant="warning">
                    REGISTERED
                 </b-button>
               </template>
               <template v-slot:cell(name)="data"> 
                 {{ data.value }}
               </template>
               <template v-slot:cell(start_ep)="data">
                 {{ getMeetingStartDateTime(data.item) }}
               </template>
               <template v-slot:cell(end_ep)="data">
                 {{ getMeetingEndDateTime(data.item) }}
               </template>
               <template v-slot:cell(geo)="data">
                 <i v-if="data.item.geo && data.item.geo.ct" class="typcn typcn-lock-closed" style="color:red;font-size:120%"></i>
               </template>
               <template v-slot:row-details="row">
                 <div style="padding: 0 0 2px 5px">
                   <b-row class="mb-0" v-show="row.item.descr">
                    <b-col sm="1" class="text-sm-right"></b-col>
                    <b-col>{{ row.item.descr }}</b-col>
                   </b-row>
                   <b-row class="mb-0" v-show="row.item.url">
                     <b-col sm="1" class="text-sm-right"></b-col>
                     <b-col><b-link :href=row.item.url>Link with more details</b-link></b-col>
                   </b-row>
                 </div>
               </template>
               </b-table>
             </div>
           </b-card-text>
        </b-card>
        <b-card title="Invitations and Registrations" v-if="false" class="mb-4 bs">
           <b-card-text>
             <div class="mb-3">
               <b-table
                 striped
                 hover
                 show-empty
                 stacked="md"
                 :fields="meetingsRoomFieldsInv"
                 :items="meetingsRoom"
                 small
               >
               <template v-slot:cell(name)="data"> 
                 {{ data.value }}
               </template>
               <template v-slot:cell(start_ep)="data">
                 {{ getMeetingStartDateTime(data.item) }}
               </template>
               <template v-slot:cell(end_ep)="data">
                 {{ getMeetingEndDateTime(data.item) }}
               </template>
               </b-table>
             </div>
           </b-card-text>
        </b-card>
       </b-col>
     </b-row>

     <b-modal id="bv-phone-verify" size="sm" hide-footer hide-header>
       <phone-verify
        descr="The number must be verified before being added as a contact."
        kind="ctrl.alert.ph"
        v-on:done="closePhVerify">
       </phone-verify>
     </b-modal>

     <b-modal id="bv-email-prompt" size="lg" title="Edit the invitation" hide-footer>
       <b-form-textarea id="email-body"
         v-model="emailInviteText"
         rows="5"
         max-rows="5"
       ></b-form-textarea>
       <div style="padding: 1vw 0px">
         <b-button-group class="">
           <b-button class="sm" @click="closeMeetingModal">
             Send Emails
           </b-button>
         </b-button-group>
         <b-button-group class="float-right">
           <b-button class="sm" @click="$bvModal.hide('bv-email-prompt')"
             variant="danger">
             Cancel
           </b-button>
         </b-button-group>
       </div>
      </b-modal>
        
      <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod && !ctrl_eph" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-meetings>
               Group, Webinars, Meetings ({{ meetingsRoom.length }})
             </b-button>
           </b-card-header>
           <b-collapse id="acc-meetings" accordion="my-accordion" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('meetings')"> ? </b-button>
             <b-card-body>

               <div class="mb-3 bhelp-meetings"  v-if="isMeetingsListView ==true"
                 data-balloon-pos="inl-right-top"
                 aria-label="Create a new meeting. Click an existing meeting in the list below to update."
                 >
                 <b-button size="sm" @click="get_all_meetings" variant="primary">
                    Refresh
                 </b-button>
                 <b-button size="sm" @click="newMeeting" variant="primary">
                    New Meeting
                 </b-button>
                 <b-table
                    striped
                    show-empty
                    stacked="sm"
                    :fields="meetingsRoomFields"
                    :items="meetingsRoom"
                    small
                 >
                   <template v-slot:cell(name)="data"> 
                     <a @click.prevent="openMeetingView(data.item)" href="">{{ data.value == "group" ? "Group Members" : (data.value || "not-named") }}</a>
                   </template>
                   <template v-slot:cell(start_ep)="data">
                     {{ getMeetingStartDateTime(data.item) }}
                   </template>
                   <template v-slot:cell(end_ep)="data">
                     {{ getMeetingEndDateTime(data.item) }}
                   </template>
                   <template v-slot:cell(attendees)="data">
                     {{ getMeetingAttendees(data.value) }}
                   </template>
                 </b-table>
               </div>
                
               <div class="mb-3" v-if="isMeetingsListView ==false">
                 <b-card-text v-if="editMeetingView ==false"
                   class="bhelp-meetings" data-balloon-pos="inl-right-top"
                   aria-label="Email invitation to all attendees, Delete the meeting."
                 >
                   <b-button-group>
                     <b-button size="sm" @click="cancelSelectedMeetingView" variant="outline-primary">
                        &lsaquo;&nbsp; Meeting List
                     </b-button>
                     <b-button size="sm" @click="openMeetingModal" variant="primary">
                        Email Invitations
                     </b-button>
                   </b-button-group>
                   <b-button-group class="float-right">
                     <b-button size="sm" v-if="!selectedMeeting.isgroup"
                       @click="confirmDeleteMeeting()" variant="danger">
                       Delete Meeting
                     </b-button>
                     <b-button size="sm" v-if="selectedMeeting.isgroup && !selectedMeeting.inactive"
                       @click="deactivateGroup()" variant="danger">
                       Turn Off Group
                     </b-button>
                     <b-button size="sm" v-if="selectedMeeting.isgroup && selectedMeeting.inactive"
                       @click="activateGroup()" variant="secondary">
                       Activate Group
                     </b-button>
                   </b-button-group>
                   <b-row  v-if="!selectedMeeting.isgroup">
                     <b-col cols="11" @click="editSelectedMeeting" >
                       <b style="color:#007bff;">{{ selectedMeeting.name }}</b>
                     </b-col>
                   </b-row>
                   <b-row  v-if="selectedMeeting.isgroup && !selectedMeeting.inactive">
                     <b-col cols="11">
                       <b>{{ "Add Users to the Group" }}</b>
                     </b-col>
                   </b-row>
                   <b-row  v-if="selectedMeeting.isgroup && selectedMeeting.inactive">
                     <b-col cols="11">
                       <b>{{ "Add Users to the Group (and activate above)" }}</b>
                     </b-col>
                   </b-row>
                   <b-row v-if="selectedMeeting.descr">
                     <b-col cols="11" @click="editSelectedMeeting" >
                       <b style="font-size:0.75rem">{{ selectedMeeting.descr }}</b>
                     </b-col>
                   </b-row>
                   <b-row v-if="selectedMeeting.url">
                     <b-col cols="11" @click="editSelectedMeeting" >
                       <b style="font-size:0.75rem">{{ selectedMeeting.url }}</b>
                     </b-col>
                   </b-row>
                   <b-row v-if="!selectedMeeting.isgroup">  
                      <b-col cols="4" @click="editSelectedMeeting" >
                        <small style="padding:0 4px 0 0;">Starts At:</small>
                        <small style="color:#007bff;"><b>{{ getMeetingStartDateTime(selectedMeeting) }}</b></small>
                      </b-col>
                      <b-col cols="4" @click="editSelectedMeeting" >
                        <small style="padding:0 4px 0 0;">Ends At:</small>
                        <small style="color:#007bff;"><b>{{ getMeetingEndDateTime(selectedMeeting) }}</b></small>
                      </b-col>
                      <b-col cols="2" v-show="selectedMeeting.iswebinar == 'true'"
                         style="color:#ff7b00;font-weight:400">
                         WEBINAR
                      </b-col>
                      <b-col cols="2" v-show="selectedMeeting.geo.ct"
                         style="color:#ff7b00;font-weight:400">
                         GEO
                      </b-col>
                      <b-col cols="2"><span> <i class="typcn typcn-edit" @click="editSelectedMeeting" style="cursor:pointer;color:#007bff;font-size:130%"></i></span></b-col>
                   </b-row>
                 </b-card-text>
                    
                 <b-card-text v-if="editMeetingView ==true">
                   <b-row
                     class="bhelp-meetings" data-balloon-pos="inl-right"
                     aria-label="Required, short name or topic for the meeting."
                   >
                     <b-col cols="6">
                       <b-input size="sm" class="mb-1"
                         id="inline2-form-input-name"
                         placeholder="Name Your Meeting"
                         v-model= "tmpSelectedMeeting.name"
                         :input-attr="{ required: true }"
                         maxlength=40
                       ></b-input>
                     </b-col>
                   </b-row>
                   <b-row
                     class="bhelp-meetings" data-balloon-pos="inl-right"
                     aria-label="Optional, more detailed description of the meeting."
                   >
                     <b-col cols="12">
                       <b-input size="sm" class="mb-1"
                         id="inline2-form-input-descr"
                         placeholder="Description"
                         v-model= "tmpSelectedMeeting.descr"
                         maxlength=150
                       ></b-input>
                     </b-col>
                   </b-row>
                   <b-row
                     class="bhelp-meetings" data-balloon-pos="inl-right"
                     aria-label="Optional website URL with meeting material"
                     >
                     <b-col cols="12">
                       <b-input size="sm" class="mb-1"
                         id="inline2-form-input-url"
                         placeholder="URL"
                         v-model= "tmpSelectedMeeting.url"
                         maxlength=200
                       ></b-input>
                     </b-col>
                   </b-row>
                   <b-row
                     class="bhelp-meetings" data-balloon-pos="inl-right"
                     aria-label="Checking 'webinar' allows people to sign-up for themselves"
                     >
                     <b-col cols="4">
                     <date-picker
                       id="inline2-form-input-start_ep"
                       placeholder="Start time"
                       v-model= "tmpSelectedMeeting.start_ep"
                       type="datetime"
                       :clearable="false"
                       :not-before="Date.now()"
                       :input-attr="{ required: true }"
                       lang="en"
                       format="MM-DD-YYYY [at] hh:mm A"
                       :time-picker-options="{
                         start: '00:00',
                         step: '00:15',
                         end: '23:59'
                       }"
                     ></date-picker>
                     </b-col>
                     <b-col cols="4">
                       <date-picker
                         id="inline2-form-input-end_ep"
                         placeholder="End time"
                         v-model= "tmpSelectedMeeting.end_ep"
                         type="datetime"
                         :clearable="false"
                         :not-before="Math.max(tmpSelectedMeeting.start_ep,Date.now())"
                         :input-attr="{ required: true }"
                         lang="en"
                         format="MM-DD-YYYY [at] hh:mm A"
                         :time-picker-options="{
                           start: '00:00',
                           step: '00:15',
                           end: '23:59'
                         }"
                       ></date-picker>
                     </b-col>
                   </b-row>

                   <b-row>
                     <b-col sm="12">
                      <b-button-group style="max-width:5rem">
                       <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="tmpSelectedMeeting.iswebinar && tmpSelectedMeeting.iswebinar != 'false' ? 'outline-secondary':'vxon'"
                        @click="tmpSelectedMeeting.iswebinar='false'">
                        Off
                       </b-button>
                       <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="tmpSelectedMeeting.iswebinar && tmpSelectedMeeting.iswebinar != 'false' ? 'vxon':'outline-secondary'"
                        @click="tmpSelectedMeeting.iswebinar='true'">
                        On
                       </b-button>
                      </b-button-group>
                      <span> Webinar Mode </span>
                      <span v-if="tmpSelectedMeeting.iswebinar && tmpSelectedMeeting.iswebinar != 'false'"
                         style="padding-left:1rem;padding-right:0;">
                        Limit attendee count to
                        <b-input size="sm" class="mb-1"
                           style="max-width:4rem;display:inline-block;"
                          placeholder="limit"
                          v-model= "tmpSelectedMeeting.canreg"
                          maxlength="6"
                         > </b-input>
                      </span>
                     </b-col>
                   </b-row>

                   <b-row>
                     <b-col sm="12">
                      <b-button-group style="max-width:5rem">
                       <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="tmpSelectedMeeting.ebsval && tmpSelectedMeeting.ebsval != 'false' ? 'outline-secondary':'vxon'"
                        @click="tmpSelectedMeeting.ebsval = 'false'">
                        Off
                       </b-button>
                       <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="tmpSelectedMeeting.ebsval && tmpSelectedMeeting.ebsval != 'false' ? 'vxon':'outline-secondary'"
                        @click="tmpSelectedMeeting.ebsval = 'true'">
                        On
                       </b-button>
                      </b-button-group>
                      <span> Automatically empty room approx 1 min before meeting starts </span>
                     </b-col>                   
                   </b-row>

                   <b-row>
                     <b-col sm="12">
                      <b-button-group style="max-width:5rem">
                       <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="tmpSelectedMeeting.userem && tmpSelectedMeeting.userem != 'false' ? 'outline-secondary':'vxon'"
                        @click="TSupdate_userem('false')">
                        Off
                       </b-button>
                       <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="tmpSelectedMeeting.userem && tmpSelectedMeeting.userem != 'false' ? 'vxon':'outline-secondary'"
                        @click="TSupdate_userem('true')">
                        On
                       </b-button>
                      </b-button-group>
                      <span> Email attendee reminders </span>
                      <span v-if="tmpSelectedMeeting.userem && tmpSelectedMeeting.userem != 'false'"
                         style="padding-right:0;padding-left:0;">
                        <b-input size="sm" class="mb-1"
                           style="max-width:4rem;display:inline-block;"
                          id="inline2-form-input-rem"
                          placeholder="min"
                          v-model= "tmpSelectedMeeting.remval"
                          maxlength="6"
                         > </b-input>
                      </span>
                      <span v-if="tmpSelectedMeeting.userem != 'false'"
                          style="padding-left:0">
                          minutes before
                       </span>
                     </b-col>
                   </b-row>

                   <b-row v-if="hasCountry">
                     <b-col sm="12">
                      <b-button-group style="max-width:5rem">
                       <b-button class="mb-1" style="padding:0; width:50%;"
                        :variant="tmpSelectedMeeting.geoval ? 'outline-secondary':'vxon'"
                        @click="TSupdate_geo('')">
                        Off
                       </b-button>
                       <b-button class="mb-1" style="padding:0; width:50%"
                        :variant="tmpSelectedMeeting.geoval ? 'vxon':'outline-secondary'"
                        @click="TSupdate_geo($parent.currentUser.loc.ct)">
                        On
                       </b-button>
                      </b-button-group>
                      <span> Limit To Your Country </span>
                     </b-col>
                   </b-row>

                   <b-row>
                     <b-col cols="3">
                       <span v-if="tmpSelectedMeeting.name && tmpSelectedMeeting.start_ep && tmpSelectedMeeting.end_ep">
                         <i class="typcn typcn-tick"  @click="saveEditSelectedMeeting"
                           style="cursor:pointer;font-size:150%;color:green;"></i>
                       </span>&nbsp;&nbsp;
                       <span> 
                         <i class="typcn typcn-times"  @click="cancelEditSelectedMeeting" 
                           style="cursor:pointer;font-size:150%;color:red;"></i>
                       </span>
                     </b-col>
                   </b-row>
                 </b-card-text>

                 <b-card-text v-if="editMeetingView ==false" >
                   <b-row
                     class="bhelp-meetings" data-balloon-length="xlarge"
                     data-balloon-pos="inl-right"
                     aria-label="Manually add email addresses for desired attendess. Edit meeting details to enable 'webinar' mode to let users sign themselves up."
                     >
                     <b-col cols="6" v-if="!attUploadFile">
                       <b-form-input
                         id="input2-addUserToMeeting"
                         v-model="newMeetingUser"
                         style="padding-right:0"
                         type="text"
                         placeholder="User's email"
                         v-on:keyup='addNewUserToMeetingShim'
                       ></b-form-input>
                     </b-col>
                     <b-col cols="3" v-if="!attUploadFile && ctrl.eph_limit">
                       <b-form-input
                         id="input2-addUserBrk"
                         v-model="newMeetingUserBrk"
                         style="padding-right:0"
                         type="text"
                         placeholder="Brk#"
                         v-on:keyup='addNewUserToMeetingShim'
                       ></b-form-input>
                     </b-col>
                     <b-col cols="3" v-if="!attUploadFile">
                       <b-button size="sm" @click="addNewUserToMeeting"
                          variant="primary">
                          Add User
                       </b-button>
                     </b-col>
                     <b-col cols="9" v-if="attUploadFile">
                       <b-button class="float-right" size="sm"
                          @click="addNewUserToMeeting"
                          variant="primary">
                          Load From File
                       </b-button>
                     </b-col>
                     <b-col cols="3">
                       <b-form-file
                          style=""
                          v-model="attUploadFile" size="sm"
                          placeholder="CSV File"
                          drop-placeholder="-"
                          browse-text="-"
                          v-on:change='attUploadChanged'
                          :state="Boolean(attUploadFile)">
                       </b-form-file>
                     </b-col>
                     <b-col cols="9" v-if="false && !attUploadFile">
                       <b-button class="float-right" size="sm" 
                          @click="clearMeetingBrk"
                          variant="danger">
                          Clear Breakouts
                       </b-button>
                     </b-col>
                   </b-row>
                 </b-card-text>
                 
                 <b-table
                   striped
                   hover
                   show-empty
                   stacked="sm"
                   :fields="selectedMeetingFields"
                   :items="selectedMeeting.attendees"
                   small
                   class="bhelp-meetings" data-balloon-length="xlarge"
                   data-balloon-pos="inl-right"
                   aria-label="List of attendees. Everyone can view the meeting. Change who can join-in and participate by clicking the green check. Remove a user by clicking the red minus."
                    >
                   <template v-slot:cell(brk)="data">
                     {{ data.item.brk ? data.item.brk : "-" }}
                   </template>
                   <template v-slot:cell(can_join)="data">
                     <b-button v-if="data.item.can_join" size="sm"
                        @click="change_att_join(data.item, false)" variant="link">
                        <i class="typcn typcn-tick" style="color:green;font-size:120%"></i>
                     </b-button>
                     <b-button v-if="!data.item.can_join" size="sm"
                        @click="change_att_join(data.item, true)" variant="link">
                        <i class="typcn typcn-cancel" style="color:red;font-size:120%"></i>
                     </b-button>
                     {{ data.item.can_join ? "Can Join" : "Only Watch" }}
                   </template>
                   <template v-slot:cell(ztail)="data"> 
                     <b-button size="sm" @click="deleteUserFromMeeting(data.item)" variant="link">
                       <i class="typcn typcn-user-delete" style="color:red;font-size:120%"></i>
                     </b-button>
                   </template>
                 </b-table>
               </div>

             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-urlgen>
               URL Generation
             </b-button>
           </b-card-header>
           <b-collapse id="acc-urlgen" accordion="my-accordion" role="tabpanel"
              v-on:show="opened_urlgen">
             <b-button class="info" variant="light"> ? </b-button>
             <b-card-body>
              <b-card-text>

               <div class="alert_section" style="margin-top:0.7rem;">
                  <div class="alert_heading">
                     Configure Your Contact URL
                  </div>
                  <div class="alert_descr">
                    A short URL that can be saved as a contact or bookmark. Use the settings below to configure the behavior of the URL. You can direct visitors to your room, to a chat session, or even temporarily forward to someone else.
                  </div>
                  <div v-if="!tinyurl.exists">
                    <b-row>
                      <b-col>
                       <b-button size="sm"
                         @click="tinyurl_save"
                         variant="primary">
                          Create URL
                       </b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-if="tinyurl.exists">
                    <div class="clipcopy" style="margin: 0.5rem auto;">
                        <span ref="cptiny_url" style="font-weight:bold;font-size:0.8rem;">{{tinyurl.url}}</span>
                        <span class="material-vue" style="color:black;font-size:0.9rem;line-height:0;cursor:pointer;" @click="doCopy2Clip('cptiny_url')"> content_copy </span>
                    </div>
                    <div>
                      <div class="alert_heading">
                        Where Visitors are brought
                      </div>
                      <div class="alert_descr">
                        Select whether to bring visitors to the video conference room or the chat page after they click the link and sign in
                      </div>
                      <b-form-radio-group id="tu-loc"
                         class="ml-4"
                         v-model="edit_tinyurl.loc"
                         @change="tinyurl_changed()">
                        <b-form-radio value="room" class="input_label_cap">A/V Room</b-form-radio>
                        <b-form-radio value="chat" class="input_label_cap">Chat</b-form-radio>
                      </b-form-radio-group>
                    </div>

                    <div class="mt-2">
                      <div class="alert_heading">
                        Where Visitors sign in
                      </div>
                      <div class="alert_descr">
                        Show users the guest login page or the main login page
                      </div>
                      <b-form-radio-group id="tu-guest"
                         class="ml-4"
                         v-model="edit_tinyurl.guest"
                         @change="tinyurl_changed()">
                        <b-form-radio value="false" class="input_label_cap">Main Login Page</b-form-radio>
                        <b-form-radio value="true" class="input_label_cap">Guest Login Page</b-form-radio>
                      </b-form-radio-group>
                    </div>

                    <div class="mt-2">
                      <div class="alert_heading">
                        Forward visitors to another room
                      </div>
                      <div class="alert_descr">
                        Direct visitors to a different room if you plan to be unavailable.
                      </div>
                      <b-row style="margin:0.5rem 1.5rem">
                        <b-col v-if="edit_tinyurl.fwd" sm="3">
                          <span style="color:#ff8000;">
                            @{{ edit_tinyurl.fwd }}
                          </span>
                        </b-col>
                        <b-col v-if="!edit_tinyurl.fwd" sm="3">
                          - not forwarded -
                        </b-col>
                        <b-col sm="3" style="padding:0;">
                          <b-button size="sm"
                            style="padding: 0 0.5rem;"
                            :disabled="!edit_tinyurl.fwd"
                            @click="tinyurl_fwdclr"
                            variant="outline-danger">
                             Clear Forward
                          </b-button>
                        </b-col>
                        <b-col>
                          <search-transfer ref="tinyurl_fwdto"
                            v-on:room="tinyurl_fwdroom"
                            usestyle="top:2rem;"
                            nosearch="true"
                            placeholder="@ForwardToRoom"
                          >
                          </search-transfer>
                        </b-col>
                      </b-row>
                    </div>

                    <div class="mt-2">
                      <b-button size="sm"
                        :disabled="!tinyurl.changed"
                        @click="tinyurl_save"
                        variant="primary">
                         Save Changes
                      </b-button>
                      <b-button size="sm"
                        v-if="tinyurl.changed"
                        @click="tinyurl_cancel"
                        variant="outline-danger">
                         Cancel
                      </b-button>
                    </div>
                  </div>
               </div>

               <div class="alert_section" style="margin-top:0.7rem;">
                  <div class="alert_heading">
                     Generate Guest URLs
                  </div>
                  <div class="alert_descr">
                    Generate a temporary URL that skips login and brings a Guest directly to your room. At least one email or phone is required. Optionally send the link directly to their email and/or phone.
                  </div>
                  <b-row>
                    <b-col>
                      <label for="guest-name">
                        <span class="input_label_cap">Guest Name</span>
                      </label>
                      <b-input id="guest-name" style="font-size:0.9rem;"
                       v-model="guest.name"
                       :placeholder='guest.name_def'>
                      </b-input>
                    </b-col>
                    <b-col>
                      <label for="guest-email">
                         <span class="input_label_cap">Email</span>
                         <span class="alert_error" v-if="guest.em_tmp && !guest.em">
                            Invalid
                         </span>
                      </label>
                      <b-input id="guest-email" style="font-size:0.9rem;"
                       v-model="guest.em_tmp"
                       v-on:keyup='guest_email_keyup'
                       :placeholder='guest.em_def'>
                      </b-input>
                      <b-checkbox class="guest_checkbox"
                         :disabled="!guest.em_tmp || !guest.em"
                         v-model="guest.sendem">
                         Email URL to address
                      </b-checkbox>
                    </b-col>
                    <b-col>
                      <label for="guest-phone">
                         <span class="input_label_cap">Phone</span>
                         <span class="alert_error" v-if="guest.ph_tmp && !guest.ph">
                            Invalid
                         </span>
                      </label>
                      <b-input id="guest-phone" style="font-size:0.9rem;"
                       v-model="guest.ph_tmp"
                       v-on:keyup='guest_phone_keyup'
                       :placeholder='guest.ph_def'>
                      </b-input>
                      <b-checkbox class="guest_checkbox"
                         :disabled="!guest.ph_tmp || !guest.ph"
                         v-model="guest.sendph">
                         Send URL to phone
                      </b-checkbox>
                    </b-col>
                  </b-row>

                    <div>
                      <div class="alert_heading">
                        Where Guest is brought
                      </div>
                      <div class="alert_descr">
                        Select whether to bring this guest to the video conference room or the chat page
                      </div>
                      <b-form-radio-group id="guest-loc"
                         class="ml-4"
                         v-model="guest.loc">
                        <b-form-radio value="room" class="input_label_cap">A/V Room</b-form-radio>
                        <b-form-radio value="chat" class="input_label_cap">Chat</b-form-radio>
                      </b-form-radio-group>
                    </div>

                  <div v-if="!!guest.room_url">
                    <div class="alert_descr">
                       Below is the generated guest URL. If selected, it has also been sent to the email or phone above.
                    </div>
                    <div class="clipcopy" style="margin: 0.5rem auto;">
                        <span ref="guestroom_url" style="font-weight:bold;font-size:0.8rem;">{{guest.room_url}}</span>
                        <span class="material-vue" style="color:black;font-size:0.9rem;line-height:0;cursor:pointer;" @click="doCopy2Clip('guestroom_url')"> content_copy </span>
                    </div>
                  </div>
                  <b-row>
                    <b-col sm="4">
                     <b-button size="sm"
                       :disabled="(!guest.em && !guest.ph) || (guest.em_tmp && !guest.em) || (guest.ph_tmp && !guest.ph) || guest.disabled"
                       @click="gen_guest"
                       variant="primary">
                        Generate URL
                     </b-button>
                    </b-col>
                  </b-row>
               </div>
   
               <div class="alert_section" style="margin-top:0.7rem;">
                   <div class="alert_heading">
                      Links to your custom management pages
                   </div>
                   <div class="alert_descr">
                     You can build room management pages using our APIs. Add the URL below and click on it to open the URL and temporarily authenticate that page to access your room.
                   </div>
                   <div class="alert_error"
                     v-if="thirdp_error">
                     {{ thirdp_error }}
                   </div>
                   <b-row>
                     <b-col sm="3">
                      <b-button variant="primary" size="sm"
                        @click="thirdp_new_url"
                        :disabled="!thirdp_url"
                      >
                      Add URL
                      </b-button>
                     </b-col>
                     <b-col>
                         <b-input
                          placeholder="https://yoursite.com/path/page.html"
                          v-model.trim="thirdp_url">
                         </b-input>
                     </b-col>
                   </b-row>
                   <edit-list ref="thirdp_tab"
                     v-on:setup="thirdp_setup"
                     v-on:action="thirdp_action"
                     >
                   </edit-list>
               </div>
 
              </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-chat >
               Configure Chat
             </b-button>
           </b-card-header>
           <b-collapse id="acc-chat" accordion="my-accordion" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('chat')"> ? </b-button>
             <b-card-body>
              <b-card-text>
                <div style="font-weight:bold;text-align:left;">
                  Chat Mode
                </div>
                <b-form-group>
                  <b-form-radio v-model="ctrl.chat.mode" name="radio1" value="any" @change="wss_ctrl_chat()">Everyone can Message Moderators, Individuals, and Broadcast to the Room</b-form-radio>
                  <b-form-radio v-model="ctrl.chat.mode" name="radio1" value="limited" @change="wss_ctrl_chat()">Everyone can Message Moderators, Individuals; Only Moderators can Broadcast to the Room</b-form-radio>
                  <b-form-radio v-model="ctrl.chat.mode" name="radio1" value="limited2" @change="wss_ctrl_chat()">Everyone can Message Moderators; Only Moderators can Message Individuals, Broadcast to the Room</b-form-radio>
                  <b-form-radio v-model="ctrl.chat.mode" name="radio1" value="disabled" @change="wss_ctrl_chat()">Chat is disabled</b-form-radio>
                </b-form-group>
                <div> <span style="font-weight:600"> Host-only commands </span> <span style="color:#ff0000">$alert</span> Broadcast alert message to everyone's main window. </div>
                <div> <span style="font-weight:600"> General commands </span> <span style="color:#ff0000">:emojiname:</span> replaces word with emoji (e.g. check, money, rocket, ex, happy, zap) </div>
              </b-card-text>
              <b-card-text style="">
                <div style="font-weight:bold;text-align:left;">
                   Welcome message to show new arrivals
                </div>
                <auto-text-area size="sm"
                  v-model.trim="ctrl.chat.wmsg"
                  maxlength="80"
                  placeholder="e.g. How can we help you?">
                </auto-text-area>
                <b-button v-if="(ctrl_orig_wmsg || ctrl.chat.wmsg) && ctrl.chat.wmsg != ctrl_orig_wmsg"
                  size="sm" style="padding: 0 0.5rem"
                  @click="wss_ctrl_chat()"
                  variant="primary">
                  Update
                </b-button>
              </b-card-text>
              <b-card-text style="">
                <div style="font-weight:bold;text-align:left;">
                   Prompt guests at login for more information
                </div>
                <div style="font-size:0.9rem;text-align:left;">
                   This will be automatically sent to chat.
                </div>
                <auto-text-area size="sm"
                  v-model.trim="ctrl.gqcfg.prompt"
                  maxlength="80"
                  placeholder="e.g. What would you like to know?">
                </auto-text-area>
                <b-button v-if="(ctrl_orig_prompt || ctrl.gqcfg.prompt) && ctrl.gqcfg.prompt != ctrl_orig_prompt"
                  size="sm" style="padding: 0 0.5rem"
                  @click="wss_ctrl_chat()"
                  variant="primary">
                  Update
                </b-button>
              </b-card-text>
              <b-card-text style="border-top:solid 1px black;">
                <b-row>
                  <b-col style="font-weight:bold;text-align:right;">
                    Delete All Chats
                  </b-col>
                  <b-col>
                    <confirm-del
                      timeout="2000"
                      :clear="chat_btn_clear"
                      v-on:confirmed-delete="chat_delete_all()">
                    </confirm-del>
                    <div v-if="chat_del_msg"
                     style="font-size:0.8rem;">
                     {{chat_del_msg}}
                    </div>
                  </b-col>
                </b-row>
              </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-polling>
               Polling
             </b-button>
           </b-card-header>
           <b-collapse id="acc-polling" accordion="my-accordion" role="tabpanel"
              v-on:show="refreshPollList">
             <b-card-body>
              <b-card-text>

                 <div class="mb-3"  v-if="isPollListView == true">
                   <b-button size="sm" @click="refreshPollList"
                     variant="primary">
                     Refresh
                   </b-button>
                   <b-button size="sm" @click="newPollQuest"
                     variant="primary">
                     New Question
                   </b-button>
                   <b-table
                      striped
                      show-empty
                      stacked="sm"
                      :fields="pollQuestFields"
                      :items="pollQuests"
                      small
                   >
                     <template v-slot:cell(q)="data"> 
                       <a @click.prevent="openPollQuest(data.item)" href=""> 
                        {{ data.value.substring(0,50) }}
                       </a>
                     </template>
                     <template v-slot:cell(total)="data"> 
                        {{ data.value }}
                     </template>
                     <template v-slot:cell(ctrl)="data">
                       <b-button-group class="float-right">
                         <b-button size="sm" class="tab-btn"
                           v-if="!data.item.active"
                           @click="enableQuest(data.item,true)"
                           >
                           Enable
                         </b-button>
                         <b-button size="sm" class="tab-btn"
                           v-if="data.item.active"
                           @click="enableQuest(data.item,false)"
                           >
                           Disable
                         </b-button>
                       </b-button-group>
                     </template>
                   </b-table>
                 </div>

                 <div class="mb-3"  v-if="isPollListView == false">
                   <b-button-group>
                     <b-button size="sm" @click="gotoPollListView" variant="outline-primary">
                        &lsaquo;&nbsp; Question List
                     </b-button>
                     <b-button size="sm"
                       @click="savePollQuest()" variant="primary">
                       Save
                     </b-button>
                     <b-button size="sm"
                       :disabled="!pollHasData"
                       @click="showResult('pie')" variant="primary">
                       PieChart
                     </b-button>
                     <b-button size="sm"
                       @click="pollReset()" variant="warning">
                       Reset
                     </b-button>
                   </b-button-group>
                   <b-button-group class="float-right">
                     <b-button size="sm"
                       @click="confirmDeleteQuest()" variant="danger">
                       Delete
                     </b-button>
                   </b-button-group>
                   <b-input size="sm" class="mb-1"
                      placeholder="Type your question"
                         v-model= "tmpSelectedQuest.q"
                         :input-attr="{ required: true }"
                         maxlength=60
                   ></b-input>
                   <b-row>
                     <b-col sm="8">
                       <b-input size="sm" class="mb-1"
                         placeholder="Answer/Option #1 (required)"
                            v-model= "tmpSelectedQuest.a[0]"
                            :input-attr="{ required: true }"
                            maxlength=60
                       ></b-input>
                     </b-col>
                     <b-col sm="4">
                        {{ tmpSelectedQuest.cnt[0] }}
                     </b-col>
                   </b-row>
                   <b-row>
                     <b-col sm="8">
                      <b-input size="sm" class="mb-1"
                        placeholder="Answer/Option #2 (required)"
                           v-model= "tmpSelectedQuest.a[1]"
                           :input-attr="{ required: true }"
                           maxlength=60
                      ></b-input>
                     </b-col>
                     <b-col sm="4">
                        {{ tmpSelectedQuest.cnt[1] }}
                     </b-col>
                   </b-row>
                   <b-row>
                     <b-col sm="8">
                       <b-input size="sm" class="mb-1"
                         placeholder="Answer/Option #3 (optional)"
                            v-model= "tmpSelectedQuest.a[2]"
                            maxlength=60
                       ></b-input>                    
                     </b-col>
                     <b-col sm="4">
                        {{ tmpSelectedQuest.cnt[2] }}
                     </b-col>
                   </b-row>
                   <b-row>
                     <b-col sm="8">
                       <b-input size="sm" class="mb-1"
                         placeholder="Answer/Option #4 (optional)"
                            v-model= "tmpSelectedQuest.a[3]"
                            maxlength=60
                       ></b-input>                    
                     </b-col>
                     <b-col sm="4">
                        {{ tmpSelectedQuest.cnt[3] }}
                     </b-col>
                   </b-row>
                   <b-row>
                     <b-col sm="8">
                       <b-input size="sm" class="mb-1"
                         placeholder="Answer/Option #5 (optional)"
                            v-model= "tmpSelectedQuest.a[4]"
                            maxlength=60
                       ></b-input>                    
                     </b-col>
                     <b-col sm="4">
                        {{ tmpSelectedQuest.cnt[4] }}
                     </b-col>
                   </b-row>
                   <b-row>
                     <b-col>
                       <canvas id="pollchart"> </canvas>
                     </b-col>
                   </b-row>
                 </div>

              </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-moderate >
               <span> Moderators ({{ currentModerators.length }}) </span>
             </b-button>
           </b-card-header>
           <b-collapse id="acc-moderate" accordion="my-accordion" role="tabpanel">
             <b-button class="info" variant="light" @click="showinfo('moderators')"> ? </b-button>
             <b-card-body>
              <b-card-text>
                  <div v-if="!ctrl.adhoc" class="mt-1">
                    Moderators Initially Join As
                  </div>
                  <b-form-select v-if="!ctrl.adhoc" class="mb-3"
                   v-model="ctrl.mod_kind" :options="modKinds"
                   @change="change_room_ctrl()">
                  </b-form-select>
                  <b-form @submit.prevent="onSubmitAddModeratingUser" class="mb">
                  <b-button size="sm" type="submit" variant="primary"
                    :disabled="!moderatingUser">
                    <span> Add to Room Moderators </span>
                  </b-button>
                  <b-form-group
                    id="input-group-moderatingUser2"
                    label-for="input-Input">
                    <b-form-input
                      class="mb-3"
                      id="input-moderatingUser2"
                      type="text"
                      v-model.trim="moderatingUser"
                      required
                      placeholder="Email address of a user to add."
                    ></b-form-input>
                  </b-form-group>
                  <h6 v-if="currentModerators && currentModerators.length"> Moderators: </h6>
                  <h6 v-if="!currentModerators || !currentModerators.length"> No moderators have been added. </h6>
                  <div class="mb-3">
                    <b-button v-for="item in currentModerators"
                       @click="confirmModeratorDelete(item)">
                         <span>{{ item.em }}</span> &nbsp;
                         <b-badge variant="light">X</b-badge>
                    </b-button>
                  </div>
                </b-form>
              </b-card-text>
                <b-card-text
                  style="margin-top:2rem;padding:0 20px;border-top:solid 1px black;"
                >
                  <b-row>
                    <b-col>
                      <label for="ajx-in"
                        style="display:inline-block;margin-right:1rem;"
                       >
                       <span
                         :style="ctrl.ajx?'color:orange;font-weight:bold;':'color:#909090;text-decoration:line-through;'"
                         >
                         Custom Participant Limit
                       </span>
                      </label>
                      <b-input
                        style="display:inline-block;max-width:6rem;"
                        input-id="ajx-in"
                        v-model.trim="ctrl.ajx"
                        placeholder="Limit"
                        v-on:change="wss_ctrl_access"
                        maxlength="6"
                      >
                      </b-input>
                      <span>
                        out of {{ ctrl.joined_max }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="aix-in"
                        style="display:inline-block;margin-right:1rem;"
                       >
                       <span
                         :style="ctrl.aix?'color:orange;font-weight:bold;':'color:#909090;text-decoration:line-through;'"
                         >
                         Custom Cast Q&A Limit
                       </span>
                      </label>
                      <b-input
                        style="display:inline-block;max-width:6rem;"
                        input-id="aix-in"
                        v-model.trim="ctrl.aix"
                        placeholder="Limit"
                        v-on:change="wss_ctrl_access"
                        maxlength="6"
                      >
                      </b-input>
                      <span>
                        out of {{ ctrl.joined_max }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label for="avx-in"
                        style="display:inline-block;margin-right:1rem;"
                       >
                       <span
                         :style="ctrl.avx?'color:orange;font-weight:bold;':'color:#909090;text-decoration:line-through;'"
                         >
                         Custom Viewing Limit
                       </span>
                      </label>
                      <b-input
                        style="display:inline-block;max-width:6rem;"
                        input-id="avx-in"
                        v-model.trim="ctrl.avx"
                        placeholder="Limit"
                        v-on:change="wss_ctrl_access"
                        maxlength="6"
                      >
                      </b-input>
                      <span>
                        out of {{ ctrl.viewed_max }}
                      </span>
                    </b-col>
                  </b-row>
                </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>


     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod && !ctrl_eph" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-transcript>
               Transcripts
             </b-button>
           </b-card-header>
           <b-collapse id="acc-transcript" accordion="my-accordion" role="tabpanel"
             v-on:show="clicked_transcript">
             <b-card-body>
               <b-card-text>
                   <div class="alert_error"
                     v-if="tscript_error">
                     {{ tscript_error }}
                   </div>
                   <edit-list ref="tscript_tab"
                     per_page="5"
                     v-on:setup="tscript_tabcreate"
                     v-on:action="tscript_action"
                     >
                   </edit-list>
               </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-modal id="bv-tscript-show" size="lg" hide-footer>
       <div v-for="txt in cur_tscript_text">
         {{ txt }}
       </div>
     </b-modal>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-spviews >
                Special Purpose Panels
             </b-button>
           </b-card-header>
           <b-collapse id="acc-spviews" accordion="my-accordion" role="tabpanel">
             <b-card-body>
              <b-card-text>
                <b-button @click="openHall()">
                  Panelist Scheduler
                </b-button>
                <b-button @click="openTruck()">
                  Truck
                </b-button>
              </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card no-body v-if="role_is_mod" class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-embed >
               Embed
             </b-button>
           </b-card-header>
           <b-collapse id="acc-embed" accordion="my-accordion" role="tabpanel">
             <b-card-body>
              <b-card-text>
                 <div> Javascript query to programmatically check room state </div>
                 <b-button @click="gen_embedq_json">
                    JSON Query
                 </b-button>
                 <div> HTML image tag that selects between two images based on room state </div>
                 <b-input type="url"
                    placeholder="Image URL to use when LIVE"
                    maxlength="200"
                    v-model="embed.live_url">
                 </b-input>
                 <b-input type="url"
                    placeholder="Image URL to use when OFFLINE"
                    maxlength="200"
                    v-model="embed.off_url">
                 </b-input>
                 <b-button @click="gen_embedq_live" :disabled="!embed.live_url && !embed.off_url">
                    Dynamic Image URL
                 </b-button>
                 <code><pre id='embed_result'> </pre></code>
              </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
     </b-row>

    </b-container>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import DatePicker from "vue2-datepicker";
import vx_api from "../vuemix";
import store from "../store";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import UploadImage from "../components/UploadImage";
import ConfirmDel from "../components/ConfirmDel";
import AutoTextArea from "../components/AutoTextArea";
import SearchTransfer from "../components/SearchTransfer";
import InputSub from "../components/InputSub";
import EditList from "../components/EditList";
import PhoneVerify from "../components/PhoneVerify";
import { format, getUnixTime } from 'date-fns';
import { CSV } from '../csv.js'

export default {
  name: "settings",
  components: {
    DatePicker,
    VueSlider,
    UploadImage,
    ConfirmDel,
    AutoTextArea,
    SearchTransfer,
    InputSub,
    EditList,
    PhoneVerify
  },
  created() {
    let vue = this;
  },
  mounted() {
    let vue = this;
    delete window.ctrl_tid;
    $("body").addClass("setbackground");
    vue.presLayouts = window.vx.user.presLayouts;
    vue.audLayouts = window.vx.user.audLayouts;
    vue.setup_room(vue, window.vx, vue.$router.currentRoute.params.acc, vue.$router.currentRoute.params.uid);
  },
  beforeDestroy() {
    let vue = this;
  },
  data() {
    return {
      dfunx: getUnixTime,
      room_name: "",
      site_url: process.env.VUE_APP_SITE_URL,
      titleInfo: { title: "", room: "()" },
      titleNickName: "()",
      ctrl_values: ["open", "closed", "locked"],
      ctrl_marks: {
        open: {
          label: "Open",
          labelStyle: {
            color: "green"
          }
        },
        closed: {
          label: "Closed",
          style: {
            display: "block",
            backgroundColor: "#ffff88"
          },
          labelStyle: {
            color: "orange"
          }
        },
        locked: {
          label: "Locked",
          style: {
            display: "block",
            backgroundColor: "#ff8888"
          },
          labelStyle: {
            color: "red"
          }
        }
      },
      slider_process: dotsPos => [
        [0, dotsPos[0] < 51 ? dotsPos[0] : 0, { backgroundColor: "orange" }],
        [0, dotsPos[0] < 51 ? 0 : dotsPos[0], { backgroundColor: "red" }]
      ],
      role_is_mod: false,
      role_is_notmod: false,
      role_is_owner: false,
      tnImgProps:{center:true, fluid: true,},
      slate: {
        url: "",
        mode: "off",
      },
      imgs: {
        tnurl:window.vx_user_tn(),
      },
      req_cats: ["How To","Buy Sell","Real Estate","Finance","Education","Careers","Software","IT", "Fitness","Marketing","Medicine","Automotive","Household","Enterprise"],
      canhide: [{n:"home", d:"Home",t:"Home Button"},
                {n:"search", d:"Search",t:"Audience Search Box"},
                {n:"breakout", d:"Breakout",t:"Breakout controls"},
                {n:"live", d:"Live",t:"Live and Rewind"},
                {n:"auto", d:"Audio-Only",t:"Auto and Audio-Only"},
                {n:"audience", d:"Audience",t:"Host / Audience View Toggle"},
                {n:"onlywatch", d:"Only Watch",t:"Allow users to watch and not participate."},
                {n:"enablevid", d:"Enable Video",t:"Show 'Turn On Camera' before joining."},
               ],
      ctrl: {
        dname: "",
        url: "",
        descr: "",
        cat:[],
        joined_max: 0,
        viewed_max: 0,
        can_view: null,
        can_join: null,
        ajx: null,
        aix: null,
        avx: null,
        can_contact: null,
        eph: 0,
        eph_limit: 0,
        eph_strict: false,
        hide: [],
        noa_msg: null,
        adhoc: null,
        pub: null,
        ulog: null,
        rlogo: "",
        rlogosm: "",
        rback: "",
        rbannland: "",
        rbannport: "",
        chat: {
          mode: null,
          wmsg: "",
        },
        gqcfg: {
          en: false,
          prompt: "",
        },
        alert: {phone:[]},
      },
      ctrl_orig_wmsg: "",
      ctrl_orig_prompt: "",
      ctrl_truckfocus: false,
      ctrl_veryfirsttime: true,
      ctrl_state: null,
      ocsListFields: [
        { key: "rp", label: "Repeats" },
        { key: "op", label: "Open Between" },
        { key: "cl", label: "Next On" },
        { key: "ac", label: "Enabled" },
        { key: "ctrl", label:"" },
      ],
      ocsList: [],
      ocs_edit: {
        op: null,
        cl: null,
        rp: "none"
      },
      alertEmails: [],
      edit_alert: {init:true,
                   phone: [],
                   em: "",
                   dbell: "false",
                   sms:"-",
                   contact:"-",
                   vmail: "false",
                   error:"",
                   saving:false,
                   tested_contact: false,
                   tested_alert: false,
                   noa_msg: "",
                   },
      vmailFields: [
        { key: "tm", label: "Date" },
        { key: "dname", label: "Name" },
        { key: "em", label: "Email" },
        { key: "vurl", label: "" },
      ],
      vmails: [],
      vmails_tab: [],
      vmail_start_key: "",
      vmail_cur_page: 0,
      vmail_max_page: 0,
      vmail_stats: {
         playing: false,
         elapsed: 0,
         duration: 0,
         str: "",
         fwd_to_room: "",
         fwd_pending: false,
         fwd_err: "",
      },

      edit_anote: {enabled:false,
                   mode: "all",
                   prompt_enabled: "false",
                   prompt_sec: 0,
                   nameq_enabled: "false",
                   callb_enabled: "false",
                   cat_enabled: "false",
                   cats: [],
                   saving: false,
                   error: "",
      },
      anote: {enabled:false,
              mode:"all",
              prompt_sec: 0,
              nameq_enabled: false,
              callb_enabled: false,
              cat_enabled: false,
              cats:[],
      },
      add_anote: {
              cat: "",
              error: "",
      },
      add_acat: {
              label: "",
              error: "",
      },
      acatFields:[
        { key: "label", label: "Label" },
        { key: "cat",  label: "Department / @Room" },
        { key: "ctrl", label: "" },
      ],
      arrivalFields:[
        { key: "room", label: "Room" },
        { key: "cat",  label: "Department" },
        { key: "ctrl", label: "Direct Only" },
      ],
      arrivalItems:[],

      ctrl_eph: false,
      embed: {
        live_url:"",
      },
      moderatingUser: "",
      currentModerators: [],
      uar_search: "",
      uar_kind: null,
      uar_all: [],
      uar_page: 1,
      uar_start: 0,
      uar_per: 6,
      uar_stats: {},
      userFilt: {part:{v:"secondary"},view:{v:"secondary"},wait:{v:"secondary"},off:{v:"secondary"},blk:{v:"secondary"},mod:{v:"secondary"}},
      userStats: {},      
      usersAtRoom: [],
      usersAtRoomFields: [
        { key: "uid", label: "User" },
        { key: "rank", label: "" },
        { key: "status", label: "" },
        { key: "can_view", label: "Can View" },
        { key: "can_join", label: "Can Join" },
        { key: "kind", label: "Presenter?" }
      ],
      presLayouts: [],
      presLayoutSel: null,
      presLayoutSelName: null,
      audLayouts: [],
      audLayoutSel: null,
      modKinds: [{value:"mod", text:"Voice Only"},{value:"aud", text:"Audience"},{value:"prs", text:"Presenter"}],
      chat_btn_clear: 0,
      chat_del_cnt: 0,
      chat_del_msg: "",
      isPollListView: true,
      pollHasData: false,
      pollQuestFields: [
        { key: "q", label: "Question" },
        { key: "total", label: "Votes" },
        { key: "ctrl", label: "" },
      ],
      pollQuests: [],
      tmpSelectedQuest: {
        q: "",
        active: false,
        a:["","","","",""],
        cnt:[0,0,0,0,0],
      },
      isMeetingsListView: true,
      meetingsRoom: [],
      selectedMeeting:{},
      tmpSelectedMeeting: {
         name: "",
         start_ep: 0, end_ep: 0,
         iswebinar: "false",
         geo: {ct:""},
         geoval: "",
         canreg: 0,
         url: "",
         descr: "",
         ebsval: "false",
         userem: "false",
         remval: 15,
         isgroup: false,
         inactive: false,
      },
      infinity: 2111222333,
      selectedMeetingFields: [
          { key: "em", label: "Email" },
          { key: "brk", label: "Brk #" },
          { key: "can_join", label: "" },
          { key: "ztail", label: ""},
      ],
      meetingsRoomFields: [
          { key: "name", label: "Name" },
          { key: "start_ep", label: "Start" },
          { key: "end_ep", label: "End" },
          { key: "attendees", label: "Invitees" },
      ],
      meetingsRoomFieldsInv: [
          { key: "name", label: "Name" },
          { key: "start_ep", label: "Start" },
          { key: "end_ep", label: "End" },
      ],
      attUploadFile: null,
      roomWebinars: [],
      roomWebinarFields: [
          { key: "isreg", label: ""},
          { key: "name", label: "Name" },
          { key: "start_ep", label: "Start" },
          { key: "end_ep", label: "End" },
          { key: "geo", label: "" },
      ],
      newMeetingUser:"",
      newMeetingUserBrk:"",
      emailInviteText:"",
      keys: {
        expire: new Date(),
        valid_at: new Date(),
        private_allow_all: true,
        private_allow_specific: "",
        cat_nm: store.get("room").name
      },
      editMeetingView: false,
      generated_keys: [],
      added_room_keys: [],
      addKeyInput: "",
      setUserName: "",
      rtmpURL: "",
      rtmpKEY: "",
      arcTITLE: "",
      spawn:{rooms:[], expires:0, cnt:""},
      admin_ctrl: {
        viewed_max: 0,
        joined_max: 0,
        eph_limit: 0,
        o_em: "",
        o_dname: "",
        o_uid: "",
        email_bad: 0,
        enable_desk: false,
        err: "",
      },
      guest: {
        room: "",
        room_def: "",
        em: "",
        em_tmp: "",
        em_def: "name@domain.com",
        ph: "",
        ph_tmp: "",
        ph_def: "15551234567",
        name: "",
        name_def: "Guest Name",
        loc: "room",
        expire: 3600,
        disabled: false,
        room_url: "",
      },
      tinyurl: {
        exists: false,
        changed: false,
      },
      edit_tinyurl: {
        loc: "room",
        guest: "false",
        fwd: "",
      },
      thirdp_url: "",
      thirdp_error: "",
      cur_tscript_text: [],
      tscript_error: "",
    };
  },
  watch: {
    keys: {
      handler(newVal, oldVal) {
        if (
          newVal.private_allow_all ||
          newVal.private_allow_specific == false
        ) {
          this.keys.private_allow_specific = "";
          this.generated_keys = [];
        }
      },
      deep: true
    },
    $route(to, from) {
      // eslint-disable-next-line
      console.log("watch:" + from.params.uid + " " + to.params.uid);
      this.setup_room(this, window.vx, to.params.acc, to.params.uid);
    },
  },
  methods: {
    setup_room: function(vue, vx, room_acc, room_name) {
      //console.log(room_acc+":"+room_name);
      vue.$parent.canShowStats = false;
      vue.titleInfo.title = "";
      vue.titleInfo.room = "()";
      vue.ctrl.dname = "";
      window.vx_set_room(vx, room_acc, room_name, "settings");
      if (vx.room.ephidx) {
         /* Settings only exists for main room */
         vue.$router.push({name: 'settings', params: {uid: vx.room.main_room} });
      }
      if (vx.room.name) {
        vue.titleInfo.room = vx.room.name;
        vue.titleInfo.title = "";
        vue.room_name = vx.room.name;
        vue.usersAtRoom = [];
        vue.uar_all = [];
        vue.tinyurl.exists = false;
        vue.ctrl.can_view = null;
        vue.ctrl.can_join = null;
        vue.ctrl.chat.mode = null;
        vue.ctrl.chat.wmsg = "";
        vue.ctrl.gqcfg = {en:false, prompt:""};
        vue.ctrl_state = null;
        vue.ctrl.eph = 0;
        vue.ctrl.eph_limit = 0;
        vue.ctrl.eph_strict = false;
        vue.ctrl.eph_mode = "open";
        vue.ctrl.hide = [];
        vue.slate.url = "";
        vue.slate.mime = "";
        vue.slate.mode = "off";
        vue.ctrl.rlogo = "";
        vue.ctrl.rlogosm = "";
        vue.ctrl.rback = "";
        vue.ctrl.rbannland = "";
        vue.ctrl.rbannport = "";
        vue.ctrl.cast = {};
        vue.ctrl.noa_msg = null;
        vue.ctrl.can_contact = false;
        vue.ctrl.alert = {phone:[]};
        vue.presLayoutSel = null;
        vue.presLayoutSelName = null;
        vue.audLayoutSel = null;
        vue.role_is_mod = false;
        vue.role_is_notmod = false;
        vue.role_is_owner = false;
        vue.currentModerators = [];
        window.wss_open(vx, {
          acc: vx.room.acc,
          room: vx.room.name,
          uid: vx.user.id,
          routes_id: "settings",
          routes: {
            auth_me: function(msg) {
              if (msg.data == "denied") {
                 vue.$parent.signUserOut("", "You have been signed out", "warning");
                 return;
              }
              if (window.is_my_room(window.vx)) {
                window.wss_send(vx, "auth_room", {
                  cred: vx.user.creds["myroom"]
                });
              } else {
                window.wss_send(vx, "auth_room", {});
              }
            },
            auth_room: vue.wss_auth_room,
            list_user: vue.wss_list_user,
            list_room: vue.wss_list_room,
            room_ctrl: vue.wss_room_ctrl,
            room: vue.wss_room,
            new_conn: vue.wss_new_conn,
            get_meetings: vue.wss_get_meetings,
            set_meetings: vue.wss_set_meetings,
            get_regmeetings: vue.wss_get_regmeetings,
            regmeeting: vue.wss_regmeeting,
            spawn_ephroom: vue.wss_spawn_ephroom,
            list_ephroom: vue.wss_list_ephroom,
            poll: vue.wss_poll,
          }
        });
      }
    },
    wss_auth_room: function(msg) {
      if (msg.data != "ok") {
        return;
      }
      /* Info about our access to this room */
      window.wss_send(window.vx, "list_user", {});
      /* Info about who is in/around our room */
      this.refresh_users();
      /* This room's control settings */
      this.refresh_ctrl();
      this.get_all_meetings();
      this.get_ephrooms();
      window.wss_send(window.vx, "cfg_remote", {set_conn:{disabled: true}});
    },
    build_user_record: function(it) {
        if (it.last_key) { return null; }
        let u = {};
        u.uid = it.uid;
        u.dname = it.dname;
        u.kind = it.kind;
        u.can_view = false;
        u.can_view_isfixed = false;
        u.can_join = false;
        u.can_join_isfixed = false;
        u.cids = it.cids;
        u.rank = (it.via == vx.room.acc) ? "" : ("<"+it.via+">");

        if (it.roles) {
          if (it.roles.can_view) {
            u.can_view = true;
          }
          if (it.roles.can_join) {
            u.can_join = true;
          }
          if (it.roles.is_owner) {
            u.is_owner = true;
            u.is_mod = true;
            u.rank = "owner";
            u.can_view_isfixed = true;
            u.can_join_isfixed = true;
          } else if (it.roles.is_mod) {
            u.is_mod = true;
            u.rank = "moderator";
            u.can_view_isfixed = true;
            u.can_join_isfixed = true;
          }
        }
        
        u.joined = false;
        if (it.kd) {
          u.joined = true;
          if (it.kind == "prs") {
            u.status = "presenter";
          } else if (it.kind == "inl") {
            u.status = "in line";
          } else {
            u.status = "audience";
          }
        } else if (u.can_view && u.cids > 0) {
          u.status = "watching";
        } else if (u.can_view && u.cids == 0) {
          u.status = "offline";
        } else if (u.cids > 0) {
          if (it.blklist) {
            u.status = "blacklisted";
          } else {
            u.status = "waiting outside";
          }
        } else {
          /* Still streaming but long since left room */
           return;
        }
        return u;
    },
    wss_list_user: function(msg) {
      let vue = this;
      if (msg.data == "denied") {
        vue.role_is_notmod = true;
        return;
      }
      if (msg.data.uid == vx.user.id) {
        /* FOR SELF */
        let is_notmod = true;
        if (msg.data && msg.data.roles) {
          let r = msg.data.roles;
          if (r.is_mod !== undefined) {
            vue.role_is_mod = r.is_mod;
            is_notmod = !r.is_mod;
          }
          if (r.is_owner !== undefined) {
            vue.role_is_owner = r.is_owner;
          }
          if (r.is_owner) {
            vue.titleInfo.title = "Your room";
            this.$parent.canShowStats = true;
          } else if (r.is_adhoc) {
            vue.titleInfo.title = "Ad hoc room";
            this.$parent.canShowStats = true;
          } else if (r.is_mod) {
            vue.titleInfo.title = "A room you moderate";
            this.$parent.canShowStats = true;
          } else {
            vue.titleInfo.title = "You are visiting";
          }
        }
        vue.role_is_notmod = is_notmod;
      } else {
        let newu = vue.build_user_record(msg.data);
        if (newu) {
          let found = false;
          vue.uar_all.forEach(function(u) {
            if (u.uid == newu.uid) {
              u.can_view = newu.can_view;
              u.can_join = newu.can_join;
              found = true;
            }
          });
          if (!found) {
            vue.uar_all.push(newu);
            vue.filter_users();
          }
        }
      }
    },
    refresh_users: function(delay) {
      let vue = this;
      if (vue.tid_uref) { return; }
      vue.tid_uref = setTimeout(function() {
         delete vue.tid_uref;
         let filt;
         if (vue.uar_kind || vue.uar_search) {
           filt = {};
           filt.name = vue.uar_search;
           if (vue.uar_kind == "mod") {
             filt.mod = true;
           } else {
             filt.kind = vue.uar_kind;
           }
         }
         window.wss_send(window.vx, "list_room",
            {all:true, filt:filt,
             limit:vue.uar_per, start_idx:vue.uar_start});
      }, (delay || 100));
    },
    user_filter_changed: function() {
       let vue = this;
       window.clearTimeout(vue.tid_uref);
       delete vue.tid_uref;
       vue.refresh_users(1000);
    },
    user_filter_sel: function(kind) {
       let vue = this;
       if (vue.userFilt[vue.uar_kind]) {
          vue.userFilt[vue.uar_kind].v = "secondary";
       }
       if (vue.uar_kind != kind) {
         vue.uar_kind = kind;
         vue.userFilt[kind].v = "warning";
       } else {
         /* Toggle off */
         vue.uar_kind = "";
       }
       window.clearTimeout(vue.tid_uref);
       delete vue.tid_uref;
       vue.refresh_users(100);
    },
    user_page_prev: function() {
      let vue = this;
      if (vue.uar_page <= 1) {
        vue.uar_page = 1;
        vue.uar_start = 0;
      } else {
        vue.uar_page --;
        vue.uar_start -= vue.uar_per;
        if (vue.uar_start <= 0) {
          vue.uar_start = 0;
          vue.uar_page = 1;
        }
        vue.refresh_users(100);
      }
    },
    user_page_next: function() {
      let vue = this;
      if (vue.usersAtRoom.length < vue.uar_per) {
        return;
      } else {
        vue.uar_page ++;
        vue.uar_start += vue.uar_per;
        vue.refresh_users(100);
     }
    },
    refresh_ctrl: function(delay) {
      let vue = this;
      if (vue.tid_cref) { return; }
      vue.tid_cref = setTimeout(function() {
         delete vue.tid_cref;
         window.wss_send(window.vx, "get_room_ctrl", {});
      }, (delay || 100));
    },
    wss_new_conn: function(msg) {
      let vue = this;
      vue.refresh_users(2000);
      vue.refresh_ctrl(2000);
    },
    wss_room: function(msg) {
      let vue = this;
      if (msg && msg.data) {
         if (msg.data.k && msg.data.k == "user_joined" && msg.data.uid) {
           vue.refresh_users(2000);
         } else if (msg.data.k && msg.data.k == "user_exited" && msg.data.uid) {
           vue.refresh_users(2000);
         } else if (msg.data.k && msg.data.k == "user_raised" && msg.data.uid) {
           vue.refresh_users(2000);
         } else if (msg.data.k && msg.data.k == "user_lowered" && msg.data.uid) {
           vue.refresh_users(2000);
         }
      }
    },
    wss_list_room: function(msg) {
      let vue = this;
      let list = [];
      if (msg.data == "denied") {
        return;
      }
      msg.data.forEach(function(it) {
        if (it.last_key || it.stats) {
          vue.uar_stats = it.stats || {};
          return;
        }
        let u = vue.build_user_record(it);
        if (u) {
          list.push(u);
        }
      });
      vue.uar_all = list;
      vue.filter_users();
    },
    filter_users: function() {
      let vue = this;
      vue.userStats = vue.uar_stats;
      if (vue.userStats.noop) {
         vue.userStats.all -= vue.userStats.noop;
      }
      vue.usersAtRoom = vue.uar_all.filter(function(u) {
         return true;
      });
    },
    noaMsgChanged: function() {
      let vue = this;
      vue.change_room_ctrl();
    },
    adhocSet: function(val) {
      let vue = this;
      if (vue.ctrl.adhoc && (!val || val == "false")) {
         vue.ctrl.adhoc = false;
         vue.change_room_ctrl();
      } else if (!vue.ctrl.adhoc && (val && val != "false")) {
         vue.ctrl.adhoc = true;
         vue.change_room_ctrl();
      }
    },
    ulogSet: function(val) {
      let vue = this;
      if (vue.ctrl.ulog && (!val || val == "false")) {
         vue.ctrl.ulog = false;
         vue.wss_ctrl_access();
      } else if (!vue.ctrl.ulog && (val && val != "false")) {
         vue.ctrl.ulog = true;
         vue.wss_ctrl_access();
      }
    },
    autoRaiseSet: function(val) {
      let vue = this;
      if (vue.ctrl.auto_raise && (!val || val == "false")) {
         vue.ctrl.auto_raise = false;
         vue.change_room_ctrl();
      } else if (!vue.ctrl.auto_raise && (val && val != "false")) {
         vue.ctrl.auto_raise = true;
         vue.change_room_ctrl();
      }
    },
    ctrlPubSet: function(val) {
      let vue = this;
      if (vue.ctrl.pub == val) { return; }
      vue.ctrl.pub = val;
      vue.change_room_ctrl();
    },
    hide: function(val) {
      let vue = this;
      val = (""+val).toLowerCase();
      if (vue.ctrl.hide.includes(val)) {
        vue.ctrl.hide = vue.ctrl.hide.filter(function(t) {
          if (t == val) { return false; }
          return true;
        });
      } else {
        vue.ctrl.hide.push(val);
      }
      vue.change_room_ctrl();
    },
    prsonlySet: function(val) {
      let vue = this;
      if (vue.ctrl.prsonly && (!val || val == "false")) {
         vue.ctrl.prsonly = false;
         vue.change_room_ctrl();
      } else if (!vue.ctrl.prsonly && (val && val != "false")) {
         vue.ctrl.prsonly = true;
         vue.change_room_ctrl();
      }
    },
    privmodeSet: function(val) {
      let vue = this;
      if (vue.ctrl.privmode && (!val || val == "false")) {
         vue.ctrl.privmode = false;
         vue.change_room_ctrl();
      } else if (!vue.ctrl.privmode && (val && val != "false")) {
         vue.ctrl.privmode = true;
         vue.change_room_ctrl();
      }
    },
    change_eph_mode: function(a,b) {
      let vue = this;
      if (!window.ctrl_tid) {
        window.ctrl_tid = setTimeout(function(){
          delete window.ctrl_tid;
          window.wss_send(window.vx, "set_room_ctrl", vue.wss_build_ctrl());
          if (vue.ctrl.eph_mode != "open") {
             window.wss_send(window.vx, "sync_room", {});
          }
        }, 250);
      }
    },
    change_room_ctrl: function(notify) {
      let vue = this;
      if (!window.ctrl_tid) {
        window.ctrl_tid = setTimeout(function(){
          delete window.ctrl_tid;
          //if (vue.ctrl.can_view == "closed") {
          //  if (vue.ctrl.can_join == "open") {
          //    vue.ctrl.can_join = "closed";
          //  }
          //} else if (vue.ctrl.can_view == "locked") {
          //  vue.ctrl.can_join = "locked";
          //}
          vue.ctrl.can_join = vue.ctrl.can_view;
          if (vue.ctrl.can_view != "open" &&
              vue.ctrl.can_view != vue.ctrl.prv_can_view) {
              /* Changed and is restrictive */
              vue.ctrl.flush = true;
          }
          if (notify) {
            vue.$parent.show_notification("Settings updated.", {
               variant:"secondary-outline"
            });
          }
          window.wss_send(window.vx, "set_room_ctrl", vue.wss_build_ctrl());
        }, 250);
      } else {
        // eslint-disable-next-line
        console.log("aggregate");
      }
    },
    ocs_show_repeat: function(ocs) {
      switch(ocs.rp) {
      case "none":
         return "-";
      case "daily":
         return "Daily";
      case "weekly":
         return "Weekly";
      }
      return "?";
    },
    ocs_show_next: function(ocs) {
      let op = new Date(ocs.op * 1000);
      switch(ocs.rp) {
      case "none":
         return "";
      default:
         return format(op,'MM/dd');
      }
    },
    ocs_show_summary: function(ocs) {
      let op = new Date(ocs.op * 1000);
      let cl = new Date(ocs.cl * 1000);
      let str = "error";
      switch(ocs.rp) {
      case "none":
        str = ""+format(op,'MM/dd E h:mma')+" - "+format(cl,'MM/dd E h:mma');
        break;
      case "daily":
        str = ""+format(op,'h:mma')+" - "+format(cl,'h:mma');
        break;
      case "weekly":
        str = ""+format(op,'E h:mma')+" - "+format(cl,'E h:mma');
        break;
      }
      return str;
    },
    ocs_add: function() {
      let vue = this;
      if (!vue.ocs_edit.op || !vue.ocs_edit.cl || !vue.ocs_edit.rp) {
        vue.$parent.show_notification("Please choose an open and close date/time.");
        return;
      }
      let op = vue.dfunx(vue.ocs_edit.op);
      let cl = vue.dfunx(vue.ocs_edit.cl);
      if (cl <= op) {
        vue.$parent.show_notification("The close time should be after the open time.");
        return;
      }
      if ((cl - op) < 600) {
        vue.$parent.show_notification("There must be at least 10min between scheduled open and close.");
        return;
      }
      vue.ocsList.push({
        op: op,
        cl: cl,
        rp: vue.ocs_edit.rp,
        ac: true,
      });
      //console.log(JSON.stringify(vue.ocsList));
      vue.ocs_edit.op = vue.ocs_edit.cl = null;
      let c = { set_ctrl: {
        soc: vue.ocsList,
      } };
      window.wss_send(window.vx, "set_room_ctrl", c);
    },
    ocs_del: function(ocs) {
      let vue = this;
      ocs.del = true;
      vue.ocsList = vue.ocsList.filter(function(r) {
         if (!r.del) { return true; }
         return false;
      });
      let c = { set_ctrl: {
        soc: vue.ocsList,
      } };
      window.wss_send(window.vx, "set_room_ctrl", c);
    },
    ocs_toggle: function(ocs) {
      let vue = this;
      ocs.ac = !ocs.ac;
      let c = { set_ctrl: {
        soc: vue.ocsList,
      } };
      window.wss_send(window.vx, "set_room_ctrl", c);
    },
    alerts_have_changed: function() {
      let vue = this;
      /* Treat as unchanged while saving is in progress */
      if (vue.edit_alert.phone.length != vue.ctrl.alert.phone.length) {
        return true;
      }
      if (vue.edit_alert.init) { return true; }
      if (vue.edit_alert.dbell != vue.ctrl.alert.dbell) {
        return true;
      }
      if (vue.edit_alert.sms != vue.ctrl.alert.sms) {
        return true;
      }
      if (vue.edit_alert.em != vue.ctrl.alert.em) {
        return true;
      }
      if (vue.edit_alert.contact != vue.ctrl.alert.contact) {
        return true;
      }
      if (vue.edit_alert.vmail != vue.ctrl.alert.vmail) {
        return true;
      }
      if (vue.edit_alert.noa_msg != vue.ctrl.noa_msg) {
        return true;
      }
      return false;
    },
    cancel_edit_alert: function() {
      let vue = this;
      vue.edit_alert.phone = vue.ctrl.alert.phone;
      vue.edit_alert.phone = [];
      vue.ctrl.alert.phone.forEach(function(p) {
        vue.edit_alert.phone.push(p);
      });
      vue.edit_alert.dbell = vue.ctrl.alert.dbell;
      vue.edit_alert.sms = vue.ctrl.alert.sms;
      vue.edit_alert.em = vue.ctrl.alert.em;
      vue.edit_alert.contact = vue.ctrl.alert.contact;
      vue.edit_alert.vmail = vue.ctrl.alert.vmail;
      vue.edit_alert.noa_msg = vue.ctrl.noa_msg;
      vue.edit_alert.error = "";
    },
    update_alerts: function() {
      let vue = this;
      vue.edit_alert.error = "";
      if (!vue.edit_alert.phone || !vue.edit_alert.phone.length) {
         vue.edit_alert.phone = [];
         vue.edit_alert.sms = "-";
         if (vue.edit_alert.contact == "sms") {
           vue.edit_alert.contact = "-";
         }
      }
      //console.log("ok"+JSON.stringify(vue.edit_alert));
      vue.edit_alert.saving = true;
      vue.edit_alert.noa_msg = vue.edit_alert.noa_msg || "You do not have permission to access this room.";
      vue.change_room_ctrl();
    },
    do_test_contact: function() {
      let vue = this;
      window.wss_send(window.vx, "contact", {msg:"Hello. This is a test."});
      vue.edit_alert.tested_contact = true;
      setTimeout(function() {
        vue.edit_alert.tested_contact = false;
      }, 2000);
    },
    addPhoneTag: function() {
      let vue = this;
      //vue.edit_alert.phone.push("+123");
      vue.$bvModal.show('bv-phone-verify');
    },
    closePhVerify: function(rs) {
      let vue = this;
      if (!rs || !rs.ok) {
      } else {
      }
      vue.$bvModal.hide('bv-phone-verify');
      vue.refresh_ctrl();
    },
    img_rlogo_changed: function(url,mime) {
      /* Called if the actual URL changes. No update needed if
       *  only the referenced image changes. */
      let vue = this;
      vue.ctrl.rlogo = url || "-";
      vue.change_room_ctrl();
    },
    img_rlogosm_changed: function(url,mime) {
      /* Called if the actual URL changes. No update needed if
       *  only the referenced image changes. */
      let vue = this;
      vue.ctrl.rlogosm = url || "-";
      vue.change_room_ctrl();
    },
    img_rback_changed: function(url,mime) {
      /* Called if the actual URL changes. No update needed if
       *  only the referenced image changes. */
      let vue = this;
      vue.ctrl.rback = url || "-";
      vue.change_room_ctrl();
    },
    img_rbannland_changed: function(url,mime) {
      /* Called if the actual URL changes. No update needed if
       *  only the referenced image changes. */
      let vue = this;
      vue.ctrl.rbannland = url || "-";
      vue.change_room_ctrl();
    },
    img_rbannport_changed: function(url,mime) {
      /* Called if the actual URL changes. No update needed if
       *  only the referenced image changes. */
      let vue = this;
      vue.ctrl.rbannport = url || "-";
      vue.change_room_ctrl();
    },
    img_slate_changed: function(url,mime) {
      /* Called if the actual URL changes. No update needed if
       *  only the referenced image changes. */
      let vue = this;
      vue.slate.url = url;
      vue.slate.mime = mime;
      vue.change_room_ctrl();
    },
    rem_current_broadcast: function() {
      let vue = this;
      if (vue.ctrl && vue.ctrl.cast && vue.ctrl.cast.handle) {
         let ar = {};
         ar.handle = vue.ctrl.cast.handle;
         ar.cast_rem = true;
         api_arcupdate(window.vx, ar, function(data) {
         });
      }
    },
    clicked_alert: function() {
      this.get_voicemails_first();
    },
    voicemail_to_tab: function() {
      let vue = this;
      let page_size = vue.vmail_page_size;
      let total = vue.vmails.length;
      let tab = [];
      if (total && vue.vmail_max_page) {
        vue.vmail_cur_page = Math.min(vue.vmail_cur_page,vue.vmail_max_page-1);
        for (let left=page_size,i=(vue.vmail_cur_page*page_size);
             left && i<total; --left,++i) {
          vue.vmails[i]._rowVariant = "";
          vue.vmails[i].playing = false;
          tab.push(vue.vmails[i]);
        }
      } else {
        vue.vmail_cur_page = 0;
        vue.vmail_max_page = 0;
      }
      vue.vmails_tab = tab;
    },
    comp_voicemail_pages: function() {
       let vue = this;
       let page_size = vue.vmail_page_size;
       vue.vmail_max_page = Math.ceil(vue.vmails.length / page_size);
       if (vue.vmail_start_key && vue.vmail_start_key != "-end-") {
         vue.vmail_max_page ++;
       }
    },
    get_more_voicemails: function(cb) {
      /* Always adds to the END */
      let vue = this;
      let page_size = vue.vmail_page_size;
      if (vue.vmail_start_key == "-end-") {
        /* No more to get */
        cb && cb();
        return;
      }
      window.wss_send_cb(window.vx, "voicemail_list", {
        vm:{
          limit: page_size,
          start_key: vue.vmail_start_key,
        },
      }, function(msg) {
        if (msg && msg.data && msg.data.vms) {
          msg.data.vms.forEach(function(vm) {
             /* Make sure fields are set here so that table gets
              *   future change events */
             vm._rowVariant = "";
             vm.playing = false;
             vm.played = vm.played || false;
             vue.vmails.push(vm);
          });
          if (msg.data.start_key) {
             vue.vmail_start_key = msg.data.start_key;
          } else {
             vue.vmail_start_key = "-end-";
          }
          vue.comp_voicemail_pages();
        }
        //console.log("vmails "+vue.vmails.length+" maxp "+vue.vmail_max_page);
        cb && cb();
      });
    },
    get_voicemails_first: function() {
      let vue = this;
      vue.vmails = [];
      vue.vmail_start_key = "";
      vue.vmail_cur_page = 0;
      vue.vmail_max_page = 0;
      vue.vmail_page_size = 10;
      vue.get_more_voicemails(function() {
        vue.voicemail_to_tab();
      });
    },
    get_voicemails_next: function() {
      let vue = this;
      //console.log("at "+vue.vmail_cur_page+" maxp "+vue.vmail_max_page);
      if (vue.vmail_cur_page >= (vue.vmail_max_page-1)) {
        return;
      } else if (vue.vmail_cur_page == (vue.vmail_max_page-2)) {
         /* Fetch more when at last known page */
         vue.get_more_voicemails(function() {
           vue.vmail_cur_page++;
           vue.voicemail_to_tab();
        });
      } else {
          vue.vmail_cur_page++;
          vue.voicemail_to_tab();
      }
    },
    get_voicemails_prev: function() {
      let vue = this;
      if (!vue.vmail_cur_page) { return; }
      vue.vmail_cur_page--;
      vue.voicemail_to_tab();
    },
    vm_forward: function() {
      let vue = this;
      if (!vue.vmail_current) { return; }
      if (!vue.vmail_current.id) { return; }
      if (!vue.vmail_stats.fwd_to_room) { return; }
      let to_room = vue.vmail_stats.fwd_to_room.replace("@","");
      vue.vmail_stats.fwd_pending = true;
      vue.vmail_stats.fwd_err = "";
      window.wss_send_cb(window.vx, "voicemail_fwd", {
        vm:{
          id: vue.vmail_current.id,
        },
        to_room: to_room,
      }, function(msg) {
        vue.vmail_stats.fwd_pending = false;
        if (msg && msg.data && msg.data.ok) {
          vue.vmail_stats.fwd_to_room = "";
        } else {
          let err = "";
          if (msg && msg.data && msg.data.error) {
            err = ":"+msg.data.error;
          }
          vue.vmail_stats.fwd_err = "Unable to forward"+err;
        }
      });
    },
    vm_delete: function(vm) {
      let vue = this;
      //Not necessary since delete does not show while playing
      //if (vue.vmail_current && vue.vmail_current.id == vm.id) {
      //  vue.vm_stop();
      //}
      window.wss_send_cb(window.vx, "voicemail_up", {
        vm:{
          id: vm.id,
          rem: true,
        },
      }, function(msg) {
        if (msg && msg.data && msg.data.deleted) {
          vue.vmails = vue.vmails.filter(function(v) {
            if (v.id != vm.id) { return true; }
            return false;
          });
          vue.comp_voicemail_pages();
          if (vue.vmail_cur_page < (vue.vmail_max_page-2)) {
             vue.voicemail_to_tab();
          } else {
             vue.get_more_voicemails(function() {
               vue.voicemail_to_tab();
             });
          }
        }
      });
    },
    vm_set_played: function(vm) {
      let vue = this;
      if (vm.played) { return; }
      window.wss_send_cb(window.vx, "voicemail_up", {
        vm:{
          id: vm.id,
          played: true,
        },
      }, function(msg) {
        if (msg && msg.data && msg.data.ok) {
          vm.played = true;
        }
      });
    },
    vm_stop: function() {
      let vue = this;
      let el = vue.$refs.vmaudio;
      if (vue.vmail_current) {
         vue.vmail_stats.playing = false;
         vue.vmail_current.playing = false;
         vue.vmail_current._rowVariant = "";
      }
      el.pause();
    },
    vm_mon: function() {
      let vue = this;
      let el = vue.$refs.vmaudio;
      if (!el || !vue.vmail_stats.playing) { return; }
      vue.vmail_stats.duration = el.duration;
      vue.vmail_stats.elapsed = el.currentTime;
      vue.vmail_stats.str =
        (vue.vmail_stats.elapsed.toFixed(1)+"s / "+
         vue.vmail_stats.duration.toFixed(1)+"s");
      vue.vmail_stats.tid = setTimeout(vue.vm_mon, 300);
    },
    vm_select: function(vm) {
      let vue = this;
      let el = vue.$refs.vmaudio;
      vue.vmail_stats.fwd_err = "";
      if (vue.vmail_current) {
         vue.vmail_stats.playing = false;
         vue.vmail_current.playing = false;
         vue.vmail_current._rowVariant = "";
      }
      vue.vmail_current = vm;
      vm._rowVariant = "success";
      clearTimeout(vue.vmail_stats.tid);
      el.src = vm.vurl;
      el.onloadedmetadata = function() {
         vue.vmail_stats.playing = true;
         vue.vm_set_played(vm);
         vue.vm_mon();
      }
      el.onended = function() {
         //vue.vmail_stats.playing = false;
         vue.vmail_current.playing = false;
         //vue.vmail_current._rowVariant = "";
      }
      vm.playing = true;
      return el;
    },
    vm_play: function(vm) {
      let vue = this;
      vue.vm_select(vm).play();
    },
    get_vmail_date: function(tm) {
      return format(new Date(tm*1000),'yyyy MM/dd E h:mma');
    },

    clicked_notify: function() {
      let vue = this;
      window.wss_send_cb(vx, "get_ctrl_part", {
        field: {
          name: "arrival-notify",
        },
      }, function(msg) {
         if (!msg || !msg.data || !msg.data.ok) { return; }
         vue.arrivalItems = [];
         vue.anote.mode = "all";
         vue.anote.prompt_sec = 0;
         vue.anote.nameq_enabled = false;
         vue.anote.callb_enabled = false;
         vue.anote.cats = [];
         msg.data.results.forEach(function(r) {
           if (!r.val || !r.val.list) { return; }
           ["mode", "prompt_sec", "nameq_enabled", "callb_enabled", "cat_enabled"].forEach(function(f) {
             if (r.val[f] !== undefined) {
               vue.anote[f] = r.val[f];
             }
           });
           if (r.val.cats) {
             r.val.cats.forEach(function(v) {
               if (!v.label || !v.cat) { return; }
               vue.anote.cats.push(v);
             });
           }
           if (r.val.list) {
             r.val.list.forEach(function(v) {
               vue.arrivalItems.push({
                  room:v.room,
                  cat:v.cat,
                  noall: v.noall,
                  ctrl:true
               });
             });
           }
         });
         vue.cancel_edit_anote();
      });
    },
    notify_add_room: function() {
      let vue = this;
      let room = vue.$refs["anote_room_input"].getVal();
      let cat = vue.add_anote.cat;

      vue.add_anote.error = "";
      if (!room) {
        vue.add_anote.error = "A room must be specified";
        return;
      }
      if (room == vx.room.name) {
        vue.add_anote.error = "A room cannot notify itself";
        return;
      }
      if (cat && cat.length > 16) {
        vue.add_anote.error = "Department name is too long";
        return;
      }
      window.wss_send_cb(vx, "set_ctrl_part", {
        field: {
          name: "arrival-notify",
          cmd: "add",
          val: {room: room, cat: cat, noall:false},
        },
      }, function(msg) {
         if (msg && msg.data && msg.data.ok) {
           let field = {room:room, cat:cat, ctrl:true};
           for (let i=0; i<vue.arrivalItems.length; ++i) {
             if (vue.arrivalItems[i].room == room) {
               vue.arrivalItems[i].cat = field.cat;
               return;
             }
           }
           vue.arrivalItems.unshift(field);
         }
      });
    },
    notify_noall_toggle: function(item) {
      let noall = item.noall ? true : false;
      window.wss_send_cb(vx, "set_ctrl_part", {
        field: {
          name: "arrival-notify",
          cmd: "add",
          val: {room: item.room, cat: item.cat, noall: noall},
        },
      }, function(msg) {
        if (msg && msg.data && msg.data.ok) { return; }
        /* Save failed. Undo. */
        item.noall = !item.noall;
      });
    },
    notify_del_room: function(item) {
      let vue = this;
      item.ctrl = false;
      vue.add_anote.error = "";
      window.wss_send_cb(vx, "set_ctrl_part", {
        field: {
          name: "arrival-notify",
          cmd: "del",
          val: {room: item.room},
        },
      }, function(msg) {
         item.ctrl = true;
         if (msg && msg.data && msg.data.ok) {
           item.del = true;
           vue.arrivalItems = vue.arrivalItems.filter(function(v) {
             return !v.del;
           });
         }
      });
    },
    notify_add_cat: function() {
      let vue = this;
      let label = vue.add_acat.label;
      let cat = vue.$refs["anote_cat_input"].getVal();
      if (vue.$refs["anote_cat_input"].isRoom()) {
        cat = "@"+cat;
      }
      vue.add_acat.error = "";
      if (!cat) {
        vue.add_acat.error = "A room or department must be specified";
        return;
      }
      if (cat.indexOf("@")) {
      } else {
        if (cat.length > 16) {
          vue.add_acat.error = "Department name is too long";
          return;
        }
      }
      if (!label) {
        vue.add_acat.error = "A button label must be specified";
        return;
      }
      for (let i=0; i<vue.edit_anote.cats.length; ++i) {
        let c = vue.edit_anote.cats[i];
        if (c.label.toLowerCase() == label.toLowerCase()) {
           c.label = label;
           c.cat = cat;
           return;
        }
      }
      vue.edit_anote.cats.push({
        cat: cat,
        label: label,
        ctrl:true,
      });
    },
    notify_del_cat: function(item) {
      let vue = this;
      item.del = true;
      item.ctrl = false;
      vue.edit_anote.cats = vue.edit_anote.cats.filter(function(v) {
        return !v.del;
      });
    },
    radio_bool_changed(radio, bool) {
      if ((radio == "false" && bool) ||
          (radio == "true" && !bool)) {
          return true;
      }
      return false;
    },
    bool_to_str(bool) {
      return bool ? "true" : "false";
    },
    str_to_bool(str) {
      if (str == "true") { return true; }
      return false;
    },
    anotes_have_changed: function() {
      let vue = this;
      if (vue.edit_anote.mode != vue.anote.mode) { return true; }
      if (vue.radio_bool_changed(vue.edit_anote.enabled,
                                 vue.anote.enabled)) {
        return true;
      }
      if (vue.radio_bool_changed(vue.edit_anote.prompt_enabled,
                                 vue.anote.prompt_sec)) {
        return true;
      }
      if (vue.edit_anote.prompt_sec != vue.anote.prompt_sec) { return true; }

      if (vue.radio_bool_changed(vue.edit_anote.nameq_enabled,
                                 vue.anote.nameq_enabled)) {
        return true;
      }
      if (vue.radio_bool_changed(vue.edit_anote.callb_enabled,
                                 vue.anote.callb_enabled)) {
        return true;
      }

      if (vue.radio_bool_changed(vue.edit_anote.cat_enabled,
                                 vue.anote.cat_enabled)) {
        return true;
      }
      if (vue.anote.cats.length != vue.edit_anote.cats.length) {
        return true;
      }
      for (let i=0; i < vue.anote.cats.length; ++i) {
        if (vue.anote.cats[i].cat != vue.edit_anote.cats[i].cat) {
          return true;
        }
        if (vue.anote.cats[i].label != vue.edit_anote.cats[i].label) {
          return true;
        }
      }
      return false;
    },
    cancel_edit_anote: function() {
      let vue = this;
      vue.edit_anote.enabled = vue.bool_to_str(vue.anote.enabled);
      vue.edit_anote.mode = vue.anote.mode;
      if (vue.anote.prompt_sec) {
        vue.edit_anote.prompt_enabled = "true";
      } else {
        vue.edit_anote.prompt_enabled = "false";
      }
      vue.edit_anote.prompt_sec = vue.anote.prompt_sec;
      vue.edit_anote.nameq_enabled = vue.bool_to_str(vue.anote.nameq_enabled);
      vue.edit_anote.callb_enabled = vue.bool_to_str(vue.anote.callb_enabled);
      vue.edit_anote.cat_enabled = vue.bool_to_str(vue.anote.cat_enabled);
      vue.edit_anote.cats = [];
      vue.anote.cats.forEach(function(c) {
        vue.edit_anote.cats.push({
          cat: c.cat,
          label: c.label,
          ctrl: true,
        });
      });
      vue.edit_anote.saving = false;
      vue.edit_anote.error = "";
    },
    anote_cat_validator: function(cat) {
      if (cat.length < 2 || cat.length > 16) {
        return false;
      }
      return true;
    },
    update_anotes: function() {
      let vue = this;
      let val = {};
      val.mode = vue.edit_anote.mode;
      if (vue.edit_anote.prompt_enabled == "false") {
        val.prompt_sec = vue.edit_anote.prompt_sec = 0;
      } else {
        val.prompt_sec = +vue.edit_anote.prompt_sec;
        if (val.prompt_sec < 15) {
           vue.edit_anote.error = "Prompt wait must be at least 15 seconds";
           return;
        } else if (val.prompt_sec > 300) {
           vue.edit_anote.error = "Prompt wait must be no more than 300 seconds";
           return;
        }
      }
      val.nameq_enabled = vue.str_to_bool(vue.edit_anote.nameq_enabled);
      val.callb_enabled = vue.str_to_bool(vue.edit_anote.callb_enabled);
      val.cat_enabled = vue.str_to_bool(vue.edit_anote.cat_enabled);
      val.cats = to_json(JSON.stringify(vue.edit_anote.cats));
      if (val.cats && val.cats.length > 6) {
         vue.edit_anote.error = "There is a maximum of 6 category buttons.";
         return;
      }
      vue.edit_anote.saving = true;
      vue.edit_anote.error = "";
      window.wss_send_cb(vx, "set_ctrl_part", {
        field: {
          name: "arrival-notify",
          cmd: "set",
          val: val,
        },
      }, function(msg) {
         vue.edit_anote.saving = false;
         if (msg && msg.data && msg.data.ok) {
            vue.anote.mode = val.mode;
            vue.anote.prompt_sec = val.prompt_sec;
            vue.anote.nameq_enabled = val.nameq_enabled;
            vue.anote.callb_enabled = val.callb_enabled;
            vue.anote.cat_enabled = val.cat_enabled;
            vue.anote.cats = val.cats;
         } else {
            vue.edit_anote.error = "Save failed";
            if (msg.data.error) {
              vue.edit_anote.error += ":" + msg.data.error;
            }
         }
      });

      if ((vue.edit_anote.enabled == "false" && vue.anote.enabled) ||
          (vue.edit_anote.enabled == "true" && !vue.anote.enabled)) {
        /* The master enable is stored on the primary ctrl obj */
        let c = { set_ctrl: {} };
        c.set_ctrl.anote_enabled = vue.str_to_bool(vue.edit_anote.enabled);
        window.wss_send(window.vx, "set_room_ctrl", c);
      }
    },

    fix_url: function(url) {
      if (!url) { return null; }
      url = url.replace(/^https?:?[\/]+/,"https://");
      if (/^https:\/\//.test(url)) {
         return url;
      } else {
         return "https://"+url;
      }
    },
    set_info_from_meeting: function(onlytest) {
      let vue = this;
      let now = Date.now()/1000;
      for (let i=0; i<vue.meetingsRoom.length; i++) {
        let m = vue.meetingsRoom[i];
        if (m.end_ep < now) { continue; }
        if (m.start_ep > (now+900)) { return 0; }
        /* If nothing is changing, pull from next meeting */
        if ((m.name && m.name != vue.ctrl.dname) ||
            (m.url && m.url != vue.ctrl.url) ||
            (m.descr && m.descr != vue.ctrl.descr)) {
          if (!onlytest) {
            vue.ctrl.dname = m.name;
            vue.ctrl.url = m.url;
            vue.ctrl.descr = m.descr;
            vue.change_room_ctrl(true);
          }
          if (m.start_ep <= now) {
            return 1;
          } else {
            return 2;
          }
        }
      }
      return 0;
    },
    admin_em_keyup: function(ev) {
      let vue = this;
      vue.admin_ctrl.o_uid = null;
      if (ev.keyCode == 13) {
        vue.admin_em_change();
      }
    },
    admin_em_change: function() {
      let vue = this;
      vue.admin_ctrl.err = "";
      vx_api
        .getUID(window.vx, {
           em: vue.admin_ctrl.o_em,
           //room: vx.room.name
        })
        .then(res => {
           if (res.uid) {
             vue.admin_ctrl.o_uid = res.uid;
             vue.admin_ctrl.o_dname = res.first_name+" "+res.last_name;
           } else {
             //vue.admin_ctrl.o_uid = vue.ctrl.o_uid;
             //vue.admin_ctrl.o_em = vue.ctrl.o_em;
             //vue.admin_ctrl.o_dname = vue.ctrl.o_dname;
             vue.admin_ctrl.err = "Email is invalid"
           }
        })
        .catch(e => {
             vue.admin_ctrl.err = "Email was invalid"
        });
    },
    admin_ctrl_open: function() {
      let vue = this;
      vue.admin_ctrl.err = "";
      ["viewed_max", "joined_max", "o_em", "o_dname",
       "eph_limit", "o_uid", "email_bad",
       "enable_desk"].forEach(function(f) {
        vue.admin_ctrl[f] = vue.ctrl[f];
      });
    },
    admin_ctrl_cancel: function() {
      let vue = this;
      vue.admin_ctrl.err = "";
      ["viewed_max", "joined_max", "o_em", "o_dname",
       "eph_limit", "o_uid", "email_bad",
       "enable_desk"].forEach(function(f) {
        vue.admin_ctrl[f] = vue.ctrl[f];
      });
    },
    admin_ctrl_save: function() {
      let vue = this;
      let c = { set_ctrl: {} };
      ["viewed_max", "joined_max", "o_em", "o_dname",
       "eph_limit", "o_uid", "email_bad",
       "enable_desk"].forEach(function(f) {
        c.set_ctrl[f] = vue.admin_ctrl[f];
      });
      window.wss_send(window.vx, "set_room_ctrl", c);
    },
    doCopy2Clip: function(refid) {
      let vue = this;
      let el = vue.$refs[refid];
      if (!window.copyEText2Clip(el)) {
        console.log("copy failed");
      } else {
         el.parentNode.setAttribute("copied","true");
         setTimeout(function() {
            el.parentNode.setAttribute("copied","false");
         },250);
      }
    },
    opened_urlgen() {
      let vue = this;
      vue.tinyurl_exists();
    },
    tinyurl_exists: function() {
      let vue = this;
      vue.tinyurl.direct_url = vx.rq_endpoint+"/hook/t/"+vx.room.acc+"/"+vx.room.name;
      vue.tinyurl.url = "https://"+vx.subd+".vuemix.com/"+"t/#"+vx.room.name;
      issue_http({url: vue.tinyurl.direct_url,
                  type:"GET", nocred:true,
                  done: function(status, data) {
                     if (status != 200) { return; }
                     let j = to_json(data);
                     if (!j || j.err || !j.opt) { return; }
                     vue.tinyurl.exists = true;
                     vue.tinyurl.loc = vue.edit_tinyurl.loc = j.opt.loc || "room";
                     vue.tinyurl.guest = j.opt.guest;
                     vue.tinyurl.fwd = vue.edit_tinyurl.fwd = j.opt.fwd || "";
                     vue.edit_tinyurl.guest = j.opt.guest ? "true" : "false";
                     //console.log(data,j);
                     vue.tinyurl_changed();
                  }});
    },
    tinyurl_fwdclr: function() {
      let vue = this;
      vue.edit_tinyurl.fwd = "";
      vue.tinyurl_changed();
    },
    tinyurl_fwdroom: function() {
      let vue = this;
      let room = vue.$refs["tinyurl_fwdto"].getVal();
      vue.edit_tinyurl.fwd = room;
      vue.tinyurl_changed();
    },
    tinyurl_changed: function() {
      let vue = this;
      vue.tinyurl.changed = false;
      if ((vue.edit_tinyurl.guest == "false" && vue.tinyurl.guest) ||
          (vue.edit_tinyurl.guest == "true" && !vue.tinyurl.guest)) {
          vue.tinyurl.changed = true;
          return;
      }
      if (vue.edit_tinyurl.loc != vue.tinyurl.loc) {
         vue.tinyurl.changed = true;
         return;
      }
      if (vue.edit_tinyurl.fwd != vue.tinyurl.fwd) {
         vue.tinyurl.changed = true;
         return;
      }
    },
    tinyurl_cancel: function() {
      let vue = this;
      vue.edit_tinyurl.loc = vue.tinyurl.loc;
      vue.edit_tinyurl.fwd = vue.tinyurl.fwd;
      vue.edit_tinyurl.guest = vue.tinyurl.guest ? "true" : "false";
      vue.tinyurl_changed();
    },
    tinyurl_save: function() {
      let vue = this;
      let up = {};
      up.loc = vue.edit_tinyurl.loc;
      up.guest = (vue.edit_tinyurl.guest == "true") ? true : false;
      up.fwd = vue.edit_tinyurl.fwd;
      window.wss_send_cb(vx, "set_ctrl_part", {
        field: {
          name: "tinyurl",
          val: up,
        },
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.ok) { return; }
        vue.tinyurl_exists();
      });
    },
    gen_guest: function() {
      let vue = this;
      vue.guest.disabled = true;
      window.wss_send_cb(window.vx, "gen_guest", {
        ginfo: {em:vue.guest.em,
                sendem: vue.guest.sendem,
                ph:vue.guest.ph,
                sendph: vue.guest.sendph,
                name: vue.guest.name || "Guest",
                loc: vue.guest.loc,
                expire:(vue.guest.expire || 3600),
                },
      }, function(msg) {
         setTimeout(function() {
             vue.guest.disabled = false;
         }, 3000);
         if (!msg || !msg.data || !msg.data.ok) {
            return;
         }
         vue.guest.room_url = msg.data.url;
         clearTimeout(vue.guest.cid);
         vue.guest.cid = setTimeout(function() {
             vue.guest.room_url = "";
         }, 30000);
      });
      return;
    },
    guest_email_keyup: function() {
      let vue = this;
      let em = vue.guest.em_tmp;
      vue.guest.em = "";
      if (vue.validateEmail(em)) {
        vue.guest.em = em;
      }
    },
    guest_phone_keyup: function() {
      let vue = this;
      let ph = vue.guest.ph_tmp;
      vue.guest.ph = "";
      ph = ph.replace(/[\(\)\-\s\D]/g,"");
      if (ph.length > 0 && ph[0] != "1") {
        ph = "1"+ph;
      }
      ph = ph.substring(0,11);
      vue.guest.ph_tmp = ph;
      if (ph.length == 11) {
        vue.guest.ph = ph;
      }
    },
    thirdp_update: function(list) {
      let vue = this;
      window.wss_send_cb(vx, "set_ctrl_part", {
        field: {
          name: "thirdparty-urls",
          val: list,
        },
      }, function(msg) {
         //console.log("thirdparty-set",msg);
         vue.thirdp_url = "";
      });
    },
    thirdp_new_url: function() {
      let vue = this;
      vue.thirdp_error = "";
      if (!vue.$refs.thirdp_tab) { return; }
      let url = vue.thirdp_url;
      if (!url) { return; }
      if (url.indexOf("https://") != 0) {
        vue.thirdp_error = "URL must start with https://";
        return;
      }
      vue.$refs.thirdp_tab.add({
        url:url,
        _label:url,
        _ctrl:{trash: true},
      });
      let list = vue.$refs.thirdp_tab.getList();
      vue.thirdp_update(list);
    },
    thirdp_setup: function(obj) {
      let vue = this;
      vue.thirdp_error = "";
      obj.labelStyle = "width:100%;cursor:pointer;text-decoration:underline;color:blue;";
      window.wss_send_cb(vx, "get_ctrl_part", {
        field: {
          name: "thirdparty-urls",
        },
      }, function(msg) {
         //console.log("thirdparty-get",msg);
         if (!msg || !msg.data || !msg.data.ok) { return; }
         obj.reset();
         /* All urls are blobbed into one result */
         if (!msg.data.results || !msg.data.results[0] ||
             !msg.data.results[0].val) { return; }
         let urls = msg.data.results[0].val;
         urls.forEach(function(u) {
           u["_label"] = u.url;
           u["_ctrl"] = { trash:true };
           obj.add(u);
         });
      });
    },
    thirdp_action: function(obj,action,item) {
      let vue = this;
      //console.log(action,""+item._label);
      if (action == "trashed") {
        /* Attempt delete */
        obj.remove(item);
        let list = vue.$refs.thirdp_tab.getList();
        vue.thirdp_update(list);
      } else if (action == "selected") {
        let exturl = item.url;
        /* Open window while trusted, generate auth, and
           change location of new window to URL + auth */
        let newwin = window.open();
        window.wss_send_cb(window.vx, "gen_api", {
          info: {
            expire: 1800,
            mode:"url",
          }
        }, function(msg) {
          if (!msg || !msg.data || !msg.data.url) {
            newwin.close();
            return;
          }
          let url = ""+exturl;
          if (url.indexOf("#") < 0) {
            url += "#";
          }
          url += "vxauthurl="+encodeURIComponent(msg.data.url);
          //console.log("url",url);
          newwin.location = url;
        });
      }
    },

    clicked_transcript: function() {
      let vue = this;
      if (vue.$refs.tscript_tab) {
        let obj = vue.$refs.tscript_tab;
        obj.reset();
        vue.tscript_last_key = "";
        vue.tscript_fetch(obj);
      }
      vue.tscript_fetch_active = false;
    },
    tscript_tabcreate: function(obj) {
      obj.labelStyle = "width:100%;cursor:pointer;font-size:0.9rem;";
    },
    tscript_fetch: function(obj) {
      let vue = this;
      if (vue.tscript_last_key == "--done--") { return; }
      if (vue.tscript_fetch_active) {
         return;
      }
      vue.tscript_fetch_active = true;
      window.wss_send_cb(vx, "get_transcript", {
         handle: "*",
         start_key: vue.tscript_last_key,
      }, function(msg) {
         //console.log("get_transcript",msg);
         vue.tscript_fetch_active = false;
         if (!msg || !msg.data || !msg.data.ok) { return; }
         //console.log("Last Key",msg.data.last_key);
         if (!msg.data.last_key) {
           /* Fetched everything */
           vue.tscript_last_key = "--done--";
           obj.nomore();
         } else {
           vue.tscript_last_key = msg.data.last_key;
         }
         msg.data.transcripts.forEach(function(tr) {
           let parts = [];
           //if (tr.meta.title && tr.meta.title != "-") {
           //  label = tr.meta.title;
           //}
           if (tr.meta.created) {
             let dt = new Date(+tr.meta.created);
             let fmt = format(dt,'yyyy MM/dd E h:mma');
             parts.push(`${fmt}`);
           }
           if (tr.meta.lns) {
             parts.push(`${tr.meta.lns} phrases`);
           }
           if (tr.meta.usrs) {
             if (tr.meta.usrs > 1) {
               parts.push(`${tr.meta.usrs} speakers`);
             } else {
               parts.push(`1 speaker`);
             }
           }
           if (!parts.length) {
             parts.push("No metadata");
           }
           tr["_label"] = parts.join(", ");
           tr["_ctrl"] = { trash:true, download:false, preview:false };
           obj.add(tr);
         });
      });
    },
    tscript_download: function() {
      let vue = this;
      let txt = vue.cur_tscript_text.join("\n");
      let data = new Blob([txt], { type: "text/vtt" });
      if (vue.tscript_saveFile !== null) {
        window.URL.revokeObjectURL(vue.tscript_saveFile);
      }
      vue.tscript_saveFile = window.URL.createObjectURL(data);

      let link = document.createElement('a');
      document.body.appendChild(link);
      link.download = "transcript.vtt";
      link.href = vue.tscript_saveFile;
      link.target = "_blank";
      link.click();
      document.body.removeChild(link);
    },
    tscript_epoch_to_vtt: function(ep) {
      let ms = ep%1000;
      ep = Math.trunc(ep/1000);
      if (ms < 10) { ms = "00"+ms; }
      else if (ms < 100) { ms = "0"+ms; }

      let sec = ep%60;
      ep = Math.trunc(ep/60);
      if (sec < 10) { sec = "0"+sec; }

      let min = ep%60;
      ep = Math.trunc(ep/60);
      if (min < 10) { min = "0"+min; }

      let hr = ep;
      if (hr < 10) { hr = "0"+hr; }
      return `${hr}:${min}:${sec}.${ms}`;
    },
    tscript_action: function(obj,action,item) {
      let vue = this;
      vue.tscript_error = ""
      if (action == "trashed") {
        //console.log("trashed",item.handle);
        window.wss_send_cb(vx, "del_transcript", {
           handle: item.handle,
        }, function(msg) {
           if (!msg || !msg.data || !msg.data.ok) {
             obj.refresh(item);
             vue.tscript_error = "Unable to delete";
             if (msg.data.error) { vue.tscript_error += ":"+msg.data.error; }
             return;
           }
           obj.remove(item);
        });
      } else if (action == "download") {
        vue.tscript_download();
      } else if (action == "preview") {
        vue.$bvModal.show('bv-tscript-show');
      } else if (action == "fetchMore") {
        //console.log("fetch more transcripts");
        vue.tscript_fetch(obj);
      } else if (action == "deselected") {
        item["_ctrl"].download = false;
        item["_ctrl"].preview = false;
        item["_rowVariant"] = null;
        if (vue.tscript_saveFile !== null) {
          window.URL.revokeObjectURL(vue.tscript_saveFile);
        }
      } else if (action == "selected") {
        //console.log("selected",item.handle);
        item["_ctrl"].download = true;
        item["_ctrl"].preview = true;
        item["_rowVariant"] = "success";
        window.wss_send_cb(vx, "get_transcript", {
           handle: item.handle,
        }, function(msg) {
           if (!msg || !msg.data || !msg.data.ok) { return; }
           let txt = msg.data.txt;
           let utab = msg.data.utab;
           let keys = Object.keys(txt);
           let cur_uid;
           let start_at, end_at;
           let base_at;
           let cur_txt = "";
           let cnt = 0;
           keys.sort();
           vue.cur_tscript_text = ["WEBVTT\n"];
           keys.forEach(function(key) {
             let at = +(key.split("-")[0].replace("t",""));
             let tuid = +(key.split("-")[1]);
             let uinfo = utab[tuid];
             uinfo = uinfo || {dname:"?",uid:"?"};
             let uid = uinfo.uid;
             if (!base_at && at) { base_at = at; }
             if (uid !== cur_uid || (at - start_at > 5000)) {
               cur_uid = uid;
               if (cur_txt) {
                 let vtt1 = Math.max(0,start_at - base_at - 500);
                 let vtt2 = end_at - base_at + 1000;
                 vue.cur_tscript_text.push(`${cnt}`);
                 vue.cur_tscript_text.push(`${vue.tscript_epoch_to_vtt(vtt1)} --> ${vue.tscript_epoch_to_vtt(vtt2)}`);
                 vue.cur_tscript_text.push(`${cur_txt}\n`);
                 cnt++;
               }
               /* Setup for next line */
               start_at = at;
               cur_txt = uinfo.dname+': ';
             }
             end_at = at;
             cur_txt += txt[key]+" ";
           });
           if (cur_txt) {
              let vtt1 = Math.max(0,start_at - base_at - 500);
              let vtt2 = end_at - base_at + 1000;
              vue.cur_tscript_text.push(`${cnt}`);
              vue.cur_tscript_text.push(`${vue.tscript_epoch_to_vtt(vtt1)} --> ${vue.tscript_epoch_to_vtt(vtt2)}`);
              vue.cur_tscript_text.push(`${cur_txt}\n`);
           }
        });
      }
    },

    wss_ctrl_chat: function() {
      let vue = this;
      /* The radio button changes are not immediately available */
      setTimeout(function() {
        let c = { set_ctrl: {} };
        c.set_ctrl.chat = vue.ctrl.chat;
        if (!vue.ctrl.gqcfg.prompt || !vue.ctrl.gqcfg.prompt.length) {
          vue.ctrl.gqcfg.en = false;
        } else {
          vue.ctrl.gqcfg.en = true;
        }
        c.set_ctrl.gqcfg = vue.ctrl.gqcfg;
        window.wss_send(window.vx, "set_room_ctrl", c);
      }, 10);
    },
    wss_ctrl_access: function() {
      let c = { set_ctrl: {} };
      this.ctrl.ajx = +this.ctrl.ajx;
      this.ctrl.aix = +this.ctrl.aix;
      this.ctrl.avx = +this.ctrl.avx;
      if (this.ctrl.ajx <= 0 || this.ctrl.ajx >= this.ctrl.joined_max) {
         this.ctrl.ajx = "";
      }
      if (this.ctrl.aix <= 0 || this.ctrl.aix >= this.ctrl.joined_max) {
         this.ctrl.aix = "";
      }
      if (this.ctrl.avx <= 0 || this.ctrl.avx >= this.ctrl.viewed_max) {
         this.ctrl.avx = "";
      }
      c.set_ctrl.viewing = this.ctrl.can_view;
      c.set_ctrl.joining = this.ctrl.can_join;
      c.set_ctrl.adhoc = this.ctrl.adhoc || false;
      c.set_ctrl.ulog = this.ctrl.ulog || false;
      c.set_ctrl.pub = this.ctrl.pub;
      c.set_ctrl.hide = this.ctrl.hide;
      c.set_ctrl.ajx = this.ctrl.ajx;
      c.set_ctrl.aix = this.ctrl.aix;
      c.set_ctrl.avx = this.ctrl.avx;
      window.wss_send(window.vx, "set_room_ctrl", c);
    },
    wss_build_ctrl: function() {
      let c = { set_ctrl: {} };
      c.set_ctrl.viewing = this.ctrl.can_view;
      c.set_ctrl.joining = this.ctrl.can_join;
      c.set_ctrl.flush = this.ctrl.flush;
      this.ctrl.flush = false;
      c.set_ctrl.dname = this.ctrl.dname;
      c.set_ctrl.url = this.fix_url(this.ctrl.url);
      c.set_ctrl.descr = this.ctrl.descr;
      c.set_ctrl.cat = this.ctrl.cat;
      c.set_ctrl.loc = this.$parent.currentUser.loc;
      c.set_ctrl.eph = this.ctrl.eph;
      c.set_ctrl.eph_mode = this.ctrl.eph_mode || "open";
      if (this.ctrl.eph_strict && this.ctrl.eph_strict != "false") {
        c.set_ctrl.eph_strict = true;
      } else {
        c.set_ctrl.eph_strict = false;
      }
      c.set_ctrl.hide = this.ctrl.hide;
      c.set_ctrl.adhoc = this.ctrl.adhoc || false;
      c.set_ctrl.ulog = this.ctrl.ulog || false;
      c.set_ctrl.pub = this.ctrl.pub;
      c.set_ctrl.prsonly = this.ctrl.prsonly || false;
      c.set_ctrl.privmode = this.ctrl.privmode || false;
      c.set_ctrl.uimin = this.ctrl.uimin || false;
      c.set_ctrl.mod_kind = this.ctrl.mod_kind;
      c.set_ctrl.slate_mode = this.slate.mode;
      c.set_ctrl.slate = this.slate.url;
      c.set_ctrl.slate_mime = this.slate.mime;
      c.set_ctrl.auto_raise = this.ctrl.auto_raise || false;
      if (this.ctrl.rlogo) { c.set_ctrl.rlogo = this.ctrl.rlogo; }
      if (this.ctrl.rlogosm) { c.set_ctrl.rlogosm = this.ctrl.rlogosm; }
      if (this.ctrl.rback) { c.set_ctrl.rback = this.ctrl.rback; }
      if (this.ctrl.rbannland) { c.set_ctrl.rbannland = this.ctrl.rbannland; }
      if (this.ctrl.rbannport) { c.set_ctrl.rbannport = this.ctrl.rbannport; }
      if (this.edit_alert) {
         c.set_ctrl.alert = {};
         c.set_ctrl.alert.init = this.edit_alert.init;
         c.set_ctrl.alert.phone = this.edit_alert.phone || [];
         c.set_ctrl.alert.dbell = this.edit_alert.dbell || "false";
         c.set_ctrl.alert.sms = this.edit_alert.sms;
         c.set_ctrl.alert.em = this.edit_alert.em;
         c.set_ctrl.alert.contact = this.edit_alert.contact;
         c.set_ctrl.alert.vmail = (this.edit_alert.vmail=="true")?true:false;
         if (this.edit_alert.noa_msg) {
           c.set_ctrl.noa_msg = this.edit_alert.noa_msg;
         }
      }
      this.ctrl_state.pl = this.presLayoutSel;
      this.ctrl_state.al = this.audLayoutSel;
      c.set_ctrl.state = this.ctrl_state;
      //c.set_ctrl.mods = ;
      //c.set_ctrl.mod = ;
      return c;
    },
    wss_room_ctrl: function(msg) {
      let vue = this;
      let refresh = false;
      if (msg.data.viewing) {
        vue.ctrl.can_view = msg.data.viewing;
      } else if (!vue.ctrl.can_view) {
        vue.ctrl.can_view = "open";
      }
      if (vue.ctrl.prv_can_view != vue.ctrl.can_view) {
        refresh = true;
      }
      vue.ctrl.prv_can_view = vue.ctrl.can_view;

      if (msg.data.joining) {
        vue.ctrl.can_join = msg.data.joining;
      } else if (!vue.ctrl.can_join) {
        vue.ctrl.can_join = "open";
      }
      if (vue.ctrl.prv_can_join != vue.ctrl.can_join) {
        refresh = true;
      }
      vue.ctrl.prv_can_join = vue.ctrl.can_join;

      vue.ctrl.joined = msg.data.joined;
      vue.ctrl.joined_max = msg.data.joined_max || vue.ctrl.joined_max;
      vue.ctrl.viewed = msg.data.viewed;
      vue.ctrl.viewed_max = msg.data.viewed_max || vue.ctrl.viewed_max;
      vue.ctrl.email_bad = msg.data.email_bad || vue.ctrl.email_bad;
      if (msg.data.enable_desk !== undefined) {
        vue.ctrl.enable_desk = msg.data.enable_desk;
      }

      if (msg.data.for_mod) {
        vue.alertEmails = [];
        if (msg.data.o_em) {
           vue.ctrl.o_em = msg.data.o_em;
           vue.ctrl.o_dname = msg.data.o_dname;
           vue.ctrl.o_uid = msg.data.o_uid;
           vue.alertEmails.push({value:vue.ctrl.o_em,
                                 text:""+vue.ctrl.o_em+" (owner)"});
        }
        if (msg.data.mods) {
          vue.currentModerators = msg.data.mods;
          vue.currentModerators.forEach(function(m) {
            vue.alertEmails.push({value:m.em,
                                  text:""+m.em+" (mod)"});
          });
        }
        vue.ctrl.ulog = msg.data.ulog || false;
      }
      vue.ctrl.dname = msg.data.dname || "";
      vue.ctrl.url = msg.data.url || "";
      vue.ctrl.descr = msg.data.descr || "";
      vue.ctrl.cat = msg.data.cat || [];
      vue.ctrl.adhoc = msg.data.adhoc || false;
      vue.ctrl.auto_raise = msg.data.auto_raise || false;
      if (msg.data.pub) { vue.ctrl.pub = msg.data.pub; }
      vue.ctrl.privmode = msg.data.privmode || false;
      vue.ctrl.uimin = msg.data.uimin || false;
      vue.ctrl.mod_kind = msg.data.mod_kind || vue.ctrl.mod_kind;
      vue.ctrl_eph = msg.data.is_eph;
      vue.ctrl.eph = msg.data.eph;
      vue.ctrl.eph_mode = msg.data.eph_mode || "open";
      vue.ctrl.eph_limit = msg.data.eph_limit || vue.ctrl.eph_limit || 0;
      vue.ctrl.eph_strict = msg.data.eph_strict || false;
      vue.ctrl.hide = msg.data.hide || [];
      vue.ctrl.ajx = msg.data.ajx || vue.ctrl.ajx;
      vue.ctrl.aix = msg.data.aix || vue.ctrl.aix;
      vue.ctrl.avx = msg.data.avx || vue.ctrl.avx;
      vue.slate.url = msg.data.slate || vue.slate.url || "";
      vue.slate.mime = msg.data.slate_mime || vue.slate.mime || "image/";
      vue.slate.mode = msg.data.slate_mode || vue.slate.mode || "off";
      if (msg.data.rlogo != "-") {
        vue.ctrl.rlogo = msg.data.rlogo || "";
      }
      if (msg.data.rlogosm != "-") {
        vue.ctrl.rlogosm = msg.data.rlogosm || "";
      }
      if (msg.data.rback != "-") {
        vue.ctrl.rback = msg.data.rback || "";
      }
      if (msg.data.rbannland != "-") {
        vue.ctrl.rbannland = msg.data.rbannland || "";
      }
      if (msg.data.rbannport != "-") {
        vue.ctrl.rbannport = msg.data.rbannport || "";
      }
      vue.ctrl.cast = msg.data.cast || {};
      vue.ctrl.can_contact = msg.data.can_contact || false;
      if (msg.data.alert) {
        delete vue.edit_alert.init;
        vue.ctrl.alert = {};
        vue.ctrl.alert.phone = vue.edit_alert.phone = msg.data.alert.phone || [];
        vue.ctrl.alert.dbell = vue.edit_alert.dbell = msg.data.alert.dbell || "false";
        vue.ctrl.alert.sms = vue.edit_alert.sms = msg.data.alert.sms || "-";
        vue.ctrl.alert.em = vue.edit_alert.em = msg.data.alert.em;
        vue.ctrl.alert.contact = vue.edit_alert.contact = msg.data.alert.contact || "-";
        vue.ctrl.alert.vmail = vue.edit_alert.vmail = (""+(msg.data.alert.vmail || false));
        vue.ctrl.noa_msg = vue.edit_alert.noa_msg =
            msg.data.noa_msg || vue.ctrl.noa_msg;
        vue.edit_alert.saving = false;
      }

      vue.anote.enabled = msg.data.anote_enabled || false;
      vue.edit_anote.enabled = vue.anote.enabled ? "true" : "false";

      if (msg.data.chat) {
        vue.ctrl.chat = msg.data.chat;
        vue.ctrl_orig_wmsg = vue.ctrl.chat.wmsg;
      } else if (!vue.ctrl.chat.mode) {
        vue.ctrl.chat.mode = "limited2";
      }
      if (msg.data.gqcfg) {
        vue.ctrl.gqcfg = msg.data.gqcfg;
        vue.ctrl_orig_prompt = vue.ctrl.gqcfg.prompt;
      }
      if (msg.data.soc !== undefined) {
        vue.ocsList = msg.data.soc;
      }
      if (msg.data.state !== undefined) {
        /* ac: room audio control
         * pl: presenter layout
         * al: audience layout
         */
        vue.ctrl_state = msg.data.state;
      } else {
        vue.ctrl_state = {};
      }
      if (!vue.ctrl_state.pl) {
        vue.ctrl_state.pl = vue.presLayouts[0].value;
      }
      if (!vue.ctrl_state.al) {
        vue.ctrl_state.al = vue.audLayouts[0].value;
      }
      vue.presLayoutSel = vue.ctrl_state.pl;
      vue.presLayoutSelName = vue.ctrl_state.pl;
      vue.audLayoutSel = vue.ctrl_state.al;

      vue.ctrl_truckfocus = false;
      if (vue.presLayoutSel.indexOf(".") > 0) {
        vue.ctrl_truckfocus = true;
        vue.presLayoutSelName = "Focus";
      }

      if (msg.data.for_mod) {
        vue.admin_ctrl_open();
      }
      if (vue.ctrl_veryfirsttime == true &&
          (msg.data == "error")) {
        /* First time; Go ahead and activate */
        vue.ctrl_veryfirsttime = false;
        window.wss_send(window.vx, "set_room_ctrl", vue.wss_build_ctrl());
      }
      if (refresh) {
        vue.refresh_users();
      }
    },
    take_from_dashboard: function() {
      let vue = this;
      vue.presLayoutSel = vue.presLayoutSel.split(".")[0];
      vue.ctrl_state.pl = vue.presLayoutSel;
      window.wss_send(window.vx, "set_room_ctrl", vue.wss_build_ctrl());
    },
    empty_room() {
      let vue = this;
      let c = { set_ctrl: {} };
      c.set_ctrl.empty = true;
      window.wss_send(window.vx, "set_room_ctrl", c);
      vue.refresh_users(5000);
    },
    change_user_role(user, k, v) {
      let vue = this;
      if (!user.uid) {
        return;
      }
      //console.log(JSON.stringify(user));
      let prv_can_join = user.can_join;
      user[k] = v;
      if (!user.can_view) {
         /* Don't allow join unless view */
         user.can_join = false;
      }
      
      let set_roles = {};
      set_roles = {};
      set_roles.can_join = user.can_join;
      set_roles.can_view = user.can_view;
      window.wss_send(window.vx, "auth_room", {
        tgt_uid: user.uid,
        set_roles: set_roles
      });
      if (prv_can_join && !user.can_join) {
        window.wss_send(window.vx, "exit_room", { tgt_uid: user.uid });
      }
      vue.$refs.userstab.refresh();
    },
    change_user_kind(user, v) {
      //console.log("change:"+user.uid+" "+v);
      if (v == "prs") {
        window.wss_send(window.vx, "raise_hand", {tgt_uid: user.uid, tgt_to:"prs"});
      } else if (v == "aud") {
        window.wss_send(window.vx, "lower_hand", {tgt_uid: user.uid});
      }
    },
    selectForChat: function(item) {
      if (vx.room.name) {
        setLocal("vx_chattgt_"+vx.room.name,
                 JSON.stringify({uid: item.uid, dname: item.dname}));
      }
    },
    onSubmitAddModeratingUser: function() {
      let vue = this;
      vx_api
        .getUID(window.vx, {
           em: vue.moderatingUser,
           room: vx.room.name
        })
        .then(res => {
          if (res.xuid) {
            /* Push moderator */
            let c = { set_ctrl: {} };
            c.set_ctrl.mod = { uid: res.xuid, em: vue.moderatingUser };
            window.wss_send(window.vx, "set_room_ctrl", c);
            vue.moderatingUser = "";
          } else {
            vue.$parent.show_notification("User ["+vue.moderatingUser+"] does not exist or you lack permission to add a moderator.");
          }
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log("error:"+e);
        });
    },
    wss_get_meetings: function(msg) {    
      if (msg.data == "denied") {
         return;
      }
      let vue = this;
      let hash = {};
      let now = (Date.now() / 1000) - 1;
      msg.data.forEach(function(u) {
         let unique_meeting = u.name+":"+u.start_ep;
         hash[unique_meeting] = hash[unique_meeting] || {};
         
         let meeting = hash[unique_meeting];
         meeting.name = u.name;
         meeting.start_ep = u.start_ep;
         meeting.end_ep = u.end_ep;
         meeting.geo = {};
         meeting.attendees = meeting.attendees || [];
         if (u.start_ep <= now) {
            if (u.end_ep <= now) {
              meeting._rowVariant = "danger";
            } else {
              meeting._rowVariant = "success";
            }
         }

         if (u.em == "_anchor_") {
           meeting.code = u.uid;
           meeting.name = u.name;
           meeting.canreg = u.canreg || 0;
           if (u.canreg && u.canreg > 0) {
             meeting.iswebinar = "true";
           } else {
             meeting.iswebinar = "false";
           }
           if (u.geo) {
             meeting.geo.ct = u.geo.ct;
           }
           meeting.url = u.url;
           meeting.descr = u.descr;
           meeting.ebs = u.ebs;
           meeting.rem = u.rem;
         } else {
           let att = {};
           att.uid = u.uid;
           att.em = u.em;
           att.brk = u.brk;
           att.can_view = u.can_view || false;
           att.can_join = u.can_join || false;
           if (!att.uid) {
             att._rowVariant = "warning";
           }
           meeting.attendees.push(att);
         }
      });
      
      let list = [];
      let group = {name:"group", canreg: 0, iswebinar:"false", start_ep:vue.infinity, end_ep:vue.infinity, attendees:[], inactive:true, isgroup:true, geo:{}};
      Object.keys(hash).forEach(function(m) {
        let meeting = hash[m];
        //console.log("meeting:"+m);
        if (m == "group:1") {
           group = meeting;
           group.inactive = false;
           group.isgroup = true;
           group._rowVariant = "success";
           return;
        } else if (m == "group:"+vue.infinity) {
           group = meeting;
           group.inactive = true;
           group.isgroup = true;
           delete group._rowVariant;
           return;
        } else if (vue.selectedMeeting && vue.selectedMeeting.name) {
           /* Need to refresh any selected meeting */
           if (vue.sameMeeting(meeting,vue.selectedMeeting)) {
              vue.selectedMeeting = meeting;
           }
        }
        list.push(meeting);
      });
      list = list.sort(function(a,b) {return a.start_ep - b.start_ep;});
      list.unshift(group);
      vue.meetingsRoom = list;      
    },
    wss_get_regmeetings: function(msg) {
      if (msg.data == "denied") {
         return;
      }
      let vue = this;
      let list = [];
      let now = Date.now()/1000;
      msg.data.forEach(function(u) {
         let meeting = {};
         meeting.name = u.name;
         meeting.start_ep = u.start_ep;
         meeting.end_ep = u.end_ep;
         meeting.code = u.uid;
         meeting.isreg = false;
         meeting.regcnt = u.regcnt;
         meeting.canreg = u.canreg;
         meeting.isfull = (meeting.regcnt >= meeting.canreg);
         meeting.isold = (meeting.end_ep <= now);
         meeting.ison = !meeting.isold && (meeting.start_ep <= now);
         if (u.descr) { meeting.descr = u.descr; meeting._showDetails = true; }
         if (u.url) { meeting.url = u.url; meeting._showDetails = true; }
         meeting.geo = {};
         if (u.geo) {
           meeting.geo.ct = u.geo.ct;
         }
         /* For other's rooms this is only your invitations/registrations */
         vue.meetingsRoom.forEach(function(m) {
           if (vue.sameMeeting(meeting,m)) {
              meeting.isreg = true;
           }
         });
         list.push(meeting);
      });
      list = list.sort(function(a,b) {return a.start_ep - b.start_ep;});
      vue.roomWebinars = list;
    },
    wss_regmeeting: function(msg) {
      if (msg.data == "denied" || msg.data == "error") {
         return;
      }
      let vue = this;
      vue.roomWebinars.forEach(function(m) {
        if (m.code == msg.data.code) {
          m.isreg = msg.data.isreg;
        }
      });
    },
    get_all_meetings: function() {
      window.wss_send(window.vx, "get_meetings", {tgt_em:"all",for_tm:"all"});
    },
    wss_set_meetings: function(msg) {
      if (!msg.data || !msg.data.error) {
        return;
      }
      /* Handle errors */
      let vue = this;
      if (msg.data.em) {
         vue.$parent.shop_notification("Email ["+msg.data.em+"] is invalid.");
         /* Email was invalid; remove */
         vue.meetingsRoom.forEach(function(m) {
           m.attendees = m.attendees.filter(function(att) {
             if (att.em == msg.data.em) {
               return false;
             }
             return true;
           });
         });
      }
    },
    change_att_join(att, can_join) {
       let sm = this.selectedMeeting;
       if (sm) {
         att.can_join = can_join;
         this.add_att_to_meeting(sm.name, sm.start_ep, sm.end_ep, att);
       }
    },
    do_self_regmeeting(meeting) {
      let vue = this;
      if (meeting.geo) {
        if (meeting.geo.ct) {
           if (!vue.$parent.currentUser.loc.ct) {
             vue.$parent.show_notification("This meeting is geo-locked and your location is not set. Please set your location in the account settings below.");
             vue.$parent.goAccount();
             return;
           }
           if (vue.$parent.currentUser.loc.ct != meeting.geo.ct) {
             vue.$parent.show_notification("This meeting is geo-locked and you are outside the target region.");
             return;
           }
        }
      }
      let up = { slots: [] };
      up.slots[0] = {};
      up.slots[0].start_ep = meeting.start_ep;
      up.slots[0].uid = meeting.code;
      up.slots[0].em = vue.$parent.currentUser.email;
      /* This adds user (or users) to the meeting records */
      window.wss_send(window.vx, "regmeeting", up);      
    },
    add_att_to_meeting: function(name, start_ep, end_ep, att) {
      if (!name || !start_ep || !att || !att.em) {
        // eslint-disable-next-line
        console.log("add_att_to_meeting: invalid");
        return;
      }
      let up = { slots: [] };
      up.slots[0] = {};
      if (att.uid) {
        up.slots[0].uid = att.uid;
      }
      up.slots[0].em = att.em;
      up.slots[0].brk = att.brk;
      up.slots[0].name = name;
      up.slots[0].start_ep = start_ep;
      up.slots[0].end_ep = end_ep;
      up.slots[0].can_view = att.can_view;
      up.slots[0].can_join = att.can_join;
      if (att.canreg !== undefined) { up.slots[0].canreg = att.canreg; }
      if (att.url) { up.slots[0].url = this.fix_url(att.url); }
      if (att.geo) { up.slots[0].geo = att.geo; }
      if (att.descr) { up.slots[0].descr = att.descr; }
      up.slots[0].ebs = att.ebs;
      if (att.rem !== undefined) { up.slots[0].rem = att.rem; }
      /* This adds user (or users) to the meeting records */
      window.wss_send(window.vx, "set_meetings", up);
    },
    add_att_to_update: function(up, name, start_ep, end_ep, att) {
      if (!name || !start_ep || !att || !att.em) {
        // eslint-disable-next-line
        console.log("add_att_to_update: invalid");
        return;
      }
      up.slots = up.slots || [];
      let slot = {};
      if (att.uid) {
        slot.uid = att.uid;
      }
      slot.em = att.em;
      slot.brk = att.brk;
      slot.name = name;
      slot.start_ep = start_ep;
      slot.end_ep = end_ep;
      slot.can_view = att.can_view;
      slot.can_join = att.can_join;
      if (att.canreg !== undefined) { slot.canreg = att.canreg; }
      if (att.url) { slot.url = this.fix_url(att.url); }
      if (att.geo) { slot.geo = att.geo; }
      if (att.descr) { slot.descr = att.descr; }
      slot.ebs = att.ebs;
      if (att.rem !== undefined) { slot.rem = att.rem; }
      up.slots.push(slot);
    },
    add_to_meeting: function(user, can_view, can_join) {
      let vue = this;
      let sm = vue.selectedMeeting;
      let meeting_name = sm.name;
      let start_ep = sm.start_ep;
      let end_ep = sm.end_ep;

      if (!user.email) { return; }
      user.email = user.email.toLowerCase();
      for (let i=0; i<sm.attendees.length; i++) {
        if (sm.attendees[i].em == user.email) {
          /* Already in the meeting */
          vue.newMeetingUser = null;
          vue.newMeetingUserBrk = null;
          return;
        }
      }
      if (user.brk > vue.ctrl.eph_limit) {
         vue.$parent.show_notification("User "+user.email+" cannot be assigned to breakout "+user.brk+". You have a max of "+vue.ctrl.eph_limit+" breakouts.");
         delete user.brk;
      }

      vx_api
        .getUID(window.vx, { em:user.email })
        .then(res => {
          let att = {};
          att.em = user.email;
          att.uid = res.uid;
          if (!att.uid) {
            att._rowVariant = "warning";
          }
          att.brk = user.brk;
          att.can_view = can_view;
          att.can_join = can_join;
          vue.add_att_to_meeting(meeting_name, start_ep, end_ep, att);
          if (vue.selectedMeeting) {
             vue.selectedMeeting.attendees.push(att);
             vue.newMeetingUser = null;
             vue.newMeetingUserBrk = null;
          }
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log(e);
        });
    },
    rm_from_meeting: function(up, when, who) {
      /* Identical API to 'add' except slot action is 'delete'
         thus capable of add and delete in same request. */
      up.slots = up.slots || [];
      let slot = {};
      slot = {};
      slot.action = "delete";
      slot.em = who.em;
      slot.uid = who.uid;
      slot.start_ep = when;
      up.slots.push(slot);
    },
    rm_from_meeting_commit: function(up) {
      window.wss_send(window.vx, "set_meetings", up);
    },
    attUploadChanged: function(e) {
      let vue = this;
    },
    getMeetingStartDateTime: function(m) {
      let vue = this;
      if (!m) { return "?"; }
      if (m.start_ep <= 1) { return "Active"; }
      if (m.start_ep === vue.infinity) { return "Off"; }
      var st = new Date(m.start_ep * 1000);
      var now = new Date();
      if (st.getYear() == now.getYear()) {
         return format(st,'MM/dd E h:mma')
      } else {
         return format(st,'yyyy MM/dd E h:mma')
      }
    },
    getMeetingEndDateTime: function(m) {
      let vue = this;
      if (!m || !m.end_ep) { return "?"; }
      if (m.end_ep === vue.infinity) { return "-"; }
      var et = new Date(m.end_ep * 1000);
      var now = new Date();
      if ((et - now) < 24*3600*1000) {
        if (et.getDay() == now.getDay()) {
          /* Same day, different hour */
          return format(et,'h:mma')
        } else {
          /* Within 24 hours but different days */
          return format(et,'E h:mma')
        }
      } else if (et.getYear() == now.getYear()) {
         /* Same year */
         return format(et,'MM/dd E h:mma')
      } else {
         return format(et,'yyyy MM/dd E h:mma')
      }
    },
    getMeetingAttendees: function(atnds) {
      if (!atnds || atnds.length == 0) { return "No one"; }
      return atnds.length;// + ` ${atnds.length > 1 ? " Attendees" : " Attendee"}`;
    },
    sameMeeting: function(m1, m2) {
      if (m1.name == m2.name && m1.start_ep == m2.start_ep) {
         return true;
      }
      return false;
    },
    openMeetingView: function(meeting){
      let vue = this;
      this.meetingsRoom.forEach(function(m){
        if (vue.sameMeeting(m,meeting)) {
          /* Only change view if successfully found */
          vue.isMeetingsListView = false;
          vue.selectedMeeting = m;
        }
      });
    },
    roundDateEp(ep) {
      let round = ((ep/900000).toFixed(0));
      round = Number.parseInt(round)+1;
      round *= 900000;
      return round;
    },
    TSupdate_geo(v) {
     this.tmpSelectedMeeting.geoval = v;
    },
    TSupdate_userem(v) {
     this.tmpSelectedMeeting.userem = v;
    },
    newMeeting: function() {
       let vue = this;
       let meeting = {};
       /* These values should be filled in / edited in the single
        * meetings view */
       meeting.start_ep = 0;
       meeting.end_ep = 0;
       meeting.attendees = [];
       meeting.geo = {};
       vue.meetingsRoom = vue.meetingsRoom || [];
       vue.meetingsRoom.push(meeting);
       vue.selectedMeeting = meeting;
       /* Switch to newly created meeting */
       vue.isMeetingsListView = false;
       /* Have name, date selection open */
       vue.tmpSelectedMeeting.name = "";
       vue.tmpSelectedMeeting.descr = "";
       vue.tmpSelectedMeeting.start_ep = null;
       vue.tmpSelectedMeeting.end_ep = null;
       vue.$set(vue.tmpSelectedMeeting, "start_ep", vue.roundDateEp(Date.now()));
       vue.$set(vue.tmpSelectedMeeting, "geoval", "");
       vue.editMeetingView = true;
    },
    addNewUserToMeetingShim(e) {
      if (event.keyCode === 13) {
         this.addNewUserToMeeting();
      }
    },
    addNewUserToMeeting() {
      let vue = this;
      if (vue.attUploadFile) {
         let reader = new FileReader();
         reader.onload = function(e) {
           let contents = e.target.result;
           let csv = new CSV;
           let c = csv.parse(contents);
           csv.classify(c, "email", function(v) {
              if ((typeof v) != "string") { return false; }
              return vue.validateEmail(v);
           });
           csv.classify(c, "breakout", function(v) {
              if ((typeof v) != "number") { return false; }
              return true;
           });
           if (("email" in c.f)) {
              let idx = c.f.email;
              let brk_idx = c.f.breakout;
              c.r.forEach(function(row) {
                let u = {email: row[idx]};
                if (brk_idx >= 0) {
                  u.brk = row[brk_idx];
                }
                vue.add_to_meeting(u, true, true);
              });
           } else {
              vue.$parent.show_notification("No emails found in csv file.");
           }
           vue.attUploadFile = null;
         }
         reader.onerror = function(e) {
           // eslint-disable-next-line
           console.log("file error");
         }
         reader.readAsText(vue.attUploadFile);
      } else if (vue.newMeetingUser) {
        vue.add_to_meeting({email: vue.newMeetingUser,
                            brk: vue.newMeetingUserBrk}, true, true);
      }
    },
    deleteUserFromMeeting: function(att) {
      let vue = this;
      let sm = vue.selectedMeeting;
      let rup = {};
      vue.rm_from_meeting(rup, sm.start_ep, {em: att.em, uid: att.uid});
      vue.rm_from_meeting_commit(rup);
      sm.attendees = sm.attendees.filter(function(it) {
         if (it.em == att.em) {
            return false;
         }
         return true;
      });
    },    
    deleteMeeting(m,send_email) {
      let vue = this;
      let now_sec = Math.trunc(Date.now()/1000);
      if (send_email && m.start_ep && m.end_ep &&
          /* Not ended and less than 10min past start */
          now_sec < m.end_ep && now_sec < (m.start_ep+600)) {
        let c = {m:{}};
        c.m.start_ep = m.start_ep;
        c.m.end_ep = m.end_ep;
        c.m.action = "cancel";
        c.body = `<div style="padding:10px;"><div style="background-color:white;width:500px;text-align:left;font-size:13px;">Cancelled</div></div>`;
        window.wss_send(window.vx, "email_meetings", c);
      }

      /* Remove from meetings list */
      vue.meetingsRoom = vue.meetingsRoom.filter(function(fm) {
        if (vue.sameMeeting(m, fm)) {
           return false;
        }
        return true;
      });
      let rup = {};
      m.attendees.forEach(function (att) {
        vue.rm_from_meeting(rup, m.start_ep, {em: att.em, uid: att.uid});
      });
      vue.rm_from_meeting(rup, m.start_ep, {em: "_anchor_", uid: 0});
      setTimeout(function() {
         vue.rm_from_meeting_commit(rup);
      }, 500);
    },
    confirmDeleteMeeting: function () {
      //getting over scoped modal issue
      let vue = this;
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to delete this meeting?")
        .then(value => {
          if (value) {
            vue.deleteMeeting(vue.selectedMeeting,true);
            vue.selectedMeeting = null;
            vue.isMeetingsListView = true;
          }
        });
    },
    clearMeetingBrk: function() {
      let vue = this;
      let sm = vue.selectedMeeting;
      let up = {slots:[]};
      let slot = {};
      sm.attendees.forEach(function(att){
         att.brk = 0;
         vue.add_att_to_update(up, sm.name, sm.start_ep,
                               sm.end_ep, att);
      });
      //console.log(JSON.stringify(up));
      window.wss_send(window.vx, "set_meetings", up);
    },
    activateGroup: function() {
      let vue = this;
      vue.selectedMeeting.start_ep = 1;
      vue.selectedMeeting.inactive = false;
      vue.selectedMeeting._rowVariant = "success";

      let up = {slots:[]};
      let slot = {};
      slot.em = "_anchor_";
      slot.name = "group";
      slot.start_ep = 1;
      slot.end_ep = vue.infinity;
      up.slots.push(slot);
      vue.selectedMeeting.attendees.forEach(function(att){
         vue.add_att_to_update(up, slot.name, slot.start_ep,
                               slot.end_ep, att);
      });
      //console.log(JSON.stringify(up));
      window.wss_send(window.vx, "set_meetings", up);

      let rup = {slots:[]};
      vue.selectedMeeting.attendees.forEach(function(att){
         vue.rm_from_meeting(rup, vue.infinity, {em: att.em, uid: att.uid});
      });
      vue.rm_from_meeting(rup, vue.infinity, {em: "_anchor_", uid: 0});
      //console.log(JSON.stringify(rup));
      window.wss_send(window.vx, "set_meetings", rup);
    },
    deactivateGroup: function() {
      let vue = this;
      vue.selectedMeeting.start_ep = vue.infinity;
      vue.selectedMeeting.inactive = true;
      delete vue.selectedMeeting._rowVariant;

      let up = {slots:[]};
      let slot = {};
      slot.em = "_anchor_";
      slot.name = "group";
      slot.start_ep = vue.infinity;
      slot.end_ep = vue.infinity;
      up.slots.push(slot);
      vue.selectedMeeting.attendees.forEach(function(att){
         vue.add_att_to_update(up, slot.name, slot.start_ep,
                               slot.end_ep, att);
      });
      //console.log(JSON.stringify(up));
      window.wss_send(window.vx, "set_meetings", up);

      let rup = {slots:[]};
      vue.selectedMeeting.attendees.forEach(function(att){
         vue.rm_from_meeting(rup, 1, {em: att.em, uid: att.uid});
      });
      vue.rm_from_meeting(rup, 1, {em: "_anchor_", uid: 0});
      //console.log(JSON.stringify(rup));
      window.wss_send(window.vx, "set_meetings", rup);
    },
    cancelSelectedMeetingView: function(){
      this.isMeetingsListView = true;
      this.selectedMeeting = null;
      this.attUploadFile = null;
    },
    editSelectedMeeting: function(){
      /* The saveEdit method does a unix time conversion
         that appears to want milliseconds so convert here */
      this.tmpSelectedMeeting.name = this.selectedMeeting.name;
      this.tmpSelectedMeeting.start_ep = (this.selectedMeeting.start_ep * 1000);
      this.tmpSelectedMeeting.end_ep = (this.selectedMeeting.end_ep * 1000);
      if (this.selectedMeeting.iswebinar == "true") {
        this.$set(this.tmpSelectedMeeting, "iswebinar", "true");
        this.tmpSelectedMeeting.canreg = this.selectedMeeting.canreg;
      } else {
        this.$set(this.tmpSelectedMeeting, "iswebinar", "false");
        this.tmpSelectedMeeting.canreg = 0;
      }
      this.tmpSelectedMeeting.geoval = "";
      if (this.selectedMeeting.geo) {
        this.tmpSelectedMeeting.geoval = this.selectedMeeting.geo.ct;
      }
      this.tmpSelectedMeeting.url = this.selectedMeeting.url;
      this.tmpSelectedMeeting.descr = this.selectedMeeting.descr;
      if (this.selectedMeeting.ebs) {
        this.tmpSelectedMeeting.ebsval = 'true';
      } else {
        this.tmpSelectedMeeting.ebsval = 'false';
      }
      if (this.selectedMeeting.rem && this.selectedMeeting.rem.length > 0) {
        this.tmpSelectedMeeting.remval = (-1 * this.selectedMeeting.rem[0]);
        this.tmpSelectedMeeting.userem = 'true';
      } else {
        this.tmpSelectedMeeting.remval = 15;
        this.tmpSelectedMeeting.userem = 'false';
      }
      this.tmpSelectedMeeting.isgroup = this.selectedMeeting.isgroup;
      this.tmpSelectedMeeting.inactive = this.selectedMeeting.inactive;
      this.editMeetingView = true;
    },
    cancelEditSelectedMeeting: function(ev) {
      let vue = this;
      let sm = vue.selectedMeeting;
      ev.stopPropagation();
      if (!sm.name || !sm.start_ep || !sm.end_ep) {
         /* New meeting that was cancelled */
         vue.deleteMeeting(sm);
         vue.selectedMeeting = null;
         vue.editMeetingView = false;
         vue.isMeetingsListView = true;
         return;
      }
      vue.editMeetingView = false;
    },
    saveEditSelectedMeeting: function(ev) {   
      let vue = this;
      let sm = vue.selectedMeeting;
      let new_start_ep = vue.dfunx(vue.tmpSelectedMeeting.start_ep);
      let new_end_ep = vue.dfunx(vue.tmpSelectedMeeting.end_ep);
      let changed = false;
      ev.stopPropagation();
      if (!vue.tmpSelectedMeeting.name || !new_start_ep || !new_end_ep) {
         /* Failsafe; should not be possible to save incomplete entry */
         return;
      }
      if (vue.tmpSelectedMeeting.iswebinar != "true") {
        vue.tmpSelectedMeeting.canreg = 0;
      } else {
        vue.tmpSelectedMeeting.canreg = (0|vue.tmpSelectedMeeting.canreg);
        if (vue.tmpSelectedMeeting.canreg <= 0) {
            vue.$parent.show_notification('Webinars must have a non-zero attendee limit');
          return;
        }
      }
      console.log("SAVE ebs "+JSON.stringify(vue.tmpSelectedMeeting.ebsval));
      if (!vue.tmpSelectedMeeting.ebsval ||
           vue.tmpSelectedMeeting.ebsval == 'false') {
         vue.tmpSelectedMeeting.ebs = false;
         if (sm.ebs !== false) { changed = true; }
      } else {
         vue.tmpSelectedMeeting.ebs = true;
         if (!sm.ebs) { changed = true; }
      }
      console.log("SAVE rem "+JSON.stringify(vue.tmpSelectedMeeting.userem)+" "+JSON.stringify(vue.tmpSelectedMeeting.remval));
      if (vue.tmpSelectedMeeting.userem &&
          vue.tmpSelectedMeeting.userem != 'false') {
        let rem = [];
        if (vue.tmpSelectedMeeting.remval < 5) {
            vue.$parent.show_notification('Reminders must be at least 5 min');
            return;
        }
        if (vue.tmpSelectedMeeting.remval > 180) {
            vue.$parent.show_notification('Reminders must be no more than 3 hours (180 min)');
            return;
        }
        if (!sm.rem || sm.rem[0] != (-1 * vue.tmpSelectedMeeting.remval)) {
           changed = true;
           vue.tmpSelectedMeeting.rem = [ (-1 * vue.tmpSelectedMeeting.remval) ];
        }
      } else {
        if (sm.rem) {
          changed = true;
          vue.tmpSelectedMeeting.rem = [ ];
        }
      }
      if (sm.name != vue.tmpSelectedMeeting.name ||
          sm.start_ep != new_start_ep ||
          sm.end_ep != new_end_ep ||
          sm.canreg != vue.tmpSelectedMeeting.canreg ||
          sm.geo.ct != vue.tmpSelectedMeeting.geoval ||
          sm.url != vue.tmpSelectedMeeting.url ||
          sm.descr != vue.tmpSelectedMeeting.descr) {
          changed = true;
      }
      if (!changed) {
          /* Nothing changed */
          vue.editMeetingView = false;
          return;
      }
      if (new_start_ep >= new_end_ep) {
         /* Do not allow invalid times */
         return;
      }
      if (vue.tmpSelectedMeeting.name.length == 0 ||
          vue.tmpSelectedMeeting.name.length > 40) {
         /* Limit name length */
         return;
      }
      if (vue.tmpSelectedMeeting.descr && vue.tmpSelectedMeeting.descr.length > 150) {
         /* Limit descr length */
         return;
      }
      if (vue.tmpSelectedMeeting.url && vue.tmpSelectedMeeting.url.length > 200) {
         /* Limit URL length */
         return;
      }

      let up = {};
      vue.add_att_to_update(up, vue.tmpSelectedMeeting.name, new_start_ep,
                 new_end_ep, {em: "_anchor_", uid: sm.code,
                              canreg:vue.tmpSelectedMeeting.canreg,
                              geo:{ct:vue.tmpSelectedMeeting.geoval},
                              url:vue.tmpSelectedMeeting.url,
                              descr:vue.tmpSelectedMeeting.descr,
                              ebs:vue.tmpSelectedMeeting.ebs,
                              rem:vue.tmpSelectedMeeting.rem});
      if (sm.name != vue.tmpSelectedMeeting.name ||
          sm.start_ep != new_start_ep || sm.end_ep != new_end_ep) {
        sm.attendees.forEach(function(att){
           vue.add_att_to_update(up, vue.tmpSelectedMeeting.name, new_start_ep,
                                  new_end_ep, att);
        });
      }
      window.wss_send(window.vx, "set_meetings", up);

      /* If meeting START time changed, need to delete old records */
      if (sm.start_ep != new_start_ep) {      
         let rup = {};
         sm.attendees.forEach(function(att) {
            vue.rm_from_meeting(rup, sm.start_ep, {em: att.em, uid: att.uid});
         });
         vue.rm_from_meeting(rup, sm.start_ep, {em: "_anchor_", uid: 0});
         vue.rm_from_meeting_commit(rup);
      }
      
      vue.selectedMeeting.name = vue.tmpSelectedMeeting.name
      vue.selectedMeeting.start_ep = new_start_ep;
      vue.selectedMeeting.end_ep = new_end_ep;
      vue.selectedMeeting.iswebinar = vue.tmpSelectedMeeting.iswebinar;
      vue.selectedMeeting.canreg = vue.tmpSelectedMeeting.canreg;
      vue.selectedMeeting.url = vue.tmpSelectedMeeting.url;
      vue.selectedMeeting.geo.ct = vue.tmpSelectedMeeting.geoval;
      vue.selectedMeeting.descr = vue.tmpSelectedMeeting.descr;
      vue.selectedMeeting.ebs = vue.tmpSelectedMeeting.ebs;
      vue.selectedMeeting.rem = vue.tmpSelectedMeeting.rem;
      vue.editMeetingView = false;
    },
    openMeetingModal: function() {
      this.emailInviteText = `${this.ctrl.o_dname} is inviting you to their room @${window.vx_only_full_room_name(window.vx)}.`;
      this.$bvModal.show('bv-email-prompt');
    },
    closeMeetingModal: function() {
      this.emailMeetingInvites();
      this.$bvModal.hide('bv-email-prompt');
    },
    emailMeetingInvites: function() {
      let vue = this;
      let sm = vue.selectedMeeting;
      if (!sm) {
        return;
      }

      let c = {m:{}};
      c.m.name = sm.name;
      c.m.start_ep = sm.start_ep;
      c.m.end_ep = sm.end_ep;

      if (!sm.isgroup) {
        c.body = `<div style="padding:10px;"><div style="background-color:white;width:500px;text-align:left;font-size:13px;"><div style="margin:10px;">${vue.emailInviteText}</div><table cellspacing="0" cellpadding="0" width="100%"><tbody><tr><td valign="top" width="32"><div></div></td><td width="12">&nbsp;&nbsp;</td><td><div style="border:1px;width:350px;overflow:hidden"><span style="color:#52727F;font-size:15px;line-height:18px;font-weight:bold;"><a href="__RMURL__"> Click to Attend: ${sm.name} </a></span><span style="padding:0 0 0 5px"></span><p style="font-size:12px;margin:0;padding-top:8px;color:#666666;"><strong>Please see the calendar for meeting details</strong></p><p style="font-size:12px;margin:0;color:#666666;">Host: ${vue.ctrl.o_dname}</p></div></td></tr></tbody></table></div></div>`;
      } else {
        c.body = `<div style="padding:10px;"><div style="background-color:white;width:500px;text-align:left;font-size:13px;"><div style="margin:10px;">${vue.emailInviteText}</div><table cellspacing="0" cellpadding="0" width="100%"><tbody><tr><td valign="top" width="32"><div></div></td><td width="12">&nbsp;&nbsp;</td><td><div style="border:1px;width:350px;overflow:hidden"><span style="color:#52727F;font-size:15px;line-height:18px;font-weight:bold;"><a href="__RMURL__"> Click to Attend: ${sm.name} </a></span><span style="padding:0 0 0 5px"></span><p style="font-size:12px;margin:0;color:#666666;">Host: ${vue.ctrl.o_dname}</p></div></td></tr></tbody></table></div></div>`;
      }
      window.wss_send_cb(window.vx, "email_meetings", c, function(msg) {
         if (!msg.data || !msg.data.error) { return; }
         if (msg.data.bad) {
            vue.$parent.show_notification("Unable to send emails. You have exceeded your limit of bounces and/or complaints.");
         } else {
            vue.$parent.show_notification("Unable to send emails.");
         }
      });
    },
    canMirror: function() {
      let vue = this;
      if (window.vx.mirror && window.vx.mirror.is_streaming()) { return 2; }
      if (!vue.$parent.currentUser.can_mirror) { return 0; }
      if (!window.vx.vsdomain) { console.log("B"); return 1; }
      if (!window.getLocal("vx_vstmpl")) { return 1; }
      return 2;
    },
    formatTarget: function(s,d,n) {
      if (!s) { return d; }
      if (s.length > n) {
        return s.substring(0,n/2) + "..." + s.substring(s.length-n/2);
      }
      return s;
    },
    formatlp: function(n) {
      let h,m,s;
      if (!n || n < 0) { return "-"; }
      s = Math.trunc(n);
      m = Math.trunc(n/60);
      s -= (60*m);
      h = Math.trunc(m/60);
      m -= (60*h);
      if (s < 10) s = "0"+s;
      if (m < 10) m = "0"+m;
      if (h == 0) {
        return ""+m+":"+s;
      }
      return ""+h+":"+m+":"+s;
    },
    sec2human: function(s) {
      if (!s && s !== 0) { return "-"; }
      if (s < 10) {
         return "recent";
      } else if (s < 90) {
         return Math.trunc(s)+" sec";
      } else if (s < 3600) {
         return Math.trunc(s/60)+" min";
      } else if (s < 48*3600) {
         return Math.trunc(s/3600)+" hr";
      }
      return Math.trunc(s/(24*3600))+" days";
    },
    validateEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateEmails: function(emails) {
      var listEmails = emails.split(",");
      for (var i = 0; i < listEmails.length; i++) {
        if (!this.validateEmail(listEmails[i])) {
          return false;
        }
      }
      return true;
    },
    confirmModeratorDelete: function(mod) {
      let vue = this;
      //getting over scoped modal issue
      vue.$bvModal
        .msgBoxConfirm("Are you sure you want to remove "
                       +("moderator?"))
        .then(value => {
          if (value) {
            /* Remove moderator */
            let c = { set_ctrl: {} };
            c.set_ctrl.rm_mod = mod.uid;
            window.wss_send(window.vx, "set_room_ctrl", c);
          }
        });
    },
    onSubmit: function() {
      let pl = {
        cat_nm: this.room.name,
        auth: this.room.auth,
        expire: this.dfunx(this.keys.expire),
        valid_at: this.dfunx(this.keys.valid_at)
      };
      let numKeys = 0;
      let listEmails = [];

      if (!this.keys.private_allow_all) {
        if (!this.validateEmails(this.keys.private_allow_specific)) {
          this.$bvModal.msgBoxOk("Please verify all emails are correct");
          return false;
        }
        listEmails = this.keys.private_allow_specific.trim().split(",");
        numKeys = listEmails.length;
      }

      if (numKeys > 0) {
        pl.auth += ",email";
        for (var i = 0; i < numKeys; i++) {
          pl.email = listEmails[i];
          (function(pl, email, that) {
            vx_api
              .generateKeys(pl)
              .then(res => {
                res.email = email;
                that.generated_keys.push(res);
              })
              .catch(e => {
                // eslint-disable-next-line
                console.log(e);
              });
          })(pl, listEmails[i], this);
        }
      } else {
        vx_api
          .generateKeys(pl)
          .then(res => {
            this.generated_keys.push(res);
          })
          .catch(e => {
            // eslint-disable-next-line
            console.log(e);
          });
      }
    },
    onSubmitSetUserName: function() {
      vx_api
        .setUserName(window.vx, this.setUserName)
        .then(res => {
          if (res.status == 400) {
            this.$parent.show_notification("User cannot change their nickname.");
            return;
          } else {
            this.$parent.show_notification("Username changed.");
            return;
          }
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log(e);
        });
    },
    onSubmitAddKey: function() {
      if (this.addKeyInput.indexOf("cat_nm=") < 0) {
        this.$parent.show_notification("No room specified for key / malformed.");
        return;
      }
      vx_api
        .addKey(this.addKeyInput)
        .then(res => {
          if (res.status != 200) {
            if (res.status == 401) {
              this.$parent.show_notification("Wrong room or key not currently valid.");
            } else if (res.message) {
              this.$parent.show_notification(""+res.message);
            } else {
              this.$parent.show_notification("Invalid Key");
            }
          } else {
            this.$parent.show_notification("Key added.",{variant:"success"});
          }
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log(e);
        });
    },
    listAllKeys: function() {
      vx_api
        .listKeys()
        .then(res => {
          if (res.keys) {
            if (res.keys.length > 0) {
              res.keys.forEach(function(k) {
                let dt = new Date(1000 * k.exp);
                if (k.nm) {
                  k.nm = k.nm.replace("qna_", "");
                  k.dt = dt;
                } else if (k.id) {
                  k.dt = dt;
                }
                this.added_room_keys.push(k);
              });
            } else {
              this.$parent.show_notification("You have no keys.");
            }
          } else {
            this.$parent.show_notification("Unable to list keys.");
          }
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log(e);
        });
    },
    del_from_ephrooms: function(er) {
      let vue = this;
      vue.spawn.rooms =
        vue.spawn.rooms.filter(function(r) {
          console.log("del?"+r.room+" "+er);
          if (r.room == er) { return false; }
          return true;
        });
    },
    add_to_ephrooms: function(er, exp) {
      let vue = this;
      vue.spawn.rooms.forEach(function(r) {
        if (r.room == er) {
          er = null;
          r.expires = 0|exp;
        }
      });
      if (er) {
        let parts = er.split(".");
        let room = parts[0];
        let num = parts[1];
        let cur_room = window.vx_only_full_room_name(window.vx);
        let rec = {room: er, dname:(room+" #"+num)};
        if (cur_room == er) { rec.room = null; rec._rowVariant = "success"; }
        rec.expires = 0|exp;
        vue.spawn.rooms.push(rec);
      }
      vue.spawn.expires = 100000;
      vue.spawn.rooms.forEach(function(r) {
        let expires = Math.trunc((r.expires - (Date.now()/1000))/60);
        if (expires < vue.spawn.expires) {
          vue.spawn.expires = expires;
        }
      });
    },
    do_spawn_ephroom: function() {
      let vue = this;
      if (vue.spawn.cnt == "" || vue.spawn.cnt === undefined) {
        return;
      }
      vue.spawn.cnt = 0|vue.spawn.cnt;
      if (vue.spawn.cnt <= vue.ctrl.eph_limit) {
        vue.ctrl.eph = vue.spawn.cnt;
        window.wss_send(window.vx, "set_room_ctrl", vue.wss_build_ctrl());
        vue.spawn.cnt = "";
      } else {
        vue.$parent.show_notification("Break-out room count exceeds limit of "+vue.ctrl.eph_limit);
      }
    },
    get_ephrooms: function() {
      let vue = this;
    },
    do_deleteall_ephrooms: function() {
      let vue = this;
      vue.ctrl.eph = 0;
      window.wss_send(window.vx, "set_room_ctrl", vue.wss_build_ctrl());
      vue.spawn.cnt = "";
    },
    wss_list_ephroom: function(msg) {
      let vue = this;
      if (!wss_ishash(msg)) { return; }
      if (!msg.data.er) { return; }
      let main_room = false;
      vue.spawn.rooms = [];
      msg.data.er.forEach(function(r) {
        vue.add_to_ephrooms(r.room, r.expires);
      });
    },
    goto_ephroom: function(x) {
      let vue = this;
      if (!x || !x.path[0]) { return; }
      let room = x.path[0].getAttribute("room");
      if (!room) { return; }
      let room_only = room.split("/")[1];
      
      /* Must authorize BEFORE going to room */
      window.wss_send(window.vx, "auth_ephroom", {ephroom: room_only});
      setTimeout(function() {
        //vue.$router.push({name: 'room', params: {uid: room} });      
        vue.$router.push("/room/"+room);
      }, 250);
    },
    cat_format: function(cat) {
      let re = /[\s-_]+/;
      if (cat.length <= 2) { return cat.toUpperCase(); }
      return cat.toLowerCase()
                .split(re)
                .map(function(word) {
                   if (!word) { return ""; }
                   return word[0].toUpperCase() + word.substr(1);
                })
                .join(' ');
    },
    ctrl_catValidator: function(cat) {
      let vue = this;
      if (this.ctrl.cat.length >= 10) {
        return false;
      }
      window.setTimeout(function() {
        let cats = [];
        let changed = false;
        vue.ctrl.cat.forEach(function(c) {
          let nc = vue.cat_format(c);
          cats.push(nc);
          if (nc != c) {
             changed = true;
          }
        });
        console.log(JSON.stringify(cats),changed);
        if (changed) {
          vue.ctrl.cat = cats;
        }
      },200);
      return true;
    },
    gen_embedq_json: function() {
      let vue = this;
      let url = vx.rq_endpoint+"/room/"+vx.room.name+"/live?acc="+vx.subd;
      let embed =
        ('let xhr = new XMLHttpRequest();\n'+
         'xhr.open("GET", "'+url+'");\n'+
         'xhr.onreadystatechange = function() {\n'+
         '  if (xhr.readyState === 4) {\n'+
         '    /* your_function(xhr.response); */\n'+
         '    /* e.g. { live:false } */\n'+
         '  }\n'+
         '}\n'+
         'xhr.send(null);\n'+
         '\n');
      $("#embed_result").html(embed);
    },
    gen_embedq_live: function() {
      let vue = this;
      let url = vx.rq_endpoint+"/room/"+vx.room.name+"/live?acc="+vx.subd;
      if (!vue.embed.live_url && !vue.embed.off_url) { return; }
      if (vue.embed.live_url) {
        url += "&ti="+encodeURIComponent(vue.embed.live_url);
      }
      if (vue.embed.off_url) {
        url += "&fi="+encodeURIComponent(vue.embed.off_url);
      }      
      let embed = ('Shows live image if live, offline image if not\n'+
                   '  &ltimg src="'+url+'"/&gt\n'+
                   '\n');
      $("#embed_result").html(embed);
    },
    ctrlState: function(mode) {
      let vue = this;
      if (mode == 'off') {
         if (vue.slate.mode == 'off') { return; }
         vue.slate.mode = 'off';
         vue.change_room_ctrl();
      } else if (mode == 'on') {
         if (vue.slate.mode == 'on') { return; }
         if (!vue.slate.url) {
           vue.$parent.show_notification("First select and upload an image to use");
           return;
         }
         vue.slate.mode = 'on';
         vue.change_room_ctrl();
      }
    },
    showinfo: function(what) {    
      //console.log("info clicked:"+what);
      let x = $(".bhelp-"+what);
      if (x) {
        let showing = true;
        x.each(function(idx) {
          if ($(this).attr('data-balloon-visible') != "") {
            showing = false;
          }
        });
        x.each(function(idx) {
          if (showing) {
            $(this).attr('data-balloon-visible',null);
          } else {
            $(this).attr('data-balloon-visible',"");
          }
        });
      }
    },
    openHall: function() {
      let vue = this;
      let route = vue.$router.resolve({ name: 'hall'});
      let url = "https://" + window.location.host + window.location.pathname + "?rt=no" + route.href;
      window.vx.open_native_url(url);
    },
    openTruck: function() {
      let vue = this;
      let route = vue.$router.resolve({ name: 'truck'});
      let url = "https://" + window.location.host + window.location.pathname + "?rt=no" + route.href;
      window.vx.open_native_url(url);
    },
    openQuiz: function() {
      let vue = this;
      let route = vue.$router.resolve({ name: 'quiz'});
      let url = "https://" + window.location.host + window.location.pathname + "?rt=no" + route.href;
      window.vx.open_native_url(url);
    },
    wss_poll: function(msg) {
      let vue = this;
      //console.log(msg);
      if (!msg.data) { return; }
      if (msg.data.list) {
         vue.pollQuests = [];
         msg.data.qs.forEach(function(q) {
           let total = 0;
           if (q.cnt) {
             q.cnt.forEach(function(c) {
                total += c;
             });
           }
           vue.pollQuests.push({
             id: q.id,
             q: q.q,
             a: q.a,
             active: q.active || false,
             total: total,
             cnt: q.cnt || [],
             _rowVariant: q.active?"success":null,
           });
         });
      } else if (msg.data.update) {
        //console.log(JSON.stringify(vue.pollQuests));
        vue.pollQuests.forEach(function(q) {
          if (!q.id && q.q == msg.data.q.q) {
            q.id = msg.data.q.id;
          }
        });
        //console.log(JSON.stringify(vue.pollQuests));
      }
    },
    refreshPollList: function() {
      window.wss_send(window.vx, "poll", {cmd:"list"});
    },
    gotoPollListView: function() {
      let vue = this;
      vue.isPollListView = true;
    },
    canSave: function() {
      let vue = this;
      if (!vue.tmpSelectedQuest.q ||
          !vue.tmpSelectedQuest.a[0] ||
          !vue.tmpSelectedQuest.a[1]) {
         return [false,"Must have question and at least two answers"];
      }
      if (vue.selectedQuest) {
        let changed = false;
        if (vue.selectedQuest.q != vue.tmpSelectedQuest.q) {
          changed = true;
        }
        //console.log(JSON.stringify(vue.selectedQuest));
        //console.log(JSON.stringify(vue.tmpSelectedQuest));
        for (let i=0; i<5; i++) {            
            if (vue.selectedQuest.a[i] != vue.tmpSelectedQuest.a[i]) {
              changed = true;
            }
        }
        if (!changed) {
          return [false,"No changes have been made"];
        }
      }
      return [true,"ok"];
    },
    chat_delete_part: function(depth,cb) {
      let vue = this;
      window.wss_send_cb(window.vx, "delete_chat", {
         opt:{ all: true },
      }, function(msg) {
         if (!msg || !msg.data || !msg.data.ok) {
           let err = (msg && msg.error)? msg.error : "Timed out";
           vue.chat_del_msg = `Deleted ${vue.chat_del_cnt}. Error ${err}.`;
           cb();
           return;
         }
         if (msg.data.cnt) {
           console.log(vue.chat_del_cnt, msg.data.cnt);
           vue.chat_del_cnt += msg.data.cnt;
         }
         if (!msg.data.more) {
           vue.chat_del_msg = `Deleted ${vue.chat_del_cnt}. Done.`;
           cb();
           return;
         } else {
           vue.chat_del_msg = `Deleted ${vue.chat_del_cnt} ...`;
         }
         vue.chat_delete_part(depth+1,cb);
      });
    },
    chat_delete_all: function() {
      let vue = this;
      vue.chat_del_cnt = 0;
      vue.chat_del_msg = `Deleting ...`;
      vue.chat_delete_part(0, function(err) {
        vue.chat_btn_clear++;
      });
    },
    newPollQuest: function() {
      let vue = this;
      vue.isPollListView = false;
      vue.selectedQuest = null;
      vue.tmpSelectedQuest.name = "";
      vue.tmpSelectedQuest.q = "";
      vue.tmpSelectedQuest.a = [];
      vue.tmpSelectedQuest.cnt = [];
      vue.tmpSelectedQuest.active = false;
    },
    openPollQuest: function(q) {
      let vue = this;
      vue.isPollListView = false;
      //console.log(JSON.stringify(q));
      vue.selectedQuest = q;
      vue.tmpSelectedQuest.q = q.q;
      vue.pollHasData = false;
      for (let i=0; i<5; i++) {
        vue.tmpSelectedQuest.a[i] = q.a[i];
        vue.tmpSelectedQuest.cnt[i] = q.cnt[i];
        if (q.cnt[i] > 0) {
          vue.pollHasData = true;
        }
      }
      vue.tmpSelectedQuest.active = q.active || false;
      //console.log("open",JSON.stringify(vue.tmpSelectedQuest));
   },
   showResult: function(kind) {
      let vue = this;
      let opt = {
        type: 'pie',
        data: { labels: ["A","B","C"],
                datasets: [{
                  backgroundColor:["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
                  data:[1,2,3]
                }],
              },
        options: {
          events: false,
          animation: {
            duration: 500,
            easing: "easeOutQuart",
            onComplete: function () {
              var ctx = this.chart.ctx;
              ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontFamily, 'normal', Chart.defaults.global.defaultFontFamily);
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
        
              this.data.datasets.forEach(function (dataset) {
        
                for (var i = 0; i < dataset.data.length; i++) {
                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                      total = dataset._meta[Object.keys(dataset._meta)[0]].total,
                      mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius)/2,
                      start_angle = model.startAngle,
                      end_angle = model.endAngle,
                      mid_angle = start_angle + (end_angle - start_angle)/2;
        
                  var x = mid_radius * Math.cos(mid_angle);
                  var y = mid_radius * Math.sin(mid_angle);
        
                  ctx.fillStyle = '#fff';
                  if (i == 3){ // Darker text color for lighter background
                    ctx.fillStyle = '#444';
                  }
                  var percent = String(Math.round(dataset.data[i]/total*100)) + "%";      
                  //Don't Display If Legend is hide or value is 0
                  if(dataset.data[i] != 0 /*&& dataset._meta[0].data[i].hidden != true*/) {
                    ctx.fillText(dataset.data[i], model.x + x, model.y + y);
                    // Display percent in another line, line break doesn't work for fillText
                    ctx.fillText(percent, model.x + x, model.y + y + 15);
                  }
                }
              });
            }
          } //animation
        } //options
      };
      opt.data.labels = [];
      opt.data.datasets[0].data = [];
      for (let i=0; i<5; i++) {
        if (!vue.tmpSelectedQuest.a[i]) { break; }
        opt.data.labels.push(vue.tmpSelectedQuest.a[i]);
        opt.data.datasets[0].data.push(vue.tmpSelectedQuest.cnt[i]);
      }
      //console.log(JSON.stringify(opt));
      vue.pollchart = new Chart($("#pollchart")[0].getContext('2d'),opt);
      vue.pollchart.update();
    },
    savePollQuest: function() {
      let vue = this;
      let [ok,msg] = vue.canSave();
      if (!ok) {
        vue.$parent.show_notification(""+msg);
        return;
      }
      if (vue.selectedQuest) {
        /* Edit */
        vue.selectedQuest.q = vue.tmpSelectedQuest.q;
        for (let i=0; i<5; i++) {
           vue.selectedQuest.a[i] = vue.tmpSelectedQuest.a[i];
        }
        vue.selectedQuest.active = vue.tmpSelectedQuest.active;
        window.wss_send(window.vx, "poll", {
          cmd:"update",
          q: vue.selectedQuest,
        });
      } else {
        /* NEW */
        let x = {a:[],cnt:[]};
        x.q = vue.tmpSelectedQuest.q;
        for (let i=0; i<5; i++) {
          x.a[i] = vue.tmpSelectedQuest.a[i];
        }
        x.active = vue.tmpSelectedQuest.active;
        vue.pollQuests.push(x);
        window.wss_send(window.vx, "poll", {
          cmd:"update",
          q: x,
        });
      }
      vue.isPollListView = true;
    },
    pollReset: function() {
        let vue = this;
        vue.selectedQuest.cnt = [0,0,0,0,0];
        vue.tmpSelectedQuest.cnt = [0,0,0,0,0];
        vue.selectedQuest.total = 0;
        vue.pollHasData = false;
        window.wss_send(window.vx, "poll", {
          cmd:"reset",
          q: {id:vue.selectedQuest.id},
        });
    },
    confirmDeleteQuest: function() {
      let vue = this;
      if (vue.selectedQuest) {
        vue.selectedQuest.del = true;   
        vue.pollQuests = vue.pollQuests.filter(function(q) {
          if (q.del) { return false; }
          return true;
        });
        window.wss_send(window.vx, "poll", {
          cmd:"delete",
          q: vue.selectedQuest,
        });
      }
      vue.isPollListView = true;
    },
    enableQuest: function(q,val) {
      let vue = this;
      q.active = val;
      if (q.active) {
        q._rowVariant = "success";
      } else {
        delete q._rowVariant;
      }
      window.wss_send(window.vx, "poll", {
        cmd:"update",
        q: q,
      });
    },
    openResults: function(q) {
    },
  },
  computed: {
    room: sync("room"),
    cat_state: function() {
      let vue = this;      
      for (let i=0; i<vue.req_cats.length; i++) {
        if (vue.ctrl.cat.includes(vue.cat_format(vue.req_cats[i]))) {
          return true;
        }
      }
      return false;
    },
    ctrl_can_access_msg: function() {
      switch (this.ctrl.can_view) {
        case "open":
          if (this.ctrl.pub == 'any') {
            return "Anyone, including anonymous guests, can access";
          } else {
            return "Any authenticated user can access";
          }
        case "closed":
          return "Users must be invited";
        case "locked":
          return "Restrict to the people already present";
      }
      return "Unknown";
    },
    /*
    ctrl_can_view_msg: function() {
      switch (this.ctrl.can_view) {
        case "open":
          return "Anyone can watch";
        case "closed":
          return "Viewers must be invited";
        case "locked":
          return "Restrict to the people already watching";
      }
      return "Unknown";
    },
    ctrl_can_join_msg: function() {
      switch (this.ctrl.can_join) {
        case "open":
          return "Anyone can participate";
        case "closed":
          return "Participants must be invited";
        case "locked":
          return "Restrict to the people already participating";
      }
      return "Unknown";
    },
    */
    user: function() {
      return this.$user.get();
    },
    hasCountry: function() {
      if (!this.$parent.currentUser.loc || !this.$parent.currentUser.loc.ct) {
        return false;
      }
      return true;
    },
    prettyLocation: function() {
      let loc = this.$parent.currentUser.loc;      
      if (!loc || !loc.ct) { return "No location set."; }
      let txt = " "+loc.ct;
      if (loc.rg) { txt += ", "+loc.rg; }
      if (loc.cy) { txt += ", "+loc.cy; }
      return txt;
    }
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx,"settings");
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}

.info {
  position:absolute;
  right:.6rem;
  top:.7rem;
  padding: .25em .6em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  border-radiue: .25rem;
  margin:0;
  border:0;
}

.highlight {
  background-color: #303090;
}

.highlight:hover {
  background-color: #4c559d;
}

.btn_mirror {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
}

.uarfilt {
  padding: 0 0.3rem;
}

.tab-btn {
  padding: 0 0.3rem;
}

.alert_section {
 position: relative;
 border: solid 1px #a0a0a0;
 padding:0.2rem;
 border-radius:5px;
 margin-top:0.4rem;
 margin-bottom:0.4rem;
}

.alert_descr {
 font-size:0.8rem;
 padding-left:1rem;
 color:#0070d0;
}

.alert_error {
 font-size:0.8rem;
 font-weight: bold;
 margin-bottom: 0.2rem;
 padding-left:1rem;
 color:#e02020;
}

.alert_heading, .alert_headingN {
 font-size:0.7rem;
 font-weight: bold;
 text-transform:uppercase;
 background-color: rgba(0,0,0,0.1);
 width:fit-content;
 border-radius: 0.2rem;
 padding: 0 0.2rem;
}

.alert_headingN {
 margin-top: 0.7rem;
}

.brand_section {
  font-weight: bold;
  text-decoration: underline;
}

.brand_usage {
  font-size: 0.8rem;
}

.vm_btn_mat {
  font-family: 'Material Icons';
  font-size: 1.5rem;
  line-height: 1.5rem;
  height: 1.5rem;
  padding:0 0.3rem;
  margin-bottom:0;
  color: black;
  background-color: transparent;
  border:none;
}

.vm_btn_mat_danger {
  color: red;
  float: right;
}

.clipcopy {
  width: fit-content;
  border-radius: 5px;
}

.clipcopy[copied="true"] {
  background:rgba(60,200,60,0.5);
}

.vm_new_tag {
  font-size: 1.2rem;
  position: absolute;
  top:0;
  left: -1.5rem;
  color: green;
}

.input_label_cap {
  text-transform: uppercase;
  font-size: 0.8rem;
  line-height: 1.5rem;
}

.guest_checkbox {
  text-transform: uppercase;
  font-size: 0.65rem;
  font-weight: bold;
  line-height:1.5rem;
}

.stinput-pos {
  background-color:blue;
}
</style>
